var _style, _defs, _defs2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _defs3, _defs4, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _defs5, _defs6, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _defs7, _defs8, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _defs9, _defs0, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _defs1, _defs10, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _defs11, _defs12, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _defs13, _defs14, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _defs15, _defs16, _g182, _g183, _g184, _g185, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _defs17, _defs18, _g205, _g206, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _defs19, _g228, _g229, _g230, _g231, _defs20, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239, _g240, _g241, _g242, _g243, _defs21, _defs22, _g244, _g245, _g246, _g247, _g248, _g249, _g250, _g251, _g252, _g253, _g254, _g255, _g256, _g257, _g258, _g259, _g260, _g261, _g262, _g263, _g264, _g265, _defs23, _defs24, _g266, _g267, _g268, _g269, _g270, _g271, _g272, _g273, _g274, _g275, _g276, _g277, _g278, _g279, _g280, _g281, _g282, _g283, _g284, _g285, _g286, _g287, _g288, _g289, _defs25, _defs26, _g290, _g291, _g292, _g293, _g294, _g295, _g296, _g297, _g298, _g299, _g300, _g301, _g302, _g303, _g304, _g305, _g306, _g307, _g308, _g309, _g310, _g311, _defs27, _defs28, _g312, _g313, _g314, _g315, _g316, _g317, _g318, _g319, _g320, _g321, _g322, _g323, _g324, _g325, _g326, _g327, _g328, _g329, _g330, _g331, _g332, _g333, _defs29, _defs30, _g334, _g335, _g336, _g337, _g338, _g339, _g340, _g341, _g342, _g343, _g344, _g345, _g346, _g347, _g348, _g349, _g350, _g351, _g352, _g353, _g354, _g355, _g356, _path, _path2, _path3, _path4, _polygon, _polygon2, _path5, _polygon3, _path6, _polygon4, _path7, _path8, _polygon5, _polygon6, _path9, _path0, _polygon7, _path1, _rect, _path10, _path11, _path12, _path13, _path14, _g357, _g358, _g359, _g360, _g361, _g362, _g363, _g364, _g365, _g366, _g367, _g368, _g369, _g370, _g371;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDataTruckSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#XMLID_00000100343355658963153870000011465353191395163013_);}\n\t.st1{clip-path:url(#XMLID_00000039825456462748053830000009294764838414069384_);}\n\t.st2{fill:#150035;}\n\t.st3{fill:#39A1FF;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{clip-path:url(#XMLID_00000178911521366714400810000013540915927190292920_);}\n\t.st6{clip-path:url(#XMLID_00000129186570201393338680000017488940531810832787_);}\n\t.st7{clip-path:url(#XMLID_00000005238288278968061970000004438878837020551048_);}\n\t.st8{clip-path:url(#XMLID_00000011727445265932597320000018221110557167722161_);}\n\t.st9{clip-path:url(#XMLID_00000037673243340751053910000005110074733614767238_);}\n\t.st10{clip-path:url(#XMLID_00000006704261573558055890000017831995881432586428_);}\n\t.st11{clip-path:url(#XMLID_00000144319331405879223620000004216071992293468086_);}\n\t.st12{clip-path:url(#XMLID_00000055678165768066094270000000840435608321111735_);}\n\t.st13{clip-path:url(#XMLID_00000097470773617880120150000012542357378732801459_);}\n\t.st14{clip-path:url(#XMLID_00000062891681077281837240000000084000577968365737_);}\n\t.st15{clip-path:url(#XMLID_00000127729959825395615750000014395525905685770415_);}\n\t.st16{clip-path:url(#XMLID_00000052792419392490310320000012983647195632460707_);}\n\t.st17{clip-path:url(#XMLID_00000033356050778774541480000017382766838010012288_);}\n\t.st18{clip-path:url(#XMLID_00000029751925193233815940000013006344006855210405_);}\n\t.st19{clip-path:url(#XMLID_00000023985337918209362060000001765794876097494404_);}\n\t.st20{clip-path:url(#XMLID_00000176016554116814281470000010755671513483777179_);}\n\t.st21{clip-path:url(#XMLID_00000134936341893179543270000010654178631304715404_);}\n\t.st22{clip-path:url(#XMLID_00000039117997320279204270000006102297838696137134_);}\n\t.st23{clip-path:url(#XMLID_00000045580606859610920010000011763931288743991452_);}\n\t.st24{clip-path:url(#XMLID_00000139251983513762999770000004804134307752167043_);}\n\t.st25{clip-path:url(#XMLID_00000129182442239587315950000007928216012804504216_);}\n\t.st26{clip-path:url(#XMLID_00000054958908262579632580000012857855877842130573_);}\n\t.st27{clip-path:url(#XMLID_00000074401576629078039520000003240515058783093426_);}\n\t.st28{clip-path:url(#XMLID_00000167368937817801262140000000192090744595257523_);}\n\t.st29{clip-path:url(#XMLID_00000116953164673075880530000000006314315459195789_);}\n\t.st30{clip-path:url(#XMLID_00000034774259631500045010000017482559709291040701_);}\n\t.st31{clip-path:url(#XMLID_00000006676291256018647000000001988353056453159311_);}\n\t.st32{clip-path:url(#XMLID_00000123399257079368885320000002900967527962678412_);}\n\t.st33{clip-path:url(#XMLID_00000127757986167346318190000009161893442764136618_);}\n\t.st34{clip-path:url(#XMLID_00000128457544826257176740000015942956528176388235_);}\n\t.st35{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1789_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1861_"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2907_",
    d: "M8.8,60.2l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6L12,58.5 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C8.6,59.7,8.6,60.1,8.8,60.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000057850929032741411940000000340373906042806194_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2907_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1863_",
    style: {
      clipPath: "url(#XMLID_00000057850929032741411940000000340373906042806194_)"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2908_",
    d: "M12.4,62.5l-5.8-3.4c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9l-6.6,3.8C13.2,62.8,12.7,62.7,12.4,62.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000011746112177608249380000015486236049386621824_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2908_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1865_",
    style: {
      clipPath: "url(#XMLID_00000011746112177608249380000015486236049386621824_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1905_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2761_",
    x: 6.8,
    y: 57.5,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.1669 13.6812)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1904_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2760_",
    x: 7.2,
    y: 57.7,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.2213 13.9158)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1903_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2759_",
    x: 7.5,
    y: 57.9,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.2881 14.1333)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1902_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2758_",
    x: 8,
    y: 58.1,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.3391 14.3713)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1901_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2757_",
    x: 8.3,
    y: 58.4,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.4131 14.5761)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1900_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2756_",
    x: 8.7,
    y: 58.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.4674 14.8107)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1899_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2755_",
    x: 9.1,
    y: 58.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.5342 15.0281)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1898_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2754_",
    x: 9.5,
    y: 59,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.5852 15.2662)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1897_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2753_",
    x: 9.9,
    y: 59.3,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.6519 15.4836)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1896_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2752_",
    x: 10.3,
    y: 59.5,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.7051 15.7215)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1895_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2751_",
    x: 10.7,
    y: 59.7,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.7718 15.939)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1894_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2750_",
    x: 11.1,
    y: 59.9,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.8229 16.177)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1893_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2749_",
    x: 11.4,
    y: 60.2,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.8968 16.3819)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1892_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2748_",
    x: 11.8,
    y: 60.4,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.9512 16.6164)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1891_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2747_",
    x: 12.2,
    y: 60.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -28.0179 16.8339)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1872_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2746_",
    x: 12.6,
    y: 60.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -28.069 17.0719)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1871_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2745_",
    x: 13,
    y: 61.1,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -28.1357 17.2893)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1870_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2744_",
    x: 5.2,
    y: 56.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -26.9373 12.7645)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1869_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2743_",
    x: 5.6,
    y: 56.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -26.9916 12.9991)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1868_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2742_",
    x: 6,
    y: 57,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.0584 13.2166)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1867_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2741_",
    x: 6.4,
    y: 57.2,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.1094 13.4545)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1866_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2740_",
    x: 6.7,
    y: 57.5,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -27.1761 13.6721)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1850_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1852_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1854_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1859_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2735_",
    className: "st3",
    d: "M13.2,57.4l-4.2,0c0,0-0.1,0-0.1,0.1l0,1.1l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L13.2,57.4C13.3,57.5,13.2,57.4,13.2,57.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2736_",
    className: "st2",
    d: "M11.1,60.2c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2v-1.1 c0-0.1,0.1-0.2,0.2-0.2l4.2,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2v1.4h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8 C11.5,60.2,11.3,60.2,11.1,60.2z M9,57.6l0,1.3c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0L13,59 c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0v-1.1L9,57.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1857_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2906_",
    className: "st2",
    d: "M13.2,57.4l-1.9,0v2.7c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0 L13.2,57.4C13.3,57.5,13.2,57.4,13.2,57.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1856_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2706_",
    className: "st4",
    d: "M13.1,57.7l-1.4,0.8c-0.3,0.2-0.8,0.2-1.2,0l-1.3-0.7c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C13.3,57.3,13.4,57.6,13.1,57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2732_",
    className: "st2",
    d: "M11.1,58.8c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4l-1.4,0.8 C11.5,58.8,11.3,58.8,11.1,58.8z M11,56.3c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3l-1.3-0.7C11.5,56.3,11.2,56.3,11,56.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1855_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2731_",
    x: 12.6,
    y: 58.2,
    className: "st3",
    width: 0.3,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1853_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2730_",
    x: 10.5,
    y: 59.3,
    className: "st2",
    width: 0.3,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1851_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2729_",
    x: 10.9,
    y: 56,
    transform: "matrix(0.5035 -0.864 0.864 0.5035 -44.1271 38.0592)",
    className: "st2",
    width: 0.3,
    height: 2.9
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1906_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1916_"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2904_",
    d: "M89.8,53.7l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6L93,52 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C89.5,53.2,89.5,53.5,89.8,53.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000088822554448470344020000006545701703100781194_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2904_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1918_",
    style: {
      clipPath: "url(#XMLID_00000088822554448470344020000006545701703100781194_)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2905_",
    d: "M93.3,56l-5.8-3.4c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9L94.9,56C94.1,56.3,93.6,56.2,93.3,56z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000043426814154071188440000006138040991626948745_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2905_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1920_",
    style: {
      clipPath: "url(#XMLID_00000043426814154071188440000006138040991626948745_)"
    }
  }, _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1942_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2728_",
    x: 87.7,
    y: 50.9,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.0638 53.2775)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1941_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2727_",
    x: 88.1,
    y: 51.2,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.1183 53.5121)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1940_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2726_",
    x: 88.5,
    y: 51.4,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.185 53.7296)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1939_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2725_",
    x: 88.9,
    y: 51.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.236 53.9676)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1938_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2724_",
    x: 89.2,
    y: 51.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.31 54.1724)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1937_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2723_",
    x: 89.6,
    y: 52.1,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.3643 54.407)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1936_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2722_",
    x: 90,
    y: 52.3,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.4311 54.6245)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1935_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2721_",
    x: 90.4,
    y: 52.5,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.4821 54.8624)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1934_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2720_",
    x: 90.8,
    y: 52.7,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.5488 55.0799)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1933_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2719_",
    x: 91.2,
    y: 53,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.602 55.3178)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1932_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2718_",
    x: 91.6,
    y: 53.2,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.6687 55.5353)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1931_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2717_",
    x: 92,
    y: 53.4,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.7198 55.7733)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1930_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2716_",
    x: 92.4,
    y: 53.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.7937 55.9781)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1929_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2715_",
    x: 92.8,
    y: 53.9,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.8481 56.2126)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1928_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2714_",
    x: 93.1,
    y: 54.1,
    transform: "matrix(0.8661 -0.4998 0.4998 0.8661 -13.9155 56.3972)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1927_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2713_",
    x: 93.6,
    y: 54.3,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -13.9672 56.6019)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1926_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2712_",
    x: 93.9,
    y: 54.5,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -14.0339 56.8191)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1925_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2711_",
    x: 86.1,
    y: 50.1,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -12.8342 52.3608)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1924_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2710_",
    x: 86.5,
    y: 50.3,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -12.8885 52.5954)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1923_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2709_",
    x: 86.9,
    y: 50.5,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -12.9553 52.8129)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1922_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2708_",
    x: 87.3,
    y: 50.7,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.0063 53.0509)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1921_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2707_",
    x: 87.7,
    y: 50.9,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -13.073 53.2683)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1907_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1909_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1911_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1915_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2702_",
    className: "st3",
    d: "M94.1,50.9l-4.2,0c0,0-0.1,0-0.1,0.1l0,1.1l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L94.1,50.9C94.2,50.9,94.1,50.9,94.1,50.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2703_",
    className: "st2",
    d: "M92,53.7c-0.3,0-0.5-0.1-0.7-0.2L90,52.8c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2V51 c0-0.1,0.1-0.2,0.2-0.2l4.2,0c0.1,0,0.2,0.1,0.2,0.2v1.4h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8C92.4,53.7,92.2,53.7,92,53.7z  M89.9,51l0,1.3c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0V51L89.9,51z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1914_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2903_",
    className: "st2",
    d: "M94.1,50.9l-1.9,0v2.7c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0 L94.1,50.9C94.2,50.9,94.1,50.9,94.1,50.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1913_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2673_",
    className: "st4",
    d: "M94,51.2l-1.4,0.8c-0.3,0.2-0.8,0.2-1.2,0l-1.3-0.7c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C94.2,50.7,94.3,51.1,94,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2699_",
    className: "st2",
    d: "M92,52.3c-0.3,0-0.5-0.1-0.7-0.2L90,51.4c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4l-1.4,0.8 C92.4,52.3,92.2,52.3,92,52.3z M91.9,49.8c-0.2,0-0.3,0-0.5,0.1L90,50.7c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3l-1.3-0.7C92.4,49.8,92.2,49.8,91.9,49.8 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1912_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2698_",
    x: 93.6,
    y: 51.7,
    className: "st3",
    width: 0.3,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1910_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2697_",
    x: 91.4,
    y: 52.7,
    className: "st2",
    width: 0.3,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1908_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2696_",
    x: 91.8,
    y: 49.4,
    transform: "matrix(0.5035 -0.864 0.864 0.5035 1.6822 104.7462)",
    className: "st2",
    width: 0.3,
    height: 2.9
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2180_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2214_"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2901_",
    d: "M81.1,37l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6l-1.9-1.2 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C80.9,36.6,80.9,36.9,81.1,37z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000009554663798313348710000007336086945201380224_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2901_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2217_",
    style: {
      clipPath: "url(#XMLID_00000009554663798313348710000007336086945201380224_)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2902_",
    d: "M84.7,39.4L78.9,36c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9l-6.6,3.8C85.5,39.7,84.9,39.5,84.7,39.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000034771250537142259220000015901815400743298484_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2902_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2219_",
    style: {
      clipPath: "url(#XMLID_00000034771250537142259220000015901815400743298484_)"
    }
  }, _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2251_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2695_",
    x: 79,
    y: 34.3,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.9028 46.7044)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2249_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2694_",
    x: 79.4,
    y: 34.5,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.9572 46.9389)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2248_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2693_",
    x: 79.8,
    y: 34.7,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.0239 47.1564)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2245_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2692_",
    x: 80.2,
    y: 35,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.075 47.3944)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2241_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2691_",
    x: 80.6,
    y: 35.2,
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -6.151 47.5836)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2240_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2690_",
    x: 81,
    y: 35.4,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.2033 47.8338)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2239_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2689_",
    x: 81.3,
    y: 35.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.27 48.0513)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2238_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2688_",
    x: 81.8,
    y: 35.9,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.321 48.2893)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2236_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2687_",
    x: 82.1,
    y: 36.1,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.3878 48.5067)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2235_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2686_",
    x: 82.5,
    y: 36.3,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.4409 48.7447)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2234_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2685_",
    x: 82.9,
    y: 36.5,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.5077 48.9621)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2233_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2684_",
    x: 83.3,
    y: 36.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.5587 49.2001)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2232_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2683_",
    x: 83.7,
    y: 37,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.6327 49.4049)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2231_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2682_",
    x: 84.1,
    y: 37.2,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.687 49.6395)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2229_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2681_",
    x: 84.5,
    y: 37.5,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.7538 49.857)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2228_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2680_",
    x: 84.9,
    y: 37.7,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.8048 50.095)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2227_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2679_",
    x: 85.3,
    y: 37.9,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.8716 50.3125)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2226_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2678_",
    x: 77.4,
    y: 33.4,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.6731 45.7876)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2224_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2677_",
    x: 77.8,
    y: 33.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.7275 46.0222)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2223_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2676_",
    x: 78.2,
    y: 33.9,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.7942 46.2397)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2222_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2675_",
    x: 78.6,
    y: 34.1,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.8452 46.4777)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2220_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2674_",
    x: 79,
    y: 34.3,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.912 46.6951)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2202_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2205_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2208_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2213_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2669_",
    className: "st3",
    d: "M85.4,34.3l-4.2,0c0,0-0.1,0-0.1,0.1v1.1l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L85.4,34.3C85.5,34.3,85.5,34.3,85.4,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2670_",
    className: "st2",
    d: "M83.3,37.1c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7C81.1,36,81,35.8,81,35.7l0-0.2v-1.1 c0-0.1,0.1-0.2,0.2-0.2l4.2,0h0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2v1.4h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8 C83.8,37,83.5,37.1,83.3,37.1z M81.2,34.4l0,1.3c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8 c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0v-1.1L81.2,34.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2212_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2900_",
    className: "st2",
    d: "M85.4,34.3l-1.9,0v2.7c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0 L85.4,34.3C85.5,34.3,85.5,34.3,85.4,34.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2211_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2640_",
    className: "st4",
    d: "M85.3,34.6l-1.4,0.8c-0.3,0.2-0.8,0.2-1.2,0l-1.3-0.7c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C85.6,34.1,85.6,34.4,85.3,34.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2666_",
    className: "st2",
    d: "M83.3,35.7c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4l-1.4,0.8 C83.8,35.6,83.5,35.7,83.3,35.7z M83.3,33.1c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3l-1.3-0.7C83.7,33.2,83.5,33.1,83.3,33.1 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2209_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2665_",
    x: 84.9,
    y: 35.1,
    className: "st3",
    width: 0.3,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2207_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2664_",
    x: 82.7,
    y: 36.1,
    className: "st2",
    width: 0.3,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2204_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2663_",
    x: 83.2,
    y: 32.8,
    transform: "matrix(0.5036 -0.864 0.864 0.5036 11.7509 88.9742)",
    className: "st2",
    width: 0.3,
    height: 2.9
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_890_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5073_"
  }, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2898_",
    d: "M52.4,28.4l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6l-1.9-1.2 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C52.2,28,52.2,28.3,52.4,28.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000054955733775019700530000008147540282763493517_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2898_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5075_",
    style: {
      clipPath: "url(#XMLID_00000054955733775019700530000008147540282763493517_)"
    }
  }, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2899_",
    d: "M56,30.8l-5.8-3.4c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9l-6.6,3.8C56.8,31.1,56.2,30.9,56,30.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000128450993194248069610000002587471696640858248_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2899_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5077_",
    style: {
      clipPath: "url(#XMLID_00000128450993194248069610000002587471696640858248_)"
    }
  }, _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5099_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2662_",
    x: 50.3,
    y: 25.7,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.4374 31.2093)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5098_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2661_",
    x: 50.7,
    y: 25.9,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.4918 31.4438)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5097_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2660_",
    x: 51.1,
    y: 26.1,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.5585 31.6613)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5096_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2659_",
    x: 51.5,
    y: 26.3,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.6096 31.8993)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5095_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2658_",
    x: 51.9,
    y: 26.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.6835 32.1041)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5094_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2657_",
    x: 52.3,
    y: 26.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.7379 32.3387)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5093_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2656_",
    x: 52.7,
    y: 27,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.8046 32.5562)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5092_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2655_",
    x: 53.1,
    y: 27.2,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.8556 32.7941)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5091_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2654_",
    x: 53.5,
    y: 27.5,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.9224 33.0116)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5090_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2653_",
    x: 53.9,
    y: 27.7,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.9755 33.2495)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5089_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2652_",
    x: 54.2,
    y: 27.9,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.0423 33.467)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5088_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2651_",
    x: 54.7,
    y: 28.1,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.0934 33.705)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5087_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2650_",
    x: 55,
    y: 28.4,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.1673 33.9098)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5086_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2649_",
    x: 55.4,
    y: 28.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.2216 34.1444)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5085_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2648_",
    x: 55.8,
    y: 28.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.2884 34.3619)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5084_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2647_",
    x: 56.2,
    y: 29.1,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.3394 34.5998)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5083_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2646_",
    x: 56.6,
    y: 29.3,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -6.4062 34.8173)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5082_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2645_",
    x: 48.7,
    y: 24.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.2077 30.2925)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5081_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2644_",
    x: 49.1,
    y: 25,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.2621 30.5271)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5080_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2643_",
    x: 49.5,
    y: 25.2,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.3288 30.7446)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5079_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2642_",
    x: 49.9,
    y: 25.5,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.3798 30.9826)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5078_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2641_",
    x: 50.3,
    y: 25.7,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -5.4466 31.2001)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4798_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4800_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4802_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4806_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2636_",
    className: "st3",
    d: "M57.3,24.7l-4.2,0c0,0-0.1,0-0.1,0.1l0,2.1l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L57.3,24.7C57.4,24.8,57.4,24.7,57.3,24.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2637_",
    className: "st2",
    d: "M55.2,28.5c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2v-2.1 c0-0.1,0.1-0.2,0.2-0.2l4.2,0c0.1,0,0.2,0.1,0.2,0.2v2.4h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8C55.6,28.5,55.4,28.5,55.2,28.5z  M53.1,24.9l0,2.3c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0v-2.1 L53.1,24.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4805_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2897_",
    className: "st2",
    d: "M57.3,24.7l-1.9,0v3.7c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0 L57.3,24.7C57.4,24.8,57.4,24.7,57.3,24.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4804_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2629_",
    className: "st4",
    d: "M57.2,25.1l-1.4,0.8c-0.3,0.2-0.8,0.2-1.2,0l-1.3-0.7c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C57.5,24.6,57.5,24.9,57.2,25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2633_",
    className: "st2",
    d: "M55.2,26.1c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4L55.8,26 C55.6,26.1,55.4,26.1,55.2,26.1z M55.2,23.6c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3l-1.3-0.7C55.6,23.7,55.4,23.6,55.2,23.6 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4803_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2632_",
    x: 56.8,
    y: 25.6,
    className: "st3",
    width: 0.3,
    height: 1.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4801_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2631_",
    x: 54.6,
    y: 26.6,
    className: "st2",
    width: 0.3,
    height: 1.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4799_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2630_",
    x: 55.1,
    y: 23.3,
    transform: "matrix(0.5036 -0.864 0.864 0.5036 6.0512 59.9812)",
    className: "st2",
    width: 0.3,
    height: 2.9
  })))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4216_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4777_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4781_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2625_",
    className: "st3",
    d: "M61,22.5l-4.2,0c0,0-0.1,0-0.1,0.1l0,5.6l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L61,22.5C61.1,22.5,61,22.5,61,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2626_",
    className: "st2",
    d: "M58.9,29.8c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2v-5.6 c0-0.1,0.1-0.2,0.2-0.2l4.2,0h0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2v6h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8 C59.3,29.8,59.1,29.8,58.9,29.8z M56.8,22.6l0,5.8c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8 c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0v-5.7L56.8,22.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4780_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2896_",
    className: "st2",
    d: "M61,22.5l-1.9,0v7.2c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L61,22.5 C61.1,22.5,61,22.5,61,22.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4779_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2620_",
    className: "st4",
    d: "M60.9,22.8l-1.4,0.8c-0.3,0.2-0.8,0.2-1.2,0L57,22.9c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C61.1,22.3,61.2,22.6,60.9,22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2622_",
    className: "st2",
    d: "M58.9,23.9c-0.3,0-0.5-0.1-0.7-0.2L56.9,23c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4l-1.4,0.8 C59.3,23.9,59.1,23.9,58.9,23.9z M58.8,21.4c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3l-1.3-0.7C59.3,21.4,59,21.4,58.8,21.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4778_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2621_",
    x: 60.4,
    y: 23.3,
    className: "st3",
    width: 0.3,
    height: 5.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4776_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2530_",
    className: "st4",
    points: "59.1,22.3 58.5,22 58.3,22.1 58,22.3 58.6,22.6 58.3,22.8 59.5,22.9 59.4,22.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2617_",
    className: "st2",
    d: "M59.7,23L58,22.8l0.4-0.2l-0.6-0.3l0.7-0.4l0.6,0.3l0.4-0.2L59.7,23z M58.7,22.7l0.7,0.1 l-0.1-0.4l-0.2,0.1l-0.6-0.3l-0.3,0.2l0.6,0.3L58.7,22.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4775_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2616_",
    x: 58.3,
    y: 24.3,
    className: "st2",
    width: 0.3,
    height: 5.3
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_701_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5102_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4829_"
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2828_",
    d: "M7.9,82.7l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6L11.2,81 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C7.7,82.2,7.7,82.5,7.9,82.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000122716829394358243390000014304900629399946125_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2828_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4831_",
    style: {
      clipPath: "url(#XMLID_00000122716829394358243390000014304900629399946125_)"
    }
  }, _defs0 || (_defs0 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2829_",
    d: "M11.5,85l-5.8-3.4c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9L13,84.9C12.3,85.3,11.8,85.2,11.5,85z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000043417488631093186750000013712361370418958732_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2829_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4833_",
    style: {
      clipPath: "url(#XMLID_00000043417488631093186750000013712361370418958732_)"
    }
  }, _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4855_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2404_",
    x: 5.9,
    y: 79.9,
    transform: "matrix(0.8666 -0.499 0.499 0.8666 -38.4476 16.1898)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4854_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2403_",
    x: 6.3,
    y: 80.1,
    transform: "matrix(0.8668 -0.4987 0.4987 0.8668 -38.4757 16.4033)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4853_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2402_",
    x: 6.7,
    y: 80.4,
    transform: "matrix(0.8666 -0.499 0.499 0.8666 -38.5687 16.6408)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4852_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2401_",
    x: 7.1,
    y: 80.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -38.6522 16.9042)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4851_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2400_",
    x: 7.4,
    y: 80.8,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -38.7261 17.1087)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4850_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2399_",
    x: 7.8,
    y: 81.1,
    transform: "matrix(0.8669 -0.4984 0.4984 0.8669 -38.7047 17.2815)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4849_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2398_",
    x: 8.2,
    y: 81.3,
    transform: "matrix(0.8666 -0.499 0.499 0.8666 -38.8148 17.5336)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4848_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2397_",
    x: 8.6,
    y: 81.5,
    transform: "matrix(0.8668 -0.4987 0.4987 0.8668 -38.8396 17.7493)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4847_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2396_",
    x: 9,
    y: 81.7,
    transform: "matrix(0.8669 -0.4984 0.4984 0.8669 -38.8892 17.9519)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4846_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2395_",
    x: 9.4,
    y: 81.9,
    transform: "matrix(0.8666 -0.499 0.499 0.8666 -38.9811 18.2214)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4845_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2394_",
    x: 9.8,
    y: 82.2,
    transform: "matrix(0.8666 -0.499 0.499 0.8666 -39.0525 18.4422)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4844_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2393_",
    x: 10.2,
    y: 82.4,
    transform: "matrix(0.8668 -0.4987 0.4987 0.8668 -39.0766 18.6567)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4843_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2392_",
    x: 10.5,
    y: 82.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -39.2099 18.912)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4842_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2391_",
    x: 11,
    y: 82.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -39.2643 19.1462)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4841_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2390_",
    x: 11.3,
    y: 83.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -39.331 19.3634)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4840_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2389_",
    x: 11.8,
    y: 83.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -39.3821 19.6011)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4839_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2388_",
    x: 12.1,
    y: 83.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -39.4488 19.8182)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4838_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2387_",
    x: 4.3,
    y: 79,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -38.2503 15.2996)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4837_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2386_",
    x: 4.7,
    y: 79.3,
    transform: "matrix(0.8666 -0.499 0.499 0.8666 -38.2682 15.5063)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4836_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2385_",
    x: 5.1,
    y: 79.5,
    transform: "matrix(0.8668 -0.4986 0.4986 0.8668 -38.3064 15.7016)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4835_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2384_",
    x: 5.5,
    y: 79.7,
    transform: "matrix(0.8666 -0.499 0.499 0.8666 -38.3854 15.9602)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4834_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2383_",
    x: 5.9,
    y: 79.9,
    transform: "matrix(0.8669 -0.4984 0.4984 0.8669 -38.4133 16.1471)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4202_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4210_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4215_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2378_",
    className: "st3",
    d: "M12.3,78.8l-4.2,0c0,0-0.1,0-0.1,0.1L8,81l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L12.3,78.8C12.4,78.9,12.3,78.8,12.3,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2379_",
    className: "st2",
    d: "M10.2,82.7c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2v-2.1 c0-0.1,0.1-0.2,0.2-0.2l4.2,0c0.1,0,0.2,0.1,0.2,0.2v2.4h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8C10.6,82.6,10.4,82.7,10.2,82.7z  M8.1,79l0,2.3c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0V79L8.1,79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4213_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2827_",
    className: "st2",
    d: "M12.3,78.9l-1.9,0v3.7c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0 L12.3,78.9C12.4,78.9,12.3,78.9,12.3,78.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4212_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2373_",
    className: "st4",
    d: "M12.2,79.2L10.7,80c-0.3,0.2-0.8,0.2-1.2,0l-1.3-0.7c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C12.4,78.7,12.5,79,12.2,79.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2375_",
    className: "st2",
    d: "M10.2,80.3c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7C8,79.2,7.8,79,7.8,78.8 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4l-1.4,0.8 C10.6,80.2,10.4,80.3,10.2,80.3z M10.1,77.7c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3l-1.3-0.7C10.6,77.8,10.4,77.7,10.1,77.7 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4211_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2374_",
    x: 11.8,
    y: 79.7,
    className: "st3",
    width: 0.3,
    height: 1.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4204_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2274_",
    className: "st4",
    points: "10.4,78.7 9.9,78.4 9.6,78.5 9.4,78.6 9.9,79 9.6,79.1 10.8,79.2 10.7,78.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2370_",
    className: "st2",
    d: "M11,79.3l-1.7-0.1L9.7,79l-0.6-0.3l0.7-0.4l0.6,0.3l0.4-0.2L11,79.3z M10,79l0.7,0.1 l-0.1-0.4l-0.2,0.1l-0.6-0.3l-0.3,0.2l0.6,0.3L10,79z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4203_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2369_",
    x: 9.6,
    y: 80.7,
    className: "st2",
    width: 0.3,
    height: 1.8
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_891_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4856_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5019_"
  }, _defs1 || (_defs1 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2825_",
    d: "M51.3,76.5l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6l-1.9-1.2 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C51.1,76.1,51.1,76.4,51.3,76.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000040562373232295154250000014413957596407791243_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2825_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5021_",
    style: {
      clipPath: "url(#XMLID_00000040562373232295154250000014413957596407791243_)"
    }
  }, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2826_",
    d: "M54.9,78.9l-5.8-3.4c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9l-6.6,3.8C55.7,79.2,55.2,79.1,54.9,78.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000062909929690870203340000013058151093281586560_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2826_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5023_",
    style: {
      clipPath: "url(#XMLID_00000062909929690870203340000013058151093281586560_)"
    }
  }, _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5045_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2318_",
    x: 49.3,
    y: 73.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.6558 37.1265)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5044_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2317_",
    x: 49.7,
    y: 74,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.7102 37.3612)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5043_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2316_",
    x: 50,
    y: 74.3,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.7769 37.5786)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5042_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2315_",
    x: 50.5,
    y: 74.5,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.828 37.8166)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5041_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2314_",
    x: 50.8,
    y: 74.7,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.9019 38.0214)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5040_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2313_",
    x: 51.2,
    y: 74.9,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.9563 38.2561)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5039_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2312_",
    x: 51.6,
    y: 75.2,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -30.023 38.4735)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5038_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2311_",
    x: 52,
    y: 75.4,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -30.0741 38.7115)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5037_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2310_",
    x: 52.4,
    y: 75.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -30.1408 38.929)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5036_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2309_",
    x: 52.8,
    y: 75.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -30.194 39.1669)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5035_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2308_",
    x: 53.2,
    y: 76.1,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -30.2607 39.3843)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5034_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2307_",
    x: 53.6,
    y: 76.3,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -30.3117 39.6223)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5033_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2306_",
    x: 53.9,
    y: 76.5,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -30.3857 39.8272)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5032_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2305_",
    x: 54.3,
    y: 76.7,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -30.4401 40.0617)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5031_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2304_",
    x: 54.7,
    y: 77,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -30.5068 40.2792)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5030_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2303_",
    x: 55.1,
    y: 77.2,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -30.5578 40.5172)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5029_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2302_",
    x: 55.5,
    y: 77.4,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -30.6246 40.7346)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5028_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2301_",
    x: 47.7,
    y: 72.9,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.4261 36.2099)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5027_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2300_",
    x: 48.1,
    y: 73.2,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.4805 36.4445)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5026_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2299_",
    x: 48.4,
    y: 73.4,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.5472 36.6619)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5025_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2298_",
    x: 48.9,
    y: 73.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.5983 36.8999)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5024_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2297_",
    x: 49.2,
    y: 73.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.665 37.1174)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5046_"
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2823_",
    d: "M49.7,74.4l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6l-1.9-1.2 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C49.5,73.9,49.5,74.2,49.7,74.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000010997888370189818510000009586299724569953940_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2823_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5048_",
    style: {
      clipPath: "url(#XMLID_00000010997888370189818510000009586299724569953940_)"
    }
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2824_",
    d: "M53.3,76.7l-5.8-3.4c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9l-6.6,3.8C54.1,77,53.6,76.9,53.3,76.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000155131955135531642730000017270255909758059932_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2824_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5050_",
    style: {
      clipPath: "url(#XMLID_00000155131955135531642730000017270255909758059932_)"
    }
  }, _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5072_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2296_",
    x: 47.7,
    y: 71.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -28.7743 36.0355)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5071_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2295_",
    x: 48.1,
    y: 71.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -28.8287 36.2701)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5070_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2294_",
    x: 48.5,
    y: 72.1,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -28.8954 36.4876)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5069_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2293_",
    x: 48.9,
    y: 72.3,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -28.9465 36.7255)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5068_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2292_",
    x: 49.2,
    y: 72.5,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.0204 36.9304)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5067_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2291_",
    x: 49.6,
    y: 72.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.0748 37.165)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5066_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2290_",
    x: 50,
    y: 73,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.1415 37.3825)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5065_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2289_",
    x: 50.4,
    y: 73.2,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.1926 37.6204)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5064_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2288_",
    x: 50.8,
    y: 73.4,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.2593 37.838)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5063_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2287_",
    x: 51.2,
    y: 73.7,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.3125 38.0758)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5062_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2286_",
    x: 51.6,
    y: 73.9,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.3792 38.2933)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5061_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2285_",
    x: 52,
    y: 74.1,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.4302 38.5313)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5060_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2284_",
    x: 52.3,
    y: 74.3,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.5042 38.7361)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5059_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2283_",
    x: 52.8,
    y: 74.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.5586 38.9707)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5058_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2282_",
    x: 53.1,
    y: 74.8,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.6253 39.1881)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5057_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2281_",
    x: 53.5,
    y: 75,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.6764 39.4262)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5056_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2280_",
    x: 53.9,
    y: 75.2,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -29.7431 39.6436)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5055_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2279_",
    x: 46.1,
    y: 70.7,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -28.5446 35.1188)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5054_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2278_",
    x: 46.5,
    y: 71,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -28.599 35.3534)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5053_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2277_",
    x: 46.9,
    y: 71.2,
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -28.6597 35.5572)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5052_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2276_",
    x: 47.3,
    y: 71.4,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -28.7168 35.8089)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5051_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2275_",
    x: 47.6,
    y: 71.6,
    transform: "matrix(0.866 -0.5001 0.5001 0.866 -28.7835 36.0263)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4826_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4003_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4005_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4156_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2270_",
    className: "st3",
    d: "M54.6,70.6l-4.2,0c0,0-0.1,0-0.1,0.1l0,2.1l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L54.6,70.6C54.6,70.7,54.6,70.6,54.6,70.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2271_",
    className: "st2",
    d: "M52.5,74.5c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2v-2.1 c0-0.1,0.1-0.2,0.2-0.2l4.2,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2v2.4h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8 C52.9,74.4,52.7,74.5,52.5,74.5z M50.4,70.8l0,2.3c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8 c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0v-2.1L50.4,70.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4011_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2822_",
    className: "st2",
    d: "M54.6,70.6l-1.9,0v3.7c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0 L54.6,70.6C54.6,70.7,54.6,70.6,54.6,70.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4007_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2265_",
    className: "st4",
    d: "M54.4,71L53,71.8c-0.3,0.2-0.8,0.2-1.2,0L50.5,71c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C54.7,70.5,54.7,70.8,54.4,71z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2267_",
    className: "st2",
    d: "M52.5,72.1c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4l-1.4,0.8 C52.9,72,52.7,72.1,52.5,72.1z M52.4,69.5c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3L53,69.7C52.8,69.6,52.6,69.5,52.4,69.5 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4006_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2266_",
    x: 54,
    y: 71.5,
    className: "st3",
    width: 0.3,
    height: 1.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4004_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_2260_",
    className: "st4",
    points: "52.7,70.5 52.1,70.1 51.9,70.3 51.6,70.4 52.2,70.8 51.9,70.9 53.1,71 53,70.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2262_",
    className: "st2",
    d: "M53.2,71.1L51.6,71l0.4-0.2l-0.6-0.3l0.7-0.4l0.6,0.3l0.4-0.2L53.2,71.1z M52.2,70.8 l0.7,0.1l-0.1-0.4l-0.2,0.1l-0.6-0.3l-0.3,0.2l0.6,0.3L52.2,70.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4157_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2261_",
    x: 51.9,
    y: 72.5,
    className: "st2",
    width: 0.3,
    height: 1.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4158_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4160_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4167_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4171_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2256_",
    className: "st3",
    d: "M55.5,73.8l-4.2,0c0,0-0.1,0-0.1,0.1V75l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L55.5,73.8C55.6,73.9,55.6,73.8,55.5,73.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2257_",
    className: "st2",
    d: "M53.4,76.7c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2l0-1.1 c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1l4.2,0h0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2v1.4h0c0,0.1-0.1,0.2-0.3,0.3 L54,76.5C53.9,76.6,53.7,76.7,53.4,76.7z M51.3,74l0,1l0,0.2c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8 c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0V74L51.3,74z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4170_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2821_",
    className: "st2",
    d: "M55.5,73.9l-1.9,0v2.7c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0 L55.5,73.9C55.6,73.9,55.6,73.9,55.5,73.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4169_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1949_",
    className: "st4",
    d: "M55.4,74.2L54,75c-0.3,0.2-0.8,0.2-1.2,0l-1.3-0.7c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C55.7,73.7,55.7,74,55.4,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2253_",
    className: "st2",
    d: "M53.4,75.3c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4L54,75.1 C53.9,75.2,53.7,75.3,53.4,75.3z M53.4,72.7c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3L54,72.9 C53.8,72.8,53.6,72.7,53.4,72.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4168_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2252_",
    x: 55,
    y: 74.7,
    className: "st3",
    width: 0.3,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4166_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2250_",
    x: 52.8,
    y: 75.7,
    className: "st2",
    width: 0.3,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4173_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2247_",
    x: 53.3,
    y: 72.4,
    transform: "matrix(0.5035 -0.864 0.864 0.5035 -37.2905 82.8122)",
    className: "st2",
    width: 0.3,
    height: 2.9
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_879_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5101_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4884_"
  }, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2819_",
    d: "M40.6,84.6l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6l-1.9-1.2 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C40.4,84.2,40.4,84.5,40.6,84.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000018934060503606178680000017693313316590077839_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2819_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4886_",
    style: {
      clipPath: "url(#XMLID_00000018934060503606178680000017693313316590077839_)"
    }
  }, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2820_",
    d: "M44.2,87l-5.8-3.4c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9l-6.6,3.8C45,87.3,44.5,87.1,44.2,87z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000171699835287365640570000003147786001402016388_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2820_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4888_",
    style: {
      clipPath: "url(#XMLID_00000171699835287365640570000003147786001402016388_)"
    }
  }, _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4910_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2185_",
    x: 38.6,
    y: 81.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.1025 32.8069)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4909_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2184_",
    x: 39,
    y: 82.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.1569 33.0412)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4908_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2183_",
    x: 39.3,
    y: 82.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.2236 33.2584)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4907_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2182_",
    x: 39.8,
    y: 82.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.2747 33.496)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4906_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2181_",
    x: 40.1,
    y: 82.8,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -35.3534 33.7085)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4905_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2179_",
    x: 40.5,
    y: 83,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.403 33.9348)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4904_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2129_",
    x: 40.9,
    y: 83.3,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -35.4745 34.16)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4903_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2128_",
    x: 41.3,
    y: 83.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.5208 34.3897)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4902_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2127_",
    x: 41.7,
    y: 83.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.5875 34.6068)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4901_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2126_",
    x: 42.1,
    y: 83.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.6407 34.8444)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4900_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2125_",
    x: 42.5,
    y: 84.2,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -35.7122 35.0698)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4899_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2124_",
    x: 42.9,
    y: 84.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.7584 35.2992)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4898_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2123_",
    x: 43.2,
    y: 84.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.8324 35.5038)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4897_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2122_",
    x: 43.6,
    y: 84.8,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.8867 35.738)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4896_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2121_",
    x: 44,
    y: 85.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.9535 35.9552)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4895_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2120_",
    x: 44.4,
    y: 85.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -36.0046 36.1929)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4894_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_2119_",
    x: 44.8,
    y: 85.5,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -36.0761 36.4185)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4893_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1989_",
    x: 37,
    y: 81,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -34.8728 31.8915)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4892_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1987_",
    x: 37.4,
    y: 81.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -34.9272 32.1258)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4891_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1986_",
    x: 37.8,
    y: 81.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -34.9939 32.3429)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4890_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1985_",
    x: 38.2,
    y: 81.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.0449 32.5806)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4889_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1983_",
    x: 38.5,
    y: 81.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -35.1117 32.7978)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4911_"
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2817_",
    d: "M39.6,82l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6l-1.9-1.2 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C39.4,81.6,39.4,81.9,39.6,82z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000178898340362047969030000013054789400002781115_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2817_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4913_",
    style: {
      clipPath: "url(#XMLID_00000178898340362047969030000013054789400002781115_)"
    }
  }, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2818_",
    d: "M43.2,84.4L37.5,81c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9l-6.6,3.8C44,84.7,43.5,84.5,43.2,84.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000120545858526492849790000000587937337894782348_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2818_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4915_",
    style: {
      clipPath: "url(#XMLID_00000120545858526492849790000000587937337894782348_)"
    }
  }, _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4937_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1979_",
    x: 37.6,
    y: 79.3,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -33.9363 31.9753)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4936_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1978_",
    x: 38,
    y: 79.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -33.9861 32.2021)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4935_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1973_",
    x: 38.4,
    y: 79.8,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -34.0574 32.4269)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4934_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1972_",
    x: 38.8,
    y: 80,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -34.1038 32.6569)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4933_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1971_",
    x: 39.1,
    y: 80.2,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -34.1824 32.8691)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4932_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1969_",
    x: 39.5,
    y: 80.4,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -34.2368 33.1035)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4931_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1968_",
    x: 39.9,
    y: 80.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -34.2989 33.3129)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4930_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1966_",
    x: 40.3,
    y: 80.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -34.3499 33.5506)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4929_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1965_",
    x: 40.7,
    y: 81.1,
    transform: "matrix(0.8664 -0.4994 0.4994 0.8664 -34.4132 33.762)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4928_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1963_",
    x: 41.1,
    y: 81.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -34.4698 34.0053)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4927_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1962_",
    x: 41.5,
    y: 81.6,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -34.5412 34.2304)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4926_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1961_",
    x: 41.9,
    y: 81.8,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -34.5876 34.4602)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4925_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1959_",
    x: 42.3,
    y: 82,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -34.6662 34.6727)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4924_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1958_",
    x: 42.7,
    y: 82.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -34.7159 34.899)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4923_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1957_",
    x: 43,
    y: 82.5,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -34.7873 35.1243)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4922_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1956_",
    x: 43.5,
    y: 82.7,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -34.8384 35.362)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4921_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1955_",
    x: 43.8,
    y: 82.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -34.9004 35.571)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4920_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1954_",
    x: 36,
    y: 78.4,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -33.7066 31.0597)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4919_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1953_",
    x: 36.4,
    y: 78.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -33.7563 31.2867)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4918_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1952_",
    x: 36.8,
    y: 78.9,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -33.8277 31.5113)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4917_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1951_",
    x: 37.2,
    y: 79.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -33.8741 31.7415)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4916_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1950_",
    x: 37.6,
    y: 79.3,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -33.9455 31.9662)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4828_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4184_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4186_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4188_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4192_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1945_",
    className: "st3",
    d: "M44.3,78.3l-4.2,0c0,0-0.1,0-0.1,0.1v2.1l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L44.3,78.3C44.4,78.4,44.4,78.3,44.3,78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1946_",
    className: "st2",
    d: "M42.2,82.1c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2v-2.1 c0-0.1,0.1-0.2,0.2-0.2l4.2,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2v2.4h0c0,0.1-0.1,0.2-0.3,0.3L42.8,82 C42.6,82.1,42.4,82.1,42.2,82.1z M40.1,78.5l0,2.3c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8 c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0v-2.1L40.1,78.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4191_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2816_",
    className: "st2",
    d: "M44.3,78.3l-1.9,0V82c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0 L44.3,78.3C44.4,78.4,44.4,78.3,44.3,78.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4190_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1885_",
    className: "st4",
    d: "M44.2,78.6l-1.4,0.8c-0.3,0.2-0.8,0.2-1.2,0l-1.3-0.7c-0.4-0.2-0.4-0.5-0.1-0.7 l1.4-0.8c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C44.5,78.2,44.5,78.5,44.2,78.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1889_",
    className: "st2",
    d: "M42.2,79.7c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4l-1.4,0.8 C42.6,79.7,42.4,79.7,42.2,79.7z M42.2,77.2c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3l-1.3-0.7 C42.6,77.2,42.4,77.2,42.2,77.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4189_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1888_",
    x: 43.8,
    y: 79.1,
    className: "st3",
    width: 0.3,
    height: 1.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4187_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1887_",
    x: 41.6,
    y: 80.2,
    className: "st2",
    width: 0.3,
    height: 1.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4185_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1886_",
    x: 42.1,
    y: 76.8,
    transform: "matrix(0.5036 -0.864 0.864 0.5036 -46.6994 75.3496)",
    className: "st2",
    width: 0.3,
    height: 2.9
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4193_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4195_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4197_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4201_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1881_",
    className: "st3",
    d: "M45,81.9l-4.2,0c0,0-0.1,0-0.1,0.1V83l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L45,81.9C45.1,81.9,45,81.9,45,81.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1882_",
    className: "st2",
    d: "M42.9,84.7c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2V82 c0-0.1,0.1-0.2,0.2-0.2l4.2,0c0.1,0,0.2,0.1,0.2,0.2v1.4h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8C43.3,84.6,43.1,84.7,42.9,84.7z  M40.8,82l0,1.3c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0V82L40.8,82z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4200_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2815_",
    className: "st2",
    d: "M45,81.9l-1.9,0v2.7c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L45,81.9 C45.1,81.9,45,81.9,45,81.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4199_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1831_",
    className: "st4",
    d: "M44.9,82.2L43.4,83c-0.3,0.2-0.8,0.2-1.2,0l-1.3-0.7c-0.4-0.2-0.4-0.5-0.1-0.7 l1.4-0.8c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C45.1,81.7,45.2,82,44.9,82.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1878_",
    className: "st2",
    d: "M42.9,83.3c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4l-1.4,0.8 C43.3,83.2,43.1,83.3,42.9,83.3z M42.8,80.7c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3l-1.3-0.7C43.3,80.8,43,80.7,42.8,80.7 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4198_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1877_",
    x: 44.4,
    y: 82.7,
    className: "st3",
    width: 0.3,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4196_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1876_",
    x: 42.3,
    y: 83.7,
    className: "st2",
    width: 0.3,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4194_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1875_",
    x: 42.7,
    y: 80.4,
    transform: "matrix(0.5035 -0.864 0.864 0.5035 -49.4703 77.6745)",
    className: "st2",
    width: 0.3,
    height: 2.9
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5243_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5291_"
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2813_",
    d: "M67.4,71l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6l-1.9-1.2 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C67.1,70.6,67.1,70.9,67.4,71z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000115514058689754364690000011156391180652029884_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2813_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5293_",
    style: {
      clipPath: "url(#XMLID_00000115514058689754364690000011156391180652029884_)"
    }
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2814_",
    d: "M70.9,73.4L65.2,70c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9l-6.6,3.8C71.7,73.7,71.2,73.5,70.9,73.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000160190436701274379730000014242568527228431029_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2814_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5295_",
    style: {
      clipPath: "url(#XMLID_00000160190436701274379730000014242568527228431029_)"
    }
  }, _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5317_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1874_",
    x: 65.3,
    y: 68.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.7311 44.3375)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5316_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1873_",
    x: 65.7,
    y: 68.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.7855 44.5719)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5315_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1860_",
    x: 66.1,
    y: 68.8,
    transform: "matrix(0.8664 -0.4994 0.4994 0.8664 -24.8505 44.7821)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5314_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1858_",
    x: 66.5,
    y: 69,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.9033 45.0266)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5313_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1849_",
    x: 66.8,
    y: 69.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.9772 45.2312)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5312_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1848_",
    x: 67.2,
    y: 69.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.0316 45.4655)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5311_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1847_",
    x: 67.6,
    y: 69.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.0983 45.6826)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5310_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1846_",
    x: 68,
    y: 69.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.1493 45.9203)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5309_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1845_",
    x: 68.4,
    y: 70.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.216 46.1375)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5308_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1844_",
    x: 68.8,
    y: 70.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.2692 46.3751)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5307_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1843_",
    x: 69.2,
    y: 70.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.336 46.5922)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5306_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1842_",
    x: 69.6,
    y: 70.8,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.3893 46.8397)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5305_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1841_",
    x: 70,
    y: 71,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.4609 47.0344)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5304_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1840_",
    x: 70.4,
    y: 71.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.5153 47.2687)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5303_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1839_",
    x: 70.7,
    y: 71.5,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.5844 47.4958)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5302_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1838_",
    x: 71.2,
    y: 71.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.6331 47.7236)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5301_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1837_",
    x: 71.5,
    y: 71.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.6999 47.9407)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5300_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1836_",
    x: 63.7,
    y: 67.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.5014 43.4221)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5299_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1835_",
    x: 64.1,
    y: 67.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.5557 43.6563)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5298_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1834_",
    x: 64.5,
    y: 67.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.6224 43.8736)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5297_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1833_",
    x: 64.9,
    y: 68.1,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -24.6759 44.1205)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5296_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1832_",
    x: 65.3,
    y: 68.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.7402 44.3284)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5246_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5248_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5250_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5254_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1827_",
    className: "st3",
    d: "M71.7,68.3l-4.2,0c0,0-0.1,0-0.1,0.1v1.1l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L71.7,68.3C71.8,68.3,71.7,68.3,71.7,68.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1828_",
    className: "st2",
    d: "M69.6,71.1c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2l0-1.1 c0-0.1,0-0.1,0.1-0.2c0,0,0.1-0.1,0.2-0.1l4.2,0c0.1,0,0.2,0.1,0.2,0.2v1.4h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8 C70,71,69.8,71.1,69.6,71.1z M67.5,68.4l0,1l0,0.2c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8 c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0v-1.1L67.5,68.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5253_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2812_",
    className: "st2",
    d: "M71.7,68.3l-1.9,0v2.7c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0 L71.7,68.3C71.8,68.3,71.7,68.3,71.7,68.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5252_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1705_",
    className: "st4",
    d: "M71.6,68.6l-1.4,0.8c-0.3,0.2-0.8,0.2-1.2,0l-1.3-0.7c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C71.8,68.1,71.9,68.4,71.6,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1824_",
    className: "st2",
    d: "M69.6,69.7c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4L69,67c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4l-1.4,0.8 C70,69.6,69.8,69.7,69.6,69.7z M69.5,67.1c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3l-1.3-0.7C70,67.2,69.8,67.1,69.5,67.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5251_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1823_",
    x: 71.2,
    y: 69.1,
    className: "st3",
    width: 0.3,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5249_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1822_",
    x: 69,
    y: 70.1,
    className: "st2",
    width: 0.3,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5247_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1821_",
    x: 69.4,
    y: 66.8,
    transform: "matrix(0.5036 -0.864 0.864 0.5036 -24.441 94.0071)",
    className: "st2",
    width: 0.3,
    height: 2.9
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2177_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1990_"
  }, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2811_",
    d: "M11.4,77.5l10.5,6c1.3,0.7,2.8,0.7,4.1,0L39.1,76c0.9-0.5,1.8-1.2,2.6-1.9l1.2-1 c0.2-0.2,0.5-0.4,0.7-0.5l0,0c0.6-0.3,1.2-0.6,1.9-0.6l0.3,0c0.4,0,0.8-0.2,1.2-0.4l0.7-0.4l16.2-9.3l0.6-0.6 c0.4-0.4,1-0.7,1.6-0.8l0,0c0.3-0.1,0.6-0.2,0.9-0.4l10.2-5.8c1-0.6,1.9-1.1,2.4-2.1l0,0c0.1-0.3,0.4-0.5,0.6-0.6l0.5-0.3 c0.3-0.2,0.7-0.2,1.1-0.2l0,0c0.8,0.1,1.7-0.4,2.4-0.8l1.9-1.1c0.8-0.5,0.8-1.6,0-2.1l-12.4-7.3L11.4,75.4 C10.6,75.8,10.6,77,11.4,77.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000173881700585259065370000006418687687474794666_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2811_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1992_",
    style: {
      clipPath: "url(#XMLID_00000173881700585259065370000006418687687474794666_)"
    }
  }, _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2091_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2176_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1820_",
    x: -0.7,
    y: 65.9,
    transform: "matrix(0.8664 -0.4993 0.4993 0.8664 -25.6523 36.0531)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2174_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1819_",
    x: -0.3,
    y: 66.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.7117 36.301)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2173_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1818_",
    x: 0,
    y: 66.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.7785 36.5182)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2172_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1817_",
    x: 0.5,
    y: 66.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.8295 36.7558)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2170_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1816_",
    x: 0.8,
    y: 66.8,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.9064 36.9684)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2169_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1815_",
    x: 1.2,
    y: 67,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.9578 37.1946)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2168_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1814_",
    x: 1.6,
    y: 67.3,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -26.0275 37.4199)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2166_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1813_",
    x: 2,
    y: 67.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -26.0756 37.6494)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2165_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1812_",
    x: 2.4,
    y: 67.7,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -26.1453 37.8749)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2163_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1811_",
    x: 2.8,
    y: 67.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -26.1955 38.1042)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2162_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1810_",
    x: 3.2,
    y: 68.2,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -26.2652 38.3297)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2160_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1809_",
    x: 3.6,
    y: 68.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -26.3133 38.559)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2159_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1808_",
    x: 3.9,
    y: 68.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -26.3872 38.7636)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2157_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1807_",
    x: 4.3,
    y: 68.8,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -26.4416 38.9979)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2156_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1806_",
    x: 4.7,
    y: 69.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -26.5083 39.215)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2155_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1805_",
    x: 5.1,
    y: 69.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -26.5594 39.4527)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2153_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1804_",
    x: 5.5,
    y: 69.5,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -26.629 39.6784)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2152_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1803_",
    x: -6.2,
    y: 62.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.8189 32.9058)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2151_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1802_",
    x: -5.8,
    y: 63,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.87 33.1435)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2149_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1801_",
    x: -5.5,
    y: 63.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.9439 33.3481)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2148_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1800_",
    x: -5.1,
    y: 63.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.9982 33.5823)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2146_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1799_",
    x: -4.7,
    y: 63.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.065 33.7995)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2145_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1798_",
    x: -4.3,
    y: 63.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.116 34.0371)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2144_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1797_",
    x: -3.9,
    y: 64.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.1827 34.2543)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2142_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1796_",
    x: -3.5,
    y: 64.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.2359 34.4919)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2141_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1795_",
    x: -3.1,
    y: 64.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.3026 34.7091)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2139_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1794_",
    x: -2.7,
    y: 64.8,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.3566 34.9544)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2138_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1793_",
    x: -2.3,
    y: 65,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.4276 35.1513)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2136_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1792_",
    x: -1.9,
    y: 65.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.482 35.3855)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2135_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1791_",
    x: -1.6,
    y: 65.5,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.5517 35.6105)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2109_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1790_",
    x: -1.1,
    y: 65.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.5998 35.8404)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2107_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1788_",
    x: -0.8,
    y: 65.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.6665 36.0575)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1993_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2082_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1787_",
    x: -12.5,
    y: 59.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.8435 29.3069)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2080_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1786_",
    x: -12.1,
    y: 59.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.8979 29.5412)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2073_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1785_",
    x: -11.7,
    y: 59.6,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -23.9675 29.7649)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2072_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1784_",
    x: -11.3,
    y: 59.8,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.0157 29.996)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2070_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1783_",
    x: -10.9,
    y: 60,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.0896 30.2005)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2069_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1782_",
    x: -10.5,
    y: 60.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.1439 30.4348)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2067_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1781_",
    x: -10.1,
    y: 60.5,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -24.2136 30.6588)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2066_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1780_",
    x: -9.7,
    y: 60.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.2617 30.8896)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2064_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1779_",
    x: -9.4,
    y: 60.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.3285 31.1068)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2063_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1778_",
    x: -8.9,
    y: 61.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.3816 31.3444)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2062_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1777_",
    x: -8.6,
    y: 61.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.4484 31.5615)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2060_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1776_",
    x: -8.1,
    y: 61.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.4994 31.7992)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2059_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1774_",
    x: -7.8,
    y: 61.8,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -24.5763 32.0108)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2058_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1724_",
    x: -7.4,
    y: 62.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.6278 32.238)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2056_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1723_",
    x: -7,
    y: 62.3,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -24.6974 32.4623)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2055_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1722_",
    x: -6.6,
    y: 62.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.7455 32.6929)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2054_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1721_",
    x: -18,
    y: 56,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.005 26.146)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2052_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1720_",
    x: -17.5,
    y: 56.2,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -23.059 26.3896)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2051_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1719_",
    x: -17.2,
    y: 56.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.13 26.5882)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2050_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1718_",
    x: -16.8,
    y: 56.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.1843 26.8225)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2040_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1717_",
    x: -16.4,
    y: 56.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.2511 27.0396)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2038_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1716_",
    x: -16,
    y: 57.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.3022 27.2773)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2027_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1715_",
    x: -15.6,
    y: 57.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.3689 27.4945)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2026_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1714_",
    x: -15.2,
    y: 57.6,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -23.425 27.7382)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2025_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1712_",
    x: -14.8,
    y: 57.8,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.4888 27.9493)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2024_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1711_",
    x: -14.4,
    y: 58,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.5398 28.1869)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2023_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1710_",
    x: -14.1,
    y: 58.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.6137 28.3914)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2020_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1709_",
    x: -13.7,
    y: 58.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.6681 28.6257)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2019_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1708_",
    x: -13.3,
    y: 58.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.7348 28.8429)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2018_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1707_",
    x: -12.9,
    y: 58.9,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -23.7888 29.087)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1994_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1706_",
    x: -12.5,
    y: 59.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.8526 29.2977)",
    className: "st2",
    width: 110.6,
    height: 0.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_889_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_665_"
  }, _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_374_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_736_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1007_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1661_",
    className: "st3",
    d: "M81.7,46.8l-11-6.2c0-0.1-0.1-0.1-0.1-0.1l-0.1,0c0-0.2-0.2-0.3-0.4-0.2l-2.4,1.4 c-0.2,0.1-0.4,0.5-0.4,0.7v0.3c0,0.1,0,0.2,0.1,0.3l0,0l0,0c0,0,0,0,0.1,0l11,6.2L81.7,46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1702_",
    className: "st2",
    d: "M78.7,49.4L78.7,49.4l-11.1-6.2c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.1-0.2-0.1-0.4v-0.3 c0-0.3,0.2-0.7,0.4-0.8l2.4-1.4c0.1-0.1,0.2-0.1,0.3,0c0.1,0,0.1,0.1,0.2,0.2c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1l11.1,6.2 L78.7,49.4z M70.4,40.4c0,0-0.1,0-0.1,0l-2.4,1.4c-0.2,0.1-0.3,0.4-0.3,0.7v0.3c0,0.1,0,0.2,0.1,0.2c0,0,0,0,0,0l0,0l11,6.2 l2.9-2.4l-10.9-6.1l0,0l-0.1,0.1l0-0.1C70.5,40.5,70.4,40.5,70.4,40.4C70.4,40.4,70.4,40.4,70.4,40.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1006_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1657_",
    className: "st3",
    d: "M70.6,40.6L70.6,40.6c-0.1-0.3-0.2-0.3-0.4-0.2l-2.4,1.4c-0.1,0.1-0.2,0.2-0.3,0.3 l11.3,6.3l2.9-1.6l-0.2-0.2l-10.3-5.8C71.3,40.8,70.7,40.5,70.6,40.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1658_",
    className: "st2",
    d: "M78.8,48.5l-11.4-6.4l0-0.1c0.1-0.2,0.2-0.3,0.3-0.4l2.4-1.4c0.1-0.1,0.3-0.1,0.4-0.1 c0.1,0,0.1,0.1,0.2,0.2l0,0c0.1,0,0.2,0.1,0.6,0.3l10.3,5.8l0.3,0.3L78.8,48.5z M67.7,42.1l11.1,6.3l2.7-1.6l-0.1-0.1 l-10.3-5.8c-0.2-0.1-0.5-0.2-0.5-0.3l0,0l-0.2-0.1l0-0.1c0-0.1,0-0.1,0-0.1c0,0-0.1,0-0.2,0l-2.4,1.4 C67.8,41.9,67.7,42,67.7,42.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1005_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1653_",
    className: "st4",
    d: "M79.2,48.7l0.8-0.9l1.5-1.1c0,0,0-0.1,0-0.1L80.4,46l-2.3,1.3 c-0.2,0.1-0.4,0.3-0.5,0.5L79.2,48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1654_",
    className: "st2",
    d: "M79.3,48.8l-1.8-1l0.1-0.1c0.2-0.2,0.3-0.4,0.5-0.5l2.3-1.3l1.1,0.6 c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1l-1.5,1.1L79.3,48.8z M77.8,47.7l1.4,0.8l0.7-0.8l1.4-1.1l-1-0.5l-2.2,1.3 C78,47.4,77.9,47.6,77.8,47.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_998_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1004_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1621_",
    className: "st2",
    d: "M81.7,46.8L81.7,46.8c-0.1-0.2-0.2-0.3-0.4-0.2L78.9,48c-0.2,0.1-0.4,0.5-0.4,0.7V49 c0,0.3,0.2,0.4,0.4,0.3l2.4-1.4c0.2-0.1,0.3-0.4,0.4-0.6l0.1,0c0.1,0,0.1-0.1,0.1-0.2v-0.2C81.8,46.8,81.8,46.8,81.7,46.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1623_",
    className: "st2",
    d: "M78.8,49.4c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.2-0.2-0.2-0.4v-0.3c0-0.3,0.2-0.7,0.4-0.8 l2.4-1.4c0.1-0.1,0.2-0.1,0.3,0c0.1,0,0.1,0.1,0.2,0.2c0,0,0.1,0,0.1,0c0.1,0,0.1,0.1,0.1,0.2v0.2c0,0.1-0.1,0.3-0.2,0.3 l0,0c-0.1,0.3-0.2,0.5-0.4,0.6L79,49.4C78.9,49.4,78.8,49.4,78.8,49.4z M81.4,46.7c0,0-0.1,0-0.1,0L79,48.1 c-0.2,0.1-0.3,0.4-0.3,0.7V49c0,0.1,0,0.2,0.1,0.2c0,0,0.1,0,0.2,0l2.4-1.4c0.2-0.1,0.3-0.3,0.3-0.5l0,0l0.1-0.1 c0,0,0.1-0.1,0.1-0.1v-0.2L81.6,47l0-0.1C81.6,46.8,81.5,46.7,81.4,46.7C81.5,46.7,81.4,46.7,81.4,46.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1002_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1622_",
    className: "st3",
    d: "M79.3,48.8C79.2,48.8,79.2,48.8,79.3,48.8c-0.1-0.1-0.2-0.1-0.2-0.2v-0.2 c0-0.1,0.1-0.3,0.2-0.3l2.2-1.3l0.1,0.2l-2.2,1.3c0,0-0.1,0.1-0.1,0.1v0.2l2.1-1.2l0.1,0.2L79.3,48.8 C79.3,48.8,79.3,48.8,79.3,48.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_670_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_702_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1553_",
    className: "st3",
    d: "M77.3,50.2c0,0-2.5-0.3-4.4-2.7s1.3-0.9,1.3-0.9s2,0.7,2.1,0.7c0.1,0,1,1.1,1,1.3 C77.2,48.7,77.3,50.2,77.3,50.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1575_",
    className: "st2",
    d: "M77.4,50.3l-0.1,0c0,0-2.6-0.3-4.5-2.8c-0.6-0.7-0.7-1.2-0.5-1.4 c0.3-0.4,1.7,0.2,1.9,0.4c0.8,0.3,2,0.7,2.1,0.7c0.2,0,1,1.2,1,1.4c0,0.1,0.1,1.6,0.1,1.6L77.4,50.3z M72.6,46.2 c-0.1,0-0.2,0-0.2,0.1c0,0-0.1,0.3,0.5,1.1c1.6,2.1,3.7,2.6,4.2,2.7c0-0.4-0.1-1.4-0.1-1.5c0-0.1-0.8-1.1-0.9-1.2 c-0.1,0-1.9-0.6-2.1-0.7C73.7,46.4,73,46.2,72.6,46.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_985_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1543_",
    className: "st3",
    d: "M71.7,52.4c0,0-2.5-0.3-4.4-2.7c-1.8-2.4,1.3-0.9,1.3-0.9s2,0.7,2.1,0.7 c0.1,0,1,1.1,1,1.3S71.7,52.4,71.7,52.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1545_",
    className: "st2",
    d: "M71.8,52.5l-0.1,0c0,0-2.6-0.3-4.5-2.8c-0.6-0.7-0.7-1.2-0.5-1.4 c0.3-0.4,1.7,0.2,1.9,0.4c0.8,0.3,2,0.7,2.1,0.7c0.2,0,1,1.2,1,1.4c0,0.1,0.1,1.6,0.1,1.6L71.8,52.5z M67,48.4 c-0.1,0-0.2,0-0.2,0.1c0,0-0.1,0.3,0.5,1.1c1.6,2.1,3.7,2.6,4.2,2.7c0-0.4-0.1-1.4-0.1-1.5c0-0.1-0.8-1.1-0.9-1.2 c-0.1,0-1.9-0.6-2.1-0.7C68.1,48.7,67.4,48.4,67,48.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_726_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_737_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1539_",
    className: "st3",
    d: "M73.1,48L73.1,48c-0.3,0-0.7,0.2-1.1,0.5c-1.2,0.9-1.9,2.8-1.8,4.2 c0.1,0.6,0.3,1,0.6,1.2c0,0,0.7,0.7,2.3,1c1.6,0.3,1.9-4.2,1.9-4.2l0.6-1.8C75.6,49,74.6,47.9,73.1,48z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1540_",
    className: "st2",
    d: "M73.3,55.1c-0.1,0-0.1,0-0.2,0c-1.6-0.3-2.3-1-2.4-1c-0.3-0.3-0.5-0.7-0.6-1.3 c-0.2-1.5,0.6-3.5,1.8-4.4c0.4-0.3,0.8-0.5,1.1-0.5c1.5-0.1,2.5,1,2.6,1l0.1,0.1l-0.6,1.8c0,0.3-0.3,3.3-1.3,4.1 C73.7,55,73.5,55.1,73.3,55.1z M73.3,48.1c-0.1,0-0.1,0-0.2,0l0,0c-0.3,0-0.7,0.2-1,0.4c-1.1,0.9-1.9,2.7-1.7,4.1 c0.1,0.5,0.2,0.9,0.5,1.1c0,0,0.7,0.7,2.2,1c0.2,0,0.4,0,0.5-0.1c1-0.8,1.2-3.9,1.2-3.9l0,0l0.6-1.7 C75.2,48.8,74.4,48.1,73.3,48.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_735_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1535_",
    className: "st2",
    d: "M76.2,50.3c0.2,1.5-0.6,3.4-1.8,4.2s-2.2,0.4-2.4-1c-0.2-1.5,0.6-3.4,1.8-4.2 C74.9,48.3,76,48.8,76.2,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1536_",
    className: "st2",
    d: "M73.3,55.1c-0.2,0-0.3,0-0.5-0.1c-0.5-0.2-0.8-0.7-0.9-1.5c-0.2-1.5,0.6-3.5,1.8-4.4 c0.6-0.5,1.2-0.6,1.7-0.4c0.5,0.2,0.8,0.7,0.9,1.5v0c0.2,1.5-0.6,3.5-1.8,4.4C74.1,54.9,73.7,55.1,73.3,55.1z M74.9,48.9 c-0.3,0-0.7,0.1-1,0.4c-1.1,0.9-1.9,2.7-1.7,4.1c0.1,0.7,0.4,1.1,0.8,1.3c0.4,0.2,0.9,0,1.4-0.3c1.1-0.9,1.9-2.7,1.7-4.1 c-0.1-0.7-0.4-1.1-0.8-1.3C75.2,48.9,75,48.9,74.9,48.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_730_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_734_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1531_",
    className: "st3",
    d: "M75.5,50.7c0.1,1-0.4,2.3-1.2,3c-0.8,0.6-1.6,0.3-1.7-0.7c-0.1-1,0.4-2.3,1.2-3 C74.7,49.4,75.4,49.7,75.5,50.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1532_",
    className: "st3",
    d: "M73.5,54.1c-0.1,0-0.2,0-0.3-0.1c-0.4-0.1-0.6-0.5-0.7-1.1c-0.1-1,0.4-2.4,1.3-3 c0.4-0.3,0.8-0.4,1.2-0.3c0.4,0.1,0.6,0.5,0.7,1.1c0.1,1-0.4,2.4-1.3,3C74.1,54,73.8,54.1,73.5,54.1z M74.7,49.8 c-0.2,0-0.5,0.1-0.7,0.3c-0.8,0.6-1.3,1.9-1.2,2.9c0.1,0.5,0.2,0.8,0.5,0.9c0.3,0.1,0.6,0,1-0.2c0.8-0.6,1.3-1.9,1.2-2.9 c-0.1-0.5-0.2-0.8-0.5-0.9C74.8,49.8,74.7,49.8,74.7,49.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_733_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1527_",
    className: "st2",
    d: "M75.1,50.6c-0.1-0.4-0.2-0.8-0.5-0.9c-0.2,0-0.5,0.1-0.8,0.3c-0.8,0.6-1.4,1.9-1.2,3 c0.1,0.4,0.2,0.8,0.5,0.9c0.2,0,0.5-0.1,0.8-0.3C74.7,53,75.2,51.6,75.1,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1528_",
    className: "st3",
    d: "M73.1,54L73.1,54c-0.3-0.2-0.5-0.5-0.5-1c-0.1-1,0.4-2.4,1.3-3 c0.3-0.2,0.6-0.3,0.8-0.3l0,0l0,0c0.3,0.2,0.5,0.5,0.5,1l0,0c0.1,1-0.4,2.4-1.3,3C73.7,53.9,73.4,54,73.1,54L73.1,54z  M74.6,49.8c-0.2,0-0.4,0.1-0.7,0.3c-0.8,0.6-1.3,1.9-1.2,2.9c0,0.4,0.2,0.7,0.4,0.8c0.2,0,0.4-0.1,0.7-0.3 c0.8-0.6,1.3-1.9,1.2-2.9C75,50.3,74.8,50,74.6,49.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_727_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_729_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1479_",
    className: "st3",
    d: "M74.8,51L74.8,51c-0.3-0.2-0.5-0.2-0.8,0c-0.4,0.3-0.7,1-0.6,1.5 c0,0.3,0.2,0.5,0.4,0.5l0.1,0l0.4,0l0.4-0.6l0.4-1.2L74.8,51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1480_",
    className: "st3",
    d: "M74.4,53.2l-0.6-0.1c-0.3,0-0.5-0.3-0.5-0.6c-0.1-0.6,0.2-1.3,0.7-1.6 c0.3-0.2,0.6-0.2,0.8,0l0.4,0.4l-0.4,1.3L74.4,53.2z M74.4,50.9c-0.1,0-0.2,0-0.3,0.1c-0.4,0.3-0.7,1-0.6,1.5 c0,0.3,0.2,0.4,0.3,0.4l0.1,0l0.4,0l0.3-0.5l0.4-1.2L74.6,51C74.6,50.9,74.5,50.9,74.4,50.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_728_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1473_",
    className: "st2",
    d: "M75.3,51.6c0.1,0.4-0.2,1-0.5,1.3c-0.4,0.3-0.7,0.1-0.7-0.3c-0.1-0.4,0.2-1,0.5-1.3 C74.9,51.1,75.2,51.2,75.3,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1474_",
    className: "st3",
    d: "M74.4,53.2c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.3-0.3-0.3-0.5c-0.1-0.5,0.2-1.1,0.6-1.4 c0.2-0.2,0.4-0.2,0.6-0.1c0.2,0.1,0.3,0.3,0.3,0.5l0,0c0.1,0.5-0.2,1.1-0.6,1.4C74.6,53.1,74.5,53.2,74.4,53.2z M74.9,51.3 c-0.1,0-0.2,0-0.3,0.1c-0.3,0.3-0.6,0.8-0.5,1.2c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.4-0.1c0.3-0.3,0.6-0.8,0.5-1.2l0,0 C75.1,51.5,75.1,51.4,74.9,51.3C74.9,51.3,74.9,51.3,74.9,51.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_396_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_725_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1468_",
    className: "st3",
    d: "M68.1,51L68.1,51c-0.3,0-0.7,0.2-1.1,0.5c-1.2,0.9-1.9,2.8-1.8,4.2 c0.1,0.6,0.3,1,0.6,1.2c0,0,0.7,0.7,2.3,1c1.6,0.3,1.9-4.2,1.9-4.2l0.6-1.8C70.6,51.9,69.6,50.9,68.1,51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1469_",
    className: "st2",
    d: "M68.3,58c-0.1,0-0.1,0-0.2,0c-1.6-0.3-2.3-1-2.4-1c-0.3-0.3-0.5-0.7-0.6-1.3 c-0.2-1.5,0.6-3.5,1.8-4.4c0.4-0.3,0.8-0.5,1.1-0.5c1.5-0.1,2.5,1,2.6,1l0.1,0.1l-0.6,1.8c0,0.3-0.3,3.3-1.3,4.1 C68.6,58,68.5,58,68.3,58z M68.3,51.1c-0.1,0-0.1,0-0.2,0l0,0c-0.3,0-0.7,0.2-1,0.4c-1.1,0.9-1.9,2.7-1.7,4.1 c0.1,0.5,0.2,0.9,0.5,1.1c0,0,0.7,0.7,2.2,1c0.2,0,0.4,0,0.5-0.1c1-0.8,1.2-3.9,1.2-3.9l0,0l0.6-1.7 C70.2,51.8,69.4,51.1,68.3,51.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_668_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1462_",
    className: "st2",
    d: "M71.2,53.2c0.2,1.5-0.6,3.4-1.8,4.2c-1.2,0.9-2.2,0.4-2.4-1c-0.2-1.5,0.6-3.4,1.8-4.2 C69.9,51.3,71,51.7,71.2,53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1464_",
    className: "st2",
    d: "M68.3,58c-0.2,0-0.3,0-0.5-0.1c-0.5-0.2-0.8-0.7-0.9-1.5c-0.2-1.5,0.6-3.5,1.8-4.4 c0.6-0.5,1.2-0.6,1.7-0.4c0.5,0.2,0.8,0.7,0.9,1.5v0c0.2,1.5-0.6,3.5-1.8,4.4C69.1,57.9,68.7,58,68.3,58z M69.9,51.8 c-0.3,0-0.7,0.1-1,0.4c-1.1,0.9-1.9,2.7-1.7,4.1c0.1,0.7,0.4,1.1,0.8,1.3c0.4,0.2,0.9,0,1.4-0.3c1.1-0.9,1.9-2.7,1.7-4.1v0 c-0.1-0.7-0.4-1.1-0.8-1.3C70.1,51.9,70,51.8,69.9,51.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_664_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_667_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1353_",
    className: "st3",
    d: "M70.5,53.7c0.1,1-0.4,2.3-1.2,3c-0.8,0.6-1.6,0.3-1.7-0.7c-0.1-1,0.4-2.3,1.2-3 C69.7,52.4,70.4,52.7,70.5,53.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1456_",
    className: "st3",
    d: "M68.5,57.1c-0.1,0-0.2,0-0.3-0.1c-0.4-0.1-0.6-0.5-0.7-1.1c-0.1-1,0.4-2.4,1.3-3 c0.4-0.3,0.8-0.4,1.2-0.3c0.4,0.1,0.6,0.5,0.7,1.1l0,0c0.1,1-0.4,2.4-1.3,3C69.1,56.9,68.8,57.1,68.5,57.1z M69.6,52.8 c-0.2,0-0.5,0.1-0.7,0.3c-0.8,0.6-1.3,1.9-1.2,2.9c0.1,0.5,0.2,0.8,0.5,0.9c0.3,0.1,0.6,0,1-0.2c0.8-0.6,1.3-1.9,1.2-2.9 l0,0c-0.1-0.5-0.2-0.8-0.5-0.9C69.8,52.8,69.7,52.8,69.6,52.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_666_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1349_",
    className: "st2",
    d: "M70.1,53.6c-0.1-0.4-0.2-0.8-0.5-0.9c-0.2,0-0.5,0.1-0.8,0.3c-0.8,0.6-1.4,1.9-1.2,3 c0.1,0.4,0.2,0.8,0.5,0.9c0.2,0,0.5-0.1,0.8-0.3C69.7,55.9,70.2,54.6,70.1,53.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1350_",
    className: "st3",
    d: "M68.1,56.9L68.1,56.9c-0.3-0.2-0.5-0.5-0.5-1c-0.1-1,0.4-2.4,1.3-3 c0.3-0.2,0.6-0.3,0.8-0.3l0,0l0,0c0.3,0.2,0.5,0.5,0.5,1c0.1,1-0.4,2.4-1.3,3C68.6,56.8,68.4,56.9,68.1,56.9L68.1,56.9z  M69.6,52.8c-0.2,0-0.4,0.1-0.7,0.3c-0.8,0.6-1.3,1.9-1.2,2.9c0,0.4,0.2,0.7,0.4,0.8c0.2,0,0.4-0.1,0.7-0.3 c0.8-0.6,1.3-1.9,1.2-2.9l0,0C69.9,53.2,69.8,52.9,69.6,52.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_399_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_663_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1345_",
    className: "st3",
    d: "M69.8,53.9L69.8,53.9c-0.3-0.2-0.5-0.2-0.8,0c-0.4,0.3-0.7,1-0.6,1.5 c0,0.3,0.2,0.5,0.4,0.5l0.1,0l0.4,0l0.4-0.6l0.4-1.2L69.8,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1346_",
    className: "st3",
    d: "M69.4,56.1l-0.6-0.1c-0.3,0-0.5-0.3-0.5-0.6c-0.1-0.6,0.2-1.3,0.7-1.6 c0.3-0.2,0.6-0.2,0.8,0l0.4,0.4l-0.4,1.3L69.4,56.1z M69.4,53.8c-0.1,0-0.2,0-0.3,0.1c-0.4,0.3-0.7,1-0.6,1.5 c0,0.3,0.2,0.4,0.3,0.4l0.1,0l0.4,0l0.3-0.5l0.4-1.2l-0.3-0.3C69.6,53.9,69.5,53.8,69.4,53.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_428_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1341_",
    className: "st2",
    d: "M70.2,54.6c0.1,0.4-0.2,1-0.5,1.3C69.3,56.2,69,56,69,55.6c-0.1-0.4,0.2-1,0.5-1.3 C69.9,54,70.2,54.2,70.2,54.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1342_",
    className: "st3",
    d: "M69.3,56.1c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.3-0.3-0.3-0.5c-0.1-0.5,0.2-1.1,0.6-1.4 c0.2-0.2,0.4-0.2,0.6-0.1c0.2,0.1,0.3,0.3,0.3,0.5c0.1,0.5-0.2,1.1-0.6,1.4C69.6,56.1,69.5,56.1,69.3,56.1z M69.8,54.2 c-0.1,0-0.2,0-0.3,0.1c-0.3,0.3-0.6,0.8-0.5,1.2c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.4-0.1c0.3-0.3,0.6-0.8,0.5-1.2 C70.1,54.4,70,54.3,69.8,54.2C69.9,54.2,69.9,54.2,69.8,54.2z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_991_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1336_",
    className: "st3",
    d: "M65.8,40.8c-0.7-0.4-1.7-0.4-2.8,0.2l-5,2.9c-2.1,1.2-3.9,4.2-3.9,6.7l0,0 c0,0.1,0.1,0.2,0.1,0.3l11.1,6.2l0.2-0.8l0.5-2.1l2.3-3l2.8-1.9l4.1-1.9l1.5-0.4c0,0,0,0,0-0.1L65.8,40.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1337_",
    className: "st2",
    d: "M65.4,57.3L54.2,51c-0.1,0-0.2-0.2-0.2-0.4l0,0c0-2.5,1.8-5.5,3.9-6.8l5-2.9 c1.1-0.6,2.1-0.7,2.9-0.2l11,6.2c0,0,0.1,0.1,0.1,0.1c0,0.1,0,0.1-0.1,0.1l-1.5,0.4l-4.1,1.9l-2.7,1.9l-2.3,3L65.4,57.3z  M64.7,40.6c-0.5,0-1.1,0.2-1.7,0.5l-5,2.9c-2.1,1.2-3.8,4.2-3.8,6.6l0,0c0,0,0,0.1,0.1,0.2l11,6.2l0.7-2.8l2.4-3.1l2.8-1.9 l4.2-1.9l1.4-0.3l-10.9-6.1C65.4,40.7,65.1,40.6,64.7,40.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_982_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1330_",
    className: "st4",
    d: "M58,43.9c0,0-0.1,0-0.1,0.1c-1.5,1-2.9,2.8-3.4,4.7l11.3,6.5l0.1-0.1l0.2-0.8l2.3-3 l2.8-1.9l2-0.9l1-1.1L63,41L58,43.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1331_",
    className: "st2",
    d: "M65.8,55.3l-11.5-6.6l0-0.1c0.6-1.9,2-3.8,3.5-4.8c0.1,0,0.1-0.1,0.1-0.1l5-2.9l0.1,0 l11.2,6.3l-1.1,1.3l-2,0.9l-2.7,1.9l-2.3,3l-0.2,0.8L65.8,55.3z M54.6,48.6L65.7,55l0,0l0.2-0.8l2.4-3.1l2.8-1.9l2-0.9l0.9-1 L63,41.1L58.1,44c0,0-0.1,0.1-0.1,0.1C56.5,45,55.2,46.8,54.6,48.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_698_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_372_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1322_",
    className: "st2",
    d: "M77.9,49.5c0-2.5-1.7-3.5-3.9-2.2l-5,2.9c-2.1,1.2-3.9,4.2-3.9,6.7l0,0 c0,0.2,0.2,0.3,0.4,0.2l0,0c0.2-0.1,0.4-0.4,0.4-0.6l0-0.1c0-2,1.4-4.4,3.1-5.4l5-2.9c1.7-1,3.1-0.2,3.1,1.8l0,0.1 c0,0.2,0.2,0.3,0.4,0.2l0,0C77.8,50,77.9,49.7,77.9,49.5L77.9,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1326_",
    className: "st2",
    d: "M65.4,57.2c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.2-0.2-0.2-0.3l0,0c0-2.5,1.8-5.5,3.9-6.8 l5-2.9c1.1-0.6,2.1-0.7,2.8-0.3c0.8,0.4,1.2,1.4,1.2,2.6l0,0c0,0.3-0.2,0.6-0.4,0.7c-0.1,0.1-0.3,0.1-0.4,0 c-0.1-0.1-0.2-0.2-0.2-0.3l0-0.1c0-0.9-0.3-1.6-0.9-1.9c-0.6-0.3-1.3-0.2-2.1,0.2l-5,2.9c-1.7,1-3.1,3.4-3.1,5.3l0,0.1 c0,0.3-0.2,0.6-0.4,0.7C65.6,57.2,65.5,57.2,65.4,57.2z M75.8,46.8c-0.5,0-1.1,0.2-1.7,0.5l-5,2.9c-2.1,1.2-3.8,4.2-3.8,6.6 l0,0c0,0.1,0,0.1,0.1,0.2c0,0,0.1,0,0.2,0c0.2-0.1,0.3-0.3,0.3-0.6l0-0.1c0-2,1.4-4.5,3.2-5.5l5-2.9 c0.9-0.5,1.7-0.6,2.3-0.2c0.6,0.4,1,1.1,1,2.1l0,0.1c0,0.1,0,0.1,0.1,0.1c0,0,0.1,0,0.2,0c0.2-0.1,0.3-0.4,0.3-0.6l0,0 c0-1.1-0.4-2-1.1-2.4C76.5,46.9,76.1,46.8,75.8,46.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_674_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1324_",
    className: "st3",
    d: "M77.7,49.8h-0.2c0-1.7-0.9-2.3-0.9-2.3l0.1-0.2C76.8,47.3,77.7,48,77.7,49.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_673_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1323_",
    className: "st3",
    d: "M65.9,55.5l-0.2,0c0,0,0.2-1,0.6-1.7l0.2,0.1C66,54.6,65.9,55.5,65.9,55.5z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_715_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_981_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1318_",
    className: "st3",
    d: "M53,47.1c-0.1-0.1-0.2-0.1-0.3,0l-7.9,4.6c-0.2,0.1-0.4,0.5-0.4,0.7v3.5 c0,0.2,0.1,0.3,0.1,0.3l0,0l11.1,6.2l8.5-9.1L53,47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1319_",
    className: "st2",
    d: "M55.7,62.5l-11.1-6.3c-0.1-0.1-0.2-0.2-0.2-0.4v-3.5c0-0.3,0.2-0.7,0.4-0.8l7.9-4.6 c0.1-0.1,0.3-0.1,0.4,0l11.2,6.3L55.7,62.5z M52.9,47.1c0,0-0.1,0-0.1,0l-7.9,4.6c-0.2,0.1-0.3,0.4-0.3,0.7v3.5 c0,0.1,0,0.2,0.1,0.2l11,6.2l8.3-8.9L52.9,47.1C52.9,47.1,52.9,47.1,52.9,47.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_983_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1314_",
    className: "st4",
    d: "M58.2,59.7l4.2-4.5l0.7-1.2l-11.2-6.4l-7.1,4.1c-0.1,0.1-0.3,0.3-0.3,0.5L58.2,59.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1315_",
    className: "st2",
    d: "M58.2,59.8L58.2,59.8l-13.8-7.6l0-0.1c0.1-0.2,0.2-0.4,0.4-0.5l7.1-4.1L63.3,54 l-0.8,1.3L58.2,59.8z M44.6,52.1l13.5,7.5l4.2-4.5L63,54l-11.1-6.3l-7,4.1C44.8,51.8,44.7,52,44.6,52.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_979_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1312_",
    className: "st4",
    d: "M45.2,51.5l11.1,6.2L45.2,51.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1313_",
    x: 50.6,
    y: 48.2,
    transform: "matrix(0.488 -0.8728 0.8728 0.488 -21.6664 72.2203)",
    className: "st2",
    width: 0.2,
    height: 12.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_980_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1310_",
    className: "st4",
    d: "M44.5,53.2l11.1,6.2L44.5,53.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1311_",
    x: 49.9,
    y: 50,
    transform: "matrix(0.488 -0.8728 0.8728 0.488 -23.5339 72.4972)",
    className: "st2",
    width: 0.2,
    height: 12.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_699_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_361_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1302_",
    className: "st2",
    d: "M63.8,57.8l-7.9,4.6c-0.2,0.1-0.4,0-0.4-0.3v-3.5c0-0.3,0.2-0.6,0.4-0.7l7.9-4.6 c0.2-0.1,0.4,0,0.4,0.3v3.5C64.2,57.4,64,57.7,63.8,57.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1307_",
    className: "st2",
    d: "M55.8,62.5c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.2-0.2-0.2-0.4v-3.5c0-0.3,0.2-0.7,0.4-0.8 l7.9-4.6c0.1-0.1,0.3-0.1,0.4,0c0.1,0.1,0.2,0.2,0.2,0.4v3.5c0,0.3-0.2,0.7-0.4,0.8L56,62.5C55.9,62.5,55.8,62.5,55.8,62.5z  M64,53.4c0,0-0.1,0-0.1,0L56,58c-0.2,0.1-0.3,0.4-0.3,0.7v3.5c0,0.1,0,0.2,0.1,0.2c0,0,0.1,0,0.2,0l7.9-4.6 c0.2-0.1,0.3-0.4,0.3-0.7v-3.5C64.1,53.5,64.1,53.4,64,53.4C64,53.4,64,53.4,64,53.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_381_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1304_",
    className: "st3",
    d: "M56.3,61.5C56.2,61.5,56.2,61.5,56.3,61.5c-0.2-0.1-0.2-0.1-0.2-0.2v-2.6 c0-0.1,0.1-0.3,0.2-0.4l7.1-4.1c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.2V57c0,0.1-0.1,0.3-0.2,0.3l-7.1,4.1 C56.4,61.5,56.3,61.5,56.3,61.5z M63.5,54.4l-7.1,4.1c-0.1,0-0.1,0.1-0.1,0.2v2.6c0,0,0,0,0,0c0,0,0,0,0,0l7.1-4.1 c0,0,0.1-0.1,0.1-0.2V54.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_383_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1303_",
    className: "st3",
    d: "M56.7,61.2C56.7,61.2,56.7,61.2,56.7,61.2c-0.2-0.1-0.2-0.1-0.2-0.2v-2.6 c0-0.1,0.1-0.3,0.2-0.4l6.1-3.5l0.1,0.2l-6.1,3.5c-0.1,0-0.1,0.1-0.1,0.2V61c0,0,0,0,0,0c0,0,0,0,0,0l6.1-3.5l0.1,0.2 l-6.1,3.5C56.8,61.2,56.8,61.2,56.7,61.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_392_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1298_",
    className: "st2",
    d: "M58.8,60.2l-0.7,0.4c-0.1,0-0.1,0-0.1-0.1v-0.2c0-0.1,0.1-0.2,0.1-0.2l0.7-0.4 c0.1,0,0.1,0,0.1,0.1V60C58.9,60.1,58.9,60.2,58.8,60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1299_",
    className: "st3",
    d: "M58.1,60.7C58,60.7,58,60.7,58.1,60.7c-0.1-0.1-0.2-0.1-0.2-0.2v-0.2 c0-0.1,0.1-0.3,0.2-0.3l0.7-0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.2V60c0,0.1-0.1,0.3-0.2,0.3L58.1,60.7 C58.1,60.7,58.1,60.7,58.1,60.7z M58.8,59.8l-0.7,0.4c0,0-0.1,0.1-0.1,0.1v0.2l0.7-0.4c0,0,0.1-0.1,0.1-0.1V59.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_393_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1294_",
    className: "st2",
    d: "M60.4,59.3l-0.7,0.4c-0.1,0-0.1,0-0.1-0.1v-0.2c0-0.1,0.1-0.2,0.1-0.2l0.7-0.4 c0.1,0,0.1,0,0.1,0.1v0.2C60.5,59.2,60.4,59.3,60.4,59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1295_",
    className: "st3",
    d: "M59.6,59.8C59.6,59.8,59.6,59.8,59.6,59.8c-0.1-0.1-0.2-0.1-0.2-0.2v-0.2 c0-0.1,0.1-0.3,0.2-0.3l0.7-0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.2v0.2c0,0.1-0.1,0.3-0.2,0.3l-0.1-0.1l0.1,0.1 L59.6,59.8C59.7,59.8,59.7,59.8,59.6,59.8z M60.4,58.9l-0.7,0.4c0,0-0.1,0.1-0.1,0.1v0.2l0.7-0.4c0,0,0.1-0.1,0.1-0.1V58.9z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_394_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1290_",
    className: "st2",
    d: "M61.9,58.4l-0.7,0.4c-0.1,0-0.1,0-0.1-0.1v-0.2c0-0.1,0.1-0.2,0.1-0.2l0.7-0.4 c0.1,0,0.1,0,0.1,0.1v0.2C62,58.3,62,58.4,61.9,58.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1291_",
    className: "st3",
    d: "M61.2,58.9C61.2,58.9,61.1,58.9,61.2,58.9c-0.1-0.1-0.2-0.1-0.2-0.2v-0.2 c0-0.1,0.1-0.3,0.2-0.3l0.7-0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.2v0.2c0,0.1-0.1,0.3-0.2,0.3L61.2,58.9 C61.3,58.9,61.2,58.9,61.2,58.9z M61.9,58l-0.7,0.4c0,0-0.1,0.1-0.1,0.1v0.2l0.7-0.4c0,0,0.1-0.1,0.1-0.1V58z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_717_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_994_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1286_",
    className: "st4",
    d: "M70.4,37.1L70.4,37.1c-0.1,0-0.2,0-0.3,0l-1.9,1.1c-0.2,0.1-0.4,0.5-0.4,0.7l0,0 c0,0.1,0,0.2,0.1,0.3l0,0l0,0c0,0,0,0,0,0l1.2,0.7c0,0.1,0.1,0.2,0.1,0.2l11.1,6.2l0.9-1.8l0.2-1.3L70.4,37.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1287_",
    className: "st2",
    d: "M80.4,46.6l-11.2-6.3c-0.1,0-0.2-0.1-0.2-0.3l-1.1-0.7c-0.1-0.1-0.2-0.2-0.2-0.4 c0-0.3,0.2-0.7,0.5-0.8l1.9-1.1c0.1-0.1,0.2-0.1,0.3-0.1l0,0l0.1,0l11.1,6.3l-0.3,1.4L80.4,46.6z M70.3,37.2c0,0-0.1,0-0.1,0 l-1.9,1.1c-0.2,0.1-0.4,0.4-0.4,0.6c0,0.1,0,0.2,0.1,0.2l1.2,0.8l0,0.1c0,0,0,0.1,0.1,0.2l11,6.2l0.9-1.7l0.2-1.2l-11-6.2 l0,0L70.3,37.2C70.4,37.2,70.3,37.2,70.3,37.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1001_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1282_",
    className: "st3",
    d: "M80.9,45.3l-12.6-7.1l0,0c-0.2,0.1-0.4,0.5-0.4,0.7l0,0c0,0.1,0,0.2,0.1,0.3 c0,0,0,0,0,0l1.2,0.7c0,0.1,0.1,0.2,0.1,0.2l11.1,6.2L80.9,45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1283_",
    className: "st2",
    d: "M80.4,46.6l-11.2-6.3c-0.1,0-0.2-0.1-0.2-0.3l-1.1-0.7c-0.1-0.1-0.2-0.2-0.2-0.4 c0-0.3,0.2-0.7,0.5-0.8l0.1-0.1L81,45.3L80.4,46.6z M68.3,38.3c-0.2,0.1-0.4,0.4-0.4,0.6c0,0.1,0,0.2,0.1,0.2l1.2,0.8l0,0.1 c0,0,0,0.1,0.1,0.2l11,6.2l0.5-1L68.3,38.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_700_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_375_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1277_",
    className: "st2",
    d: "M78.9,45.2L78.9,45.2c0,0.3,0.2,0.4,0.4,0.2l0,0c0.5-0.3,0.9-0.1,0.9,0.5v0.2 c0,0.3,0.2,0.4,0.4,0.2l0.6-0.3c0.2-0.1,0.4-0.5,0.4-0.7v-1.2v-0.5l0,0c0-0.3-0.2-0.4-0.4-0.2l-1.9,1.1 C79.1,44.6,78.9,44.9,78.9,45.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1279_",
    className: "st2",
    d: "M80.4,46.6c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.2-0.2-0.2-0.4V46c0-0.2-0.1-0.4-0.2-0.5 c-0.1-0.1-0.3-0.1-0.5,0.1c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.1-0.2-0.2-0.2-0.4c0-0.3,0.2-0.7,0.5-0.8l1.9-1.1 c0.1-0.1,0.3-0.1,0.4,0c0.1,0.1,0.2,0.2,0.2,0.4v1.7c0,0.3-0.2,0.7-0.5,0.8l-0.6,0.3C80.6,46.6,80.5,46.6,80.4,46.6z  M79.7,45.2c0.1,0,0.2,0,0.3,0.1c0.2,0.1,0.3,0.3,0.3,0.7v0.2c0,0.1,0,0.2,0.1,0.2c0,0,0.1,0,0.2,0l0.6-0.3 c0.2-0.1,0.4-0.4,0.4-0.6v-1.7c0-0.1,0-0.2-0.1-0.2c0,0-0.1,0-0.2,0l-1.9,1.1C79.2,44.7,79,45,79,45.2c0,0.1,0,0.2,0.1,0.2 c0,0,0.1,0,0.2,0C79.4,45.3,79.6,45.2,79.7,45.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_384_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1278_",
    x: 79.7,
    y: 44.4,
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -11.4678 46.2385)",
    className: "st3",
    width: 1.8,
    height: 0.2
  })))))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_333_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_984_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1273_",
    className: "st3",
    d: "M54,63.5c0,0-2.5-0.3-4.4-2.7s1.3-0.9,1.3-0.9s2,0.7,2.1,0.7c0.1,0,1,1.1,1,1.3 C54,62,54,63.5,54,63.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1274_",
    className: "st2",
    d: "M54.1,63.7l-0.1,0c0,0-2.6-0.3-4.5-2.8c-0.6-0.7-0.7-1.2-0.5-1.4 c0.3-0.4,1.7,0.2,1.9,0.4c0.8,0.3,2,0.7,2.1,0.7c0.2,0,1,1.2,1,1.4c0,0.1,0.1,1.6,0.1,1.6L54.1,63.7z M49.4,59.5 c-0.1,0-0.2,0-0.2,0.1c0,0-0.1,0.3,0.5,1.1c1.6,2.1,3.7,2.6,4.2,2.7c0-0.4-0.1-1.4-0.1-1.5c0-0.1-0.8-1.1-0.9-1.2 c-0.1,0-1.9-0.6-2.1-0.7C50.4,59.8,49.7,59.5,49.4,59.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_675_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_683_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1269_",
    className: "st3",
    d: "M49.8,61.5L49.8,61.5c-0.3,0-0.7,0.2-1.1,0.5c-1.2,0.9-1.9,2.8-1.8,4.2 c0.1,0.6,0.3,1,0.6,1.2c0,0,0.7,0.7,2.3,1c1.6,0.3,1.9-4.2,1.9-4.2l0.6-1.8C52.3,62.4,51.3,61.3,49.8,61.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1270_",
    className: "st2",
    d: "M50,68.5c-0.1,0-0.1,0-0.2,0c-1.6-0.3-2.3-1-2.4-1c-0.3-0.3-0.5-0.7-0.6-1.3 c-0.2-1.5,0.6-3.5,1.8-4.4c0.4-0.3,0.8-0.5,1.1-0.5c1.5-0.1,2.5,1,2.6,1l0.1,0.1l-0.6,1.8c0,0.3-0.3,3.3-1.3,4.1 C50.4,68.4,50.2,68.5,50,68.5z M50,61.6c-0.1,0-0.1,0-0.2,0l0,0c-0.3,0-0.7,0.2-1,0.4c-1.1,0.9-1.9,2.7-1.7,4.1 c0.1,0.5,0.2,0.9,0.5,1.1c0,0,0.7,0.7,2.2,1c0.2,0,0.4,0,0.5-0.1c1-0.8,1.2-3.9,1.2-3.9l0,0l0.6-1.7 C51.9,62.3,51.1,61.6,50,61.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_681_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1265_",
    className: "st2",
    d: "M52.9,63.7c0.2,1.5-0.6,3.4-1.8,4.2c-1.2,0.9-2.2,0.4-2.4-1c-0.2-1.5,0.6-3.4,1.8-4.2 C51.6,61.8,52.7,62.2,52.9,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1266_",
    className: "st2",
    d: "M50,68.5c-0.2,0-0.3,0-0.5-0.1c-0.5-0.2-0.8-0.7-0.9-1.5c-0.2-1.5,0.6-3.5,1.8-4.4 c0.6-0.5,1.2-0.6,1.7-0.4c0.5,0.2,0.8,0.7,0.9,1.5l0,0c0.2,1.5-0.6,3.5-1.8,4.4C50.8,68.3,50.4,68.5,50,68.5z M51.6,62.3 c-0.3,0-0.7,0.1-1,0.4c-1.1,0.9-1.9,2.7-1.7,4.1c0.1,0.7,0.4,1.1,0.8,1.3c0.4,0.2,0.9,0,1.4-0.3c1.1-0.9,1.9-2.7,1.7-4.1 c-0.1-0.7-0.4-1.1-0.8-1.3C51.9,62.4,51.7,62.3,51.6,62.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_678_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_680_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1261_",
    className: "st3",
    d: "M52.2,64.2c0.1,1-0.4,2.3-1.2,3c-0.8,0.6-1.6,0.3-1.7-0.7c-0.1-1,0.4-2.3,1.2-3 C51.4,62.8,52.1,63.2,52.2,64.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1262_",
    className: "st3",
    d: "M50.2,67.5c-0.1,0-0.2,0-0.3-0.1c-0.4-0.1-0.6-0.5-0.7-1.1c-0.1-1,0.4-2.4,1.3-3 c0.4-0.3,0.8-0.4,1.2-0.3c0.4,0.1,0.6,0.5,0.7,1.1l0,0c0.1,1-0.4,2.4-1.3,3C50.8,67.4,50.5,67.5,50.2,67.5z M51.3,63.2 c-0.2,0-0.5,0.1-0.7,0.3c-0.8,0.6-1.3,1.9-1.2,2.9c0.1,0.5,0.2,0.8,0.5,0.9c0.3,0.1,0.6,0,1-0.2c0.8-0.6,1.3-1.9,1.2-2.9 l0,0c-0.1-0.5-0.2-0.8-0.5-0.9C51.5,63.3,51.4,63.2,51.3,63.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_679_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1257_",
    className: "st2",
    d: "M51.8,64.1c-0.1-0.4-0.2-0.8-0.5-0.9c-0.2,0-0.5,0.1-0.8,0.3c-0.8,0.6-1.4,1.9-1.2,3 c0.1,0.4,0.2,0.8,0.5,0.9c0.2,0,0.5-0.1,0.8-0.3C51.4,66.4,51.9,65.1,51.8,64.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1258_",
    className: "st3",
    d: "M49.8,67.4L49.8,67.4c-0.3-0.2-0.5-0.5-0.5-1c-0.1-1,0.4-2.4,1.3-3 c0.3-0.2,0.6-0.3,0.8-0.3l0,0l0,0c0.3,0.2,0.5,0.5,0.5,1l0,0c0.1,1-0.4,2.4-1.3,3C50.4,67.3,50.1,67.4,49.8,67.4L49.8,67.4z  M51.3,63.2c-0.2,0-0.4,0.1-0.7,0.3c-0.8,0.6-1.3,1.9-1.2,2.9c0,0.4,0.2,0.7,0.4,0.8c0.2,0,0.4-0.1,0.7-0.3 c0.8-0.6,1.3-1.9,1.2-2.9l0,0C51.7,63.7,51.5,63.4,51.3,63.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_676_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_677_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1253_",
    className: "st2",
    d: "M50.9,64.7c0.1,0.4-0.2,1-0.5,1.3c-0.4,0.3-0.7,0.1-0.7-0.3c-0.1-0.4,0.2-1,0.5-1.3 C50.5,64.1,50.8,64.2,50.9,64.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1254_",
    className: "st3",
    d: "M50,66.2c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.3-0.3-0.3-0.5c-0.1-0.5,0.2-1.1,0.6-1.4 c0.2-0.2,0.4-0.2,0.6-0.1c0.2,0.1,0.3,0.3,0.3,0.5c0.1,0.5-0.2,1.1-0.6,1.4C50.3,66.1,50.1,66.2,50,66.2z M50.5,64.3 c-0.1,0-0.2,0-0.3,0.1c-0.3,0.3-0.6,0.8-0.5,1.2c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.4-0.1c0.3-0.3,0.6-0.8,0.5-1.2 C50.8,64.5,50.7,64.4,50.5,64.3C50.6,64.3,50.5,64.3,50.5,64.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_883_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_888_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1249_",
    className: "st3",
    d: "M12.4,59.6l-0.8-0.4c0,0-0.1,0-0.1,0l-0.4,0.2c0,0,0,0,0,0l1,1.2c0,0,0,0,0,0l0.4-0.2 l0,0c0,0,0.1-0.1,0.1-0.2V60C12.6,59.8,12.5,59.6,12.4,59.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1250_",
    className: "st2",
    d: "M12.1,60.7L12.1,60.7L11,59.4l0-0.1l0,0l0.4-0.2c0.1,0,0.1,0,0.2,0l0.8,0.4 c0.1,0.1,0.2,0.3,0.2,0.5v0.3c0,0.1,0,0.2-0.1,0.2L12.1,60.7z M11.3,59.4l0.9,1.1l0.3-0.2l0,0c0,0,0,0,0-0.1V60 c0-0.1-0.1-0.2-0.1-0.3l-0.8-0.4c0,0,0,0,0,0L11.3,59.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_887_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1245_",
    className: "st3",
    d: "M12.3,60.8l-0.4-0.2c-0.1-0.1-0.2-0.1-0.3,0l-0.3,0.2l0.3,0.9c0,0.4,0.1,0.7,0.4,1.1 l0.3,0.9c0,0,0,0,0,0l0.4-0.2c0,0,0.1-0.1,0.1-0.1v-1.8C12.6,61.2,12.5,60.9,12.3,60.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1246_",
    className: "st2",
    d: "M12.2,63.7L12.2,63.7c-0.1,0-0.1-0.1-0.1-0.1l-0.3-0.9c-0.2-0.4-0.4-0.8-0.4-1.1 l-0.3-0.9l0.4-0.2c0.1-0.1,0.3-0.1,0.4,0l0.4,0.2c0.2,0.1,0.4,0.5,0.4,0.7v1.8c0,0.1-0.1,0.2-0.1,0.2l0,0L12.2,63.7z  M11.3,60.8l0.3,0.8c0,0.3,0.1,0.7,0.3,1l0,0l0.3,0.8l0.3-0.2c0,0,0,0,0-0.1v-1.8c0-0.2-0.1-0.5-0.3-0.6v0l-0.4-0.2 c0,0-0.1-0.1-0.2,0l0,0L11.3,60.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_884_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_886_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1241_",
    className: "st3",
    d: "M11.8,63.4l0.2,0.2c0.1,0.1,0.3,0.1,0.3-0.1v-1.8c0-0.2-0.2-0.5-0.4-0.6l-0.4-0.2 c-0.2-0.1-0.4,0-0.4,0.2v0.8C11.1,62.3,11.3,62.9,11.8,63.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1242_",
    className: "st2",
    d: "M12.1,63.7c-0.1,0-0.2,0-0.2-0.1l-0.2-0.2C11.3,63,11,62.3,11,61.8V61 c0-0.2,0.1-0.3,0.2-0.3c0.1-0.1,0.2,0,0.4,0l0.4,0.2c0.2,0.1,0.4,0.5,0.4,0.7v1.8C12.3,63.6,12.3,63.7,12.1,63.7 C12.2,63.7,12.1,63.7,12.1,63.7z M11.8,63.3l0.2,0.2c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0v-1.8c0-0.2-0.1-0.5-0.3-0.6l-0.4-0.2 c-0.1,0-0.1,0-0.2,0c0,0-0.1,0.1-0.1,0.2v0.8C11.2,62.3,11.4,62.9,11.8,63.3L11.8,63.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_885_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1237_",
    className: "st3",
    d: "M11.3,60.2l0.8,0.4c0.1,0.1,0.2,0,0.2-0.2v-0.3c0-0.1-0.1-0.3-0.2-0.4l-0.8-0.4 c-0.1-0.1-0.2,0-0.2,0.2v0.3C11.1,59.9,11.2,60.1,11.3,60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1238_",
    className: "st2",
    d: "M12.1,60.7c0,0-0.1,0-0.1,0l-0.8-0.4C11.1,60.2,11,60,11,59.8v-0.3 c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.2,0l0.8,0.4c0.1,0.1,0.2,0.3,0.2,0.5v0.3c0,0.1,0,0.2-0.1,0.2 C12.2,60.7,12.1,60.7,12.1,60.7z M11.3,60.1l0.8,0.4c0,0,0,0,0,0c0,0,0,0,0-0.1v-0.3c0-0.1-0.1-0.2-0.1-0.3l-0.8-0.4 c0,0,0,0,0,0c0,0,0,0,0,0.1v0.3C11.2,59.9,11.2,60,11.3,60.1L11.3,60.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_830_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1233_",
    className: "st3",
    d: "M33.1,75.3c0,0-2.5-0.3-4.4-2.7c-1.8-2.4,1.7-2.2,1.7-2.2s3.5,0.2,3.6,0.3 c0.1,0,0.5,1.6,0.5,1.7C34.5,72.6,33.1,75.3,33.1,75.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1234_",
    className: "st2",
    d: "M33.2,75.4L33.2,75.4c-0.1,0-2.7-0.3-4.5-2.8C28.1,72,28,71.4,28.2,71 c0.4-0.8,2.2-0.7,2.2-0.7c0.6,0,3.5,0.2,3.6,0.3c0.2,0.1,0.6,1.8,0.6,1.8C34.6,72.6,33.7,74.3,33.2,75.4L33.2,75.4z  M30.2,70.5c-0.5,0-1.5,0.1-1.8,0.6c-0.2,0.3,0,0.8,0.4,1.4c1.6,2.2,3.8,2.6,4.3,2.7c0.5-1,1.3-2.7,1.4-2.8 c0-0.1-0.4-1.4-0.5-1.6c-0.3,0-2.2-0.2-3.5-0.3C30.4,70.5,30.3,70.5,30.2,70.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_836_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1229_",
    className: "st2",
    d: "M35.1,57.6L35.1,57.6c-0.2-0.1-0.2-0.1-0.4,0l-4.6,2.7l2.6-5l1.2-2.2c0,0,0,0,0,0 l-10.8-6.2c-0.1,0-0.3,0-0.3,0.1L22,47.3c-0.5,0.3-1.1,0.7-1.6,1.1l-1,0.8c-0.5,0.4-1,0.8-1.5,1.3l-3.4,3.3 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.8,0.6-1.4,1.8-1.5,2.8l-0.7,8c0,0.5-0.1,1-0.1,1.5v8.5c0,0,0,0.1,0,0.1l0,0c0,0,0.1,0,0.1,0 l10.9,6.1c0,0,0.3,0.1,0.3,0L27,66.3l4.7-2.7l-1.5,6.8l4,0.6l11.9-7.2c0,0,0,0,0,0L35.1,57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1230_",
    className: "st2",
    d: "M23.2,81.3c-0.1,0-0.2,0-0.3-0.1L11.9,75c0,0-0.1,0-0.1-0.1l0,0c0,0-0.1-0.1-0.1-0.2 v-8.5c0-0.5,0-1,0.1-1.5l0.7-8c0.1-1,0.7-2.2,1.6-2.8c0.1-0.1,0.2-0.2,0.3-0.3l3.4-3.3c0.5-0.5,1-0.9,1.5-1.3l1-0.8 c0.5-0.4,1.1-0.8,1.6-1.1l0.8-0.4c0,0,0.3-0.1,0.4-0.1L34,53c0.1,0,0.1,0.1,0,0.2l-1.2,2.2L30.4,60l4.3-2.5 c0.2-0.1,0.3-0.1,0.4,0l0.1,0l11,6.2c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1l-12,7.2l0,0l-4.1-0.6l1.5-6.7l-4.5,2.6l-3.8,14.8 c0,0,0,0.1-0.1,0.1C23.2,81.2,23.2,81.3,23.2,81.3z M23,46.9c0,0-0.2,0-0.2,0.1L22,47.4c-0.5,0.3-1.1,0.7-1.6,1.1l-1,0.8 c-0.5,0.4-1,0.8-1.5,1.3l-3.4,3.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.8,0.6-1.4,1.7-1.5,2.7l-0.7,8c0,0.5-0.1,1-0.1,1.5v8.5l0,0 l0.1,0L23,81c0,0,0.1,0,0.2,0l3.8-14.8l4.9-2.8l-1.5,7l3.9,0.6L46,63.8L35,57.6c-0.1,0-0.1,0-0.2,0l-4.9,2.8l2.8-5.3l1.2-2.1 L23,46.9C23,46.9,23,46.9,23,46.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_352_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1225_",
    className: "st3",
    d: "M42.6,54.3L42.6,54.3c-0.7-0.6-1.8-0.6-3,0.1c-2.1,1.2-3.9,4.2-3.9,6.7l0,0 c0,0.2,0.1,0.3,0.2,0.3l10.9,6.2l0.3-0.5l0.8-3.2l2.8-2.7l2.5-0.8L42.6,54.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1226_",
    className: "st2",
    d: "M47,67.7L47,67.7l-11-6.2c-0.1,0-0.1,0-0.2-0.1c-0.1,0-0.1-0.1-0.1-0.3l0,0 c0-2.5,1.8-5.5,3.9-6.8c1.2-0.7,2.3-0.7,3.1-0.1l10.9,6.1L51,61.2l-2.8,2.7l-0.8,3.2L47,67.7z M36,61.3L36,61.3l10.8,6.1 l0.2-0.4l0.8-3.3l2.9-2.7l2.3-0.7l-10.5-5.9h0l0,0c-0.7-0.6-1.7-0.5-2.8,0.1c-2.1,1.2-3.8,4.2-3.8,6.6l0,0c0,0.1,0,0.1,0,0.2 C36,61.3,36,61.3,36,61.3L36,61.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_993_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1221_",
    className: "st4",
    d: "M47.6,65.5l0.4-1.7l2.8-2.7l0.7-0.2L40,54.3c0,0,0,0,0,0c-0.1,0.1-0.2,0.1-0.3,0.2 c-1.5,0.9-2.9,2.7-3.5,4.6L47.6,65.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1222_",
    className: "st2",
    d: "M47.7,65.7L36,59l0-0.1c0.6-1.9,2-3.8,3.5-4.6c0.1-0.1,0.2-0.1,0.3-0.2l0,0l0,0l0,0 l11.9,6.8l-0.9,0.3l-2.8,2.7L47.7,65.7z M36.3,58.9l11.3,6.4l0.4-1.6l2.9-2.7l0.5-0.2L40,54.4c-0.1,0-0.2,0.1-0.3,0.1 C38.3,55.3,36.9,57.1,36.3,58.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_721_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1217_",
    className: "st3",
    d: "M35.3,57.6L35.3,57.6c-0.2-0.1-0.2-0.1-0.4,0l-4.6,2.7l2.6-5l1.2-2.2c0,0,0,0,0,0 l-11.1-6.2l-0.9,0.5c-0.5,0.3-1.1,0.7-1.6,1.1l-1,0.8c-0.5,0.4-1,0.8-1.5,1.3l-3.4,3.3c-0.1,0.1-0.2,0.2-0.3,0.3 c-0.8,0.6-1.4,1.8-1.5,2.8l-0.7,8c0,0.5-0.1,1-0.1,1.5v8.5c0,0,0,0.1,0,0.1l0,0l0,0c0,0,0,0,0,0l0.1,0l11,6.2c0,0,0,0,0,0 l4-14.9l4.7-2.7l-1.5,6.8l4,0.6l11.9-7.2c0,0,0,0,0,0L35.3,57.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1218_",
    className: "st2",
    d: "M23.2,81.2L23.2,81.2L12,75l0,0c0,0-0.1-0.1-0.1-0.1v-8.5c0-0.5,0-1,0.1-1.5l0.7-8 c0.1-1,0.7-2.2,1.6-2.8c0.1-0.1,0.2-0.2,0.3-0.3l3.4-3.3c0.5-0.5,1-0.9,1.5-1.3l1-0.8c0.5-0.4,1.1-0.8,1.6-1.1l0.9-0.5l0,0 L34.2,53c0.1,0,0.1,0.1,0.1,0.2L33,55.3L30.6,60l4.3-2.5c0.2-0.1,0.3-0.1,0.4,0l0.1,0l11,6.2c0,0,0.1,0.1,0.1,0.1 c0,0,0,0.1-0.1,0.1l-12,7.2l0,0l-4.1-0.6l1.5-6.7l-4.5,2.6l-4,14.9L23.2,81.2z M12.2,74.8L12.2,74.8l11,6.2l4-14.8l0,0 l4.9-2.8l-1.5,7l3.9,0.6l11.8-7.1l-10.9-6.1c-0.1,0-0.1,0-0.2,0l-4.9,2.8l2.8-5.3l1.2-2.1l-10.9-6.2l-0.8,0.5 c-0.5,0.3-1.1,0.7-1.6,1.1l-1,0.8c-0.5,0.4-1,0.8-1.5,1.3l-3.4,3.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.8,0.6-1.4,1.7-1.5,2.7l-0.7,8 c0,0.5-0.1,1-0.1,1.5L12.2,74.8L12.2,74.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_682_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_866_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1213_",
    className: "st4",
    d: "M46.3,63.7l-11-6.2l0,0c-0.1,0-0.2-0.1-0.3,0l-3,1.7l9,5.1c0,0,0,0,0,0l-10.1,6.1 l3.5,0.5L46.3,63.7C46.4,63.8,46.4,63.7,46.3,63.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1214_",
    className: "st2",
    d: "M34.4,71.1L34.4,71.1l-3.8-0.6l10.2-6.2l-9-5.1l3.1-1.8c0.2-0.1,0.3-0.1,0.4,0l0.1,0 l11,6.2c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1L34.4,71.1z M31.2,70.4l3.2,0.5l11.8-7.1l-10.9-6.1c-0.1,0-0.1,0-0.2,0 l-2.8,1.6l8.8,5c0,0,0.1,0.1,0.1,0.1c0,0,0,0.1-0.1,0.1L31.2,70.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_861_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1209_",
    className: "st4",
    d: "M30.3,60.3l2.6-5l1.2-2.2c0,0,0,0,0,0l-11.1-6.2l-0.9,0.5c-0.5,0.3-1.1,0.7-1.6,1.1 l-1,0.8c-0.5,0.4-1,0.8-1.5,1.3l-3.4,3.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.3,0.2-0.6,0.6-0.9,0.9l16.4,9.7L30.3,60.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1210_",
    className: "st2",
    d: "M30,64.9l-0.1-0.1l-16.5-9.8l0.1-0.1c0.3-0.4,0.6-0.7,0.9-1c0.1-0.1,0.2-0.2,0.3-0.3 l3.4-3.3c0.5-0.5,1-0.9,1.5-1.3l1-0.8c0.5-0.4,1.1-0.8,1.6-1.1l0.9-0.5l0,0L34.2,53c0.1,0,0.1,0.1,0.1,0.2L33,55.3l-2.6,4.9 L30,64.9z M13.7,55l16.1,9.6l0.4-4.4l2.6-5l1.2-2.1l-10.9-6.2l-0.8,0.5c-0.5,0.3-1.1,0.7-1.6,1.1l-1,0.8 c-0.5,0.4-1,0.8-1.5,1.3l-3.4,3.3c-0.1,0.1-0.2,0.2-0.3,0.3C14.2,54.4,13.9,54.7,13.7,55z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_684_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_697_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1205_",
    className: "st3",
    d: "M28.7,72.9L28.7,72.9c-0.3,0-0.7,0.2-1.1,0.5c-1.2,0.9-1.9,2.8-1.8,4.2 c0.1,0.6,0.3,1,0.6,1.2c0,0,0.7,0.7,2.3,1c1.6,0.3,1.9-4.2,1.9-4.2l0.6-1.8C31.1,73.8,30.2,72.8,28.7,72.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1206_",
    className: "st2",
    d: "M28.8,79.9c-0.1,0-0.1,0-0.2,0c-1.6-0.3-2.3-1-2.4-1c-0.3-0.3-0.5-0.7-0.6-1.3 c-0.2-1.5,0.6-3.5,1.8-4.4c0.4-0.3,0.8-0.5,1.1-0.5c1.5-0.1,2.5,1,2.6,1l0.1,0.1l-0.6,1.8c0,0.3-0.3,3.3-1.3,4.1 C29.2,79.9,29,79.9,28.8,79.9z M28.9,73c-0.1,0-0.1,0-0.2,0l0,0c-0.3,0-0.7,0.2-1,0.4c-1.1,0.9-1.9,2.7-1.7,4.1 c0.1,0.5,0.2,0.9,0.5,1.1c0,0,0.7,0.7,2.2,1c0.2,0,0.4,0,0.5-0.1c1-0.8,1.2-3.9,1.2-3.9l0,0l0.6-1.7C30.8,73.7,30,73,28.9,73 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_691_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1201_",
    className: "st2",
    d: "M31.7,75.1c0.2,1.5-0.6,3.4-1.8,4.2c-1.2,0.9-2.2,0.4-2.4-1c-0.2-1.5,0.6-3.4,1.8-4.2 C30.5,73.2,31.6,73.6,31.7,75.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1202_",
    className: "st2",
    d: "M28.9,79.9c-0.2,0-0.3,0-0.5-0.1c-0.5-0.2-0.8-0.7-0.9-1.5c-0.2-1.5,0.6-3.5,1.8-4.4 c0.6-0.5,1.2-0.6,1.7-0.4c0.5,0.2,0.8,0.7,0.9,1.5l0,0c0.2,1.5-0.6,3.5-1.8,4.4C29.7,79.8,29.2,79.9,28.9,79.9z M30.5,73.7 c-0.3,0-0.7,0.1-1,0.4c-1.1,0.9-1.9,2.7-1.7,4.1c0.1,0.7,0.4,1.1,0.8,1.3c0.4,0.2,0.9,0,1.4-0.3c1.1-0.9,1.9-2.7,1.7-4.1l0,0 c-0.1-0.7-0.4-1.1-0.8-1.3C30.7,73.8,30.6,73.7,30.5,73.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_688_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_690_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1197_",
    className: "st3",
    d: "M31.1,75.6c0.1,1-0.4,2.3-1.2,3c-0.8,0.6-1.6,0.3-1.7-0.7c-0.1-1,0.4-2.3,1.2-3 C30.2,74.2,31,74.6,31.1,75.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1198_",
    className: "st3",
    d: "M29.1,79c-0.1,0-0.2,0-0.3-0.1c-0.4-0.1-0.6-0.5-0.7-1.1c-0.1-1,0.4-2.4,1.3-3 c0.4-0.3,0.8-0.4,1.2-0.3c0.4,0.1,0.6,0.5,0.7,1.1l0,0c0.1,1-0.4,2.4-1.3,3C29.7,78.8,29.4,79,29.1,79z M30.2,74.7 c-0.2,0-0.5,0.1-0.7,0.3c-0.8,0.6-1.3,1.9-1.2,2.9c0.1,0.5,0.2,0.8,0.5,0.9c0.3,0.1,0.6,0,1-0.2c0.8-0.6,1.3-1.9,1.2-2.9 l0,0c-0.1-0.5-0.2-0.8-0.5-0.9C30.4,74.7,30.3,74.7,30.2,74.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_689_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1193_",
    className: "st2",
    d: "M30.7,75.5c-0.1-0.4-0.2-0.8-0.5-0.9c-0.2,0-0.5,0.1-0.8,0.3c-0.8,0.6-1.4,1.9-1.2,3 c0.1,0.4,0.2,0.8,0.5,0.9c0.2,0,0.5-0.1,0.8-0.3C30.2,77.8,30.8,76.5,30.7,75.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1194_",
    className: "st3",
    d: "M28.6,78.8L28.6,78.8c-0.3-0.2-0.5-0.5-0.5-1c-0.1-1,0.4-2.4,1.3-3 c0.3-0.2,0.6-0.3,0.8-0.3l0,0l0,0c0.3,0.2,0.5,0.5,0.5,1c0.1,1-0.4,2.4-1.3,3C29.2,78.7,28.9,78.8,28.6,78.8L28.6,78.8z  M30.2,74.7c-0.2,0-0.4,0.1-0.7,0.3c-0.8,0.6-1.3,1.9-1.2,2.9c0,0.4,0.2,0.7,0.4,0.8c0.2,0,0.4-0.1,0.7-0.3 c0.8-0.6,1.3-1.9,1.2-2.9l0,0C30.5,75.1,30.4,74.8,30.2,74.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_685_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_687_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1189_",
    className: "st3",
    d: "M30.4,75.8L30.4,75.8c-0.3-0.2-0.5-0.2-0.8,0c-0.4,0.3-0.7,1-0.6,1.5 c0,0.3,0.2,0.5,0.4,0.5l0.1,0l0.4,0l0.4-0.6l0.4-1.2L30.4,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1190_",
    className: "st3",
    d: "M29.9,78L29.4,78c-0.3,0-0.5-0.3-0.5-0.6c-0.1-0.6,0.2-1.3,0.7-1.6 c0.3-0.2,0.6-0.2,0.8,0l0.4,0.4l-0.4,1.3L29.9,78z M30,75.7c-0.1,0-0.2,0-0.3,0.1c-0.4,0.3-0.7,1-0.6,1.5 c0,0.3,0.2,0.4,0.3,0.4l0.1,0l0.4,0l0.3-0.5l0.4-1.2l-0.3-0.3C30.2,75.8,30.1,75.7,30,75.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_686_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1185_",
    className: "st2",
    d: "M30.8,76.5c0.1,0.4-0.2,1-0.5,1.3c-0.4,0.3-0.7,0.1-0.7-0.3c-0.1-0.4,0.2-1,0.5-1.3 C30.4,75.9,30.8,76,30.8,76.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1186_",
    className: "st3",
    d: "M29.9,78c-0.1,0-0.1,0-0.2,0c-0.2-0.1-0.3-0.3-0.3-0.5c-0.1-0.5,0.2-1.1,0.6-1.4 c0.2-0.2,0.4-0.2,0.6-0.1c0.2,0.1,0.3,0.3,0.3,0.5c0.1,0.5-0.2,1.1-0.6,1.4C30.2,78,30.1,78,29.9,78z M30.4,76.1 c-0.1,0-0.2,0-0.3,0.1c-0.3,0.3-0.6,0.8-0.5,1.2c0,0.2,0.1,0.3,0.2,0.4c0.1,0,0.2,0,0.4-0.1c0.3-0.3,0.6-0.8,0.5-1.2 C30.7,76.3,30.6,76.2,30.4,76.1C30.5,76.1,30.5,76.1,30.4,76.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_337_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_324_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1174_",
    className: "st2",
    d: "M33.8,70.5l0-1.4c0-0.4,0-0.7-0.1-1l0,0c-0.1-0.3-0.2-0.7-0.1-1c0-0.5,0-1,0-1 c0-4.3,0.5-7.8,0.8-9.6c0.1-0.7,0.1-1.4-0.2-1.8l0,0v-1.6c0,0,0,0,0,0l-0.8,0.5c-0.5,0.3-1.1,0.7-1.6,1.1l-1,0.8 c-0.5,0.4-1,0.8-1.5,1.3l-3.4,3.3c-0.1,0.1-0.2,0.2-0.3,0.3l0,0c-0.8,0.6-1.4,1.8-1.5,2.8l-0.7,8c0,0.5-0.1,1-0.1,1.5V81 c0,0.1,0.1,0.1,0.2,0.1l2.5-1.5c0.5-0.3,0.9-0.9,0.9-1.5l0-0.4c0-1.9,1.3-4.2,3-5.1c1.6-0.9,3-0.2,3,1.7l0,0.4 c0,0.6,0.4,0.8,0.9,0.5L45,68.6c0.5-0.3,0.9-0.8,1.1-1.4l0,0c0.3-0.8,0.4-1.7,0.4-2.4c0-0.2,0-0.5,0-0.7 c0-0.3-0.2-0.4-0.5-0.3l-11.9,6.9C33.9,70.8,33.8,70.7,33.8,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1182_",
    className: "st2",
    d: "M23.2,81.3c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.1-0.2v-8.5c0-0.5,0-1,0.1-1.5l0.7-8 c0.1-1,0.7-2.2,1.6-2.8c0.1-0.1,0.2-0.2,0.3-0.3l3.4-3.3c0.5-0.5,1-0.9,1.5-1.3l1-0.8c0.5-0.4,1.1-0.8,1.6-1.1l0.8-0.5 c0,0,0.1,0,0.1,0c0,0,0.1,0.1,0.1,0.1v1.6c0.3,0.5,0.3,1.1,0.2,1.9c-0.3,1.7-0.8,5.3-0.8,9.5c0,0,0,0.6,0,1 c0,0.4,0,0.7,0.1,1c0.1,0.3,0.2,0.6,0.2,1l0,1.4c0,0.1,0,0.1,0,0.1c0,0,0.1,0,0.1,0L46,63.7c0.2-0.1,0.3-0.1,0.4,0 c0.1,0.1,0.2,0.2,0.2,0.4c0,0.2,0,0.5,0,0.7c0,0.8-0.1,1.6-0.4,2.4l0,0c-0.2,0.6-0.6,1.2-1.1,1.5l-11.5,6.6 c-0.3,0.2-0.5,0.2-0.7,0.1c-0.2-0.1-0.3-0.3-0.3-0.6l0-0.4c0-0.9-0.3-1.5-0.8-1.8c-0.5-0.3-1.2-0.2-2,0.2 c-1.6,0.9-2.9,3.2-2.9,5l0,0.4c0,0.6-0.4,1.3-0.9,1.6l-2.5,1.5C23.3,81.2,23.3,81.3,23.2,81.3z M34.1,53.2l-0.7,0.4 c-0.5,0.3-1.1,0.7-1.6,1.1l-1,0.8c-0.5,0.4-1,0.8-1.5,1.3l-3.4,3.3c-0.1,0.1-0.2,0.2-0.3,0.3c-0.8,0.6-1.4,1.7-1.5,2.7 l-0.7,8c0,0.5-0.1,1-0.1,1.5V81l2.5-1.5c0.4-0.3,0.8-0.9,0.8-1.4l0-0.4c0-1.9,1.4-4.3,3-5.2c0.8-0.5,1.6-0.5,2.2-0.2 c0.6,0.3,0.9,1.1,0.9,2l0,0.4c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.1,0.5-0.1L45,68.6c0.4-0.3,0.8-0.8,1-1.4l0,0 c0.3-0.8,0.4-1.6,0.4-2.4c0-0.2,0-0.5,0-0.7c0-0.1,0-0.2-0.1-0.2c-0.1,0-0.1,0-0.2,0l-11.9,6.9c-0.1,0.1-0.2,0.1-0.3,0 c-0.1-0.1-0.1-0.2-0.1-0.3l0-1.4c0-0.3,0-0.7-0.1-0.9c-0.1-0.3-0.2-0.7-0.1-1.1c0-0.5,0-1,0-1c0-4.3,0.5-7.8,0.8-9.6 c0.1-0.7,0.1-1.3-0.2-1.8l0,0l0,0V53.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_328_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1181_",
    className: "st3",
    d: "M39.9,70.8c-0.1,0-0.2,0-0.2,0c-0.2-0.1-0.3-0.2-0.4-0.4l-0.5-1 c-0.1-0.3,0.1-0.8,0.4-1l6.7-3.9l0.1,0.2l-6.7,3.9c-0.2,0.1-0.4,0.5-0.3,0.7l0.5,1c0.1,0.1,0.2,0.2,0.3,0.3 c0.2,0.1,0.4,0,0.6-0.1l5-2.9l0,0.1l0,0l0,0l0.1,0.1c0,0-0.1,0-0.1,0c0,0,0,0,0,0l-4.9,2.9C40.3,70.7,40.1,70.8,39.9,70.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_358_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1178_",
    className: "st3",
    d: "M40.3,70.6c-0.1,0-0.2,0-0.2,0c-0.2-0.1-0.3-0.2-0.4-0.4l-0.5-1 c-0.1-0.3,0.1-0.8,0.4-1l6.4-3.7l0,0.2c0,0.1,0,1.7-0.5,3.1l0,0l0,0l-4.6,2.7C40.7,70.5,40.5,70.6,40.3,70.6z M45.9,64.8 l-6.1,3.5c-0.2,0.1-0.4,0.5-0.3,0.7l0.5,1c0.1,0.1,0.2,0.2,0.3,0.3c0.2,0.1,0.4,0,0.6-0.1l4.6-2.7 C45.8,66.5,45.9,65.2,45.9,64.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_326_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1175_",
    className: "st3",
    d: "M24,76.6c0,0-0.1,0-0.1,0c-0.1-0.1-0.1-0.2-0.1-0.3v-4.6c0-0.6,0-1.2,0.1-1.8l0.5-5.8 c0-0.3,0.2-0.7,0.5-0.8l3.7-2.1c0.1-0.1,0.3-0.1,0.4,0c0.1,0.1,0.2,0.2,0.2,0.4v10.8l0,0c-1.2,1-2,2.6-2,2.6l0,0l-2.8,1.6 C24.1,76.6,24.1,76.6,24,76.6z M28.6,61.3L25,63.4c-0.2,0.1-0.4,0.4-0.4,0.7L24,69.9c-0.1,0.6-0.1,1.2-0.1,1.8v4.6 c0,0.1,0,0.1,0,0.1c0,0,0.1,0,0.1,0l2.8-1.6c0.1-0.2,0.9-1.7,2-2.7V61.4c0-0.1,0-0.2-0.1-0.2C28.8,61.2,28.7,61.2,28.6,61.3 L28.6,61.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_336_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1172_",
    className: "st2",
    d: "M24.6,68.6l-0.1,0.7c0,0.2,0.1,0.3,0.3,0.2l3.3-1.9c0.2-0.1,0.4-0.4,0.4-0.7v-4.8 c0-0.2-0.1-0.2-0.3-0.2l-3,1.7C25.1,63.8,25,64,25,64.1l-0.3,3.1L24.6,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1173_",
    className: "st3",
    d: "M24.7,69.6c0,0-0.1,0-0.1,0c-0.1-0.1-0.1-0.2-0.1-0.3l0.1-0.7l0.2,0l-0.1,0.7 c0,0.1,0,0.1,0,0.1c0,0,0.1,0,0.1,0l3.3-1.9c0.2-0.1,0.3-0.4,0.3-0.6v-4.8c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0l-3,1.7 c-0.1,0.1-0.2,0.2-0.2,0.4l-0.3,3.1l-0.2,0l0.3-3.1c0-0.2,0.2-0.4,0.3-0.5l3-1.7c0.1-0.1,0.2-0.1,0.3,0 c0.1,0,0.1,0.1,0.1,0.3v4.8c0,0.3-0.2,0.6-0.4,0.7l-3.3,1.9C24.8,69.6,24.7,69.6,24.7,69.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_738_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1168_",
    className: "st2",
    d: "M28.2,62l-0.3,0.2v4.4c0,0.2-0.2,0.5-0.4,0.7l-3,1.7l0,0.3c0,0.2,0.1,0.3,0.3,0.2 l3.3-1.9c0.2-0.1,0.4-0.4,0.4-0.7v-4.8C28.5,62,28.4,61.9,28.2,62z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1169_",
    className: "st3",
    d: "M24.7,69.6c0,0-0.1,0-0.1,0c-0.1-0.1-0.1-0.2-0.1-0.3l0-0.4l3.1-1.8 c0.2-0.1,0.3-0.4,0.3-0.6v-4.5l0.3-0.2c0.1-0.1,0.2-0.1,0.3,0c0.1,0,0.1,0.1,0.1,0.3v4.8c0,0.3-0.2,0.6-0.4,0.7l-3.3,1.9 C24.8,69.6,24.7,69.6,24.7,69.6z M24.6,69l0,0.3c0,0.1,0,0.1,0,0.1c0,0,0.1,0,0.1,0l3.3-1.9c0.2-0.1,0.3-0.4,0.3-0.6v-4.8 c0,0,0-0.1,0-0.1c0,0-0.1,0-0.1,0L28,62.2v4.4c0,0.3-0.2,0.6-0.4,0.7L24.6,69z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_308_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1164_",
    className: "st2",
    d: "M29.7,66.7L29.7,66.7c-0.1,0-0.2-0.1-0.2-0.2v-4.9c0-0.2,0.1-0.4,0.2-0.4l1-0.6 c0.1-0.1,0.2,0.1,0.1,0.3l-0.1,3.2C30.6,65.2,30.2,66.4,29.7,66.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1165_",
    className: "st3",
    d: "M29.6,66.8C29.6,66.8,29.6,66.8,29.6,66.8c-0.2-0.1-0.2-0.2-0.2-0.4v-4.9 c0-0.2,0.1-0.4,0.2-0.5l1-0.6c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0.2,0.1,0.4l-0.1,3.2C30.7,65.3,30.3,66.4,29.6,66.8 C29.7,66.8,29.7,66.8,29.6,66.8z M30.7,60.7l-0.9,0.5c0,0-0.1,0.2-0.1,0.3v4.9c0,0.1,0,0.1,0,0.1c0.5-0.3,0.9-1.4,0.9-2.5 l0.1-3.2C30.7,60.8,30.7,60.7,30.7,60.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_739_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1127_",
    className: "st2",
    d: "M30.6,60.6l-0.5,0.3L30,64.1c0,0.8-0.2,1.5-0.5,2.1v0.3c0,0.2,0.1,0.3,0.2,0.2 c0.5-0.3,1-1.4,1-2.6l0.1-3.2C30.8,60.7,30.7,60.5,30.6,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1161_",
    className: "st3",
    d: "M29.6,66.8C29.6,66.8,29.6,66.8,29.6,66.8c-0.2-0.1-0.2-0.2-0.2-0.4v-0.3l0,0 c0.3-0.5,0.5-1.3,0.5-2l0.1-3.3l0.5-0.3c0.1,0,0.1,0,0.2,0c0.1,0.1,0.1,0.2,0.1,0.4l-0.1,3.2C30.7,65.3,30.3,66.5,29.6,66.8 C29.7,66.8,29.7,66.8,29.6,66.8z M29.6,66.2v0.3c0,0.1,0,0.1,0,0.1c0.5-0.3,0.9-1.4,0.9-2.5l0.1-3.2c0-0.1,0-0.1,0-0.2 l-0.4,0.2l-0.1,3.2C30.1,64.9,29.9,65.6,29.6,66.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_325_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1158_",
    className: "st3",
    d: "M27,70.3c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.2-0.3-0.1-0.5l0,0L28,69c0,0,0.1,0,0.1,0 c0,0,0.1,0.1,0,0.1l-0.1,0.3c-0.1,0.2-0.2,0.4-0.4,0.5l-0.5,0.3C27.1,70.3,27,70.3,27,70.3z M26.9,69.8c0,0.1,0,0.2,0,0.3 c0.1,0,0.1,0,0.2,0l0.5-0.3c0.1-0.1,0.2-0.2,0.3-0.4l0-0.2L26.9,69.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_380_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1157_",
    className: "st3",
    d: "M33,59.3c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.1-0.3c0-0.2,0.1-0.5,0.3-0.6l0.8-0.5 l0.1,0.2l-0.8,0.5C33.1,58.7,33,58.9,33,59c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0l0.7-0.4l0.1,0.2l-0.7,0.4 C33.2,59.3,33.1,59.3,33,59.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_378_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1156_",
    className: "st3",
    d: "M32.8,60.8c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.1-0.3c0-0.2,0.1-0.5,0.3-0.6l0.8-0.5 l0.1,0.2L33,60c-0.1,0.1-0.2,0.3-0.2,0.4c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0l0.7-0.4l0.1,0.2L33,60.7 C32.9,60.7,32.9,60.8,32.8,60.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_377_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1155_",
    className: "st3",
    d: "M32.7,62.2c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.1-0.3c0-0.2,0.1-0.5,0.3-0.6l0.8-0.5 l0.1,0.2l-0.8,0.5c-0.1,0.1-0.2,0.3-0.2,0.4c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0l0.8-0.4l0.1,0.2l-0.8,0.4 C32.8,62.1,32.7,62.2,32.7,62.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_351_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1154_",
    className: "st3",
    d: "M32.6,63.5c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.1-0.3c0-0.2,0.1-0.5,0.3-0.6l0.8-0.5 l0.1,0.2l-0.8,0.5c-0.1,0.1-0.2,0.3-0.2,0.4c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0l0.8-0.5l0.1,0.2l-0.8,0.5 C32.7,63.5,32.6,63.5,32.6,63.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_350_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1153_",
    className: "st3",
    d: "M32.5,64.9c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.1-0.3c0-0.2,0.1-0.5,0.3-0.6l0.8-0.5 l0.1,0.2l-0.8,0.5c-0.1,0.1-0.2,0.3-0.2,0.4c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0l0.8-0.4l0.1,0.2l-0.8,0.4 C32.6,64.9,32.5,64.9,32.5,64.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_335_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1150_",
    className: "st3",
    d: "M33.9,73.6C33.8,73.6,33.8,73.6,33.9,73.6c-0.2-0.1-0.2-0.1-0.2-0.3v-1.1 c0-0.2,0.1-0.3,0.2-0.4l0.6-0.3c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0.1,0.1,0.2v1.1c0,0.2-0.1,0.3-0.2,0.4L34,73.6 C34,73.6,33.9,73.6,33.9,73.6z M34.6,71.7C34.6,71.7,34.6,71.7,34.6,71.7L34,72c-0.1,0-0.1,0.1-0.1,0.2v1.1c0,0,0,0,0,0.1 c0,0,0,0,0,0l0.6-0.3c0.1,0,0.1-0.1,0.1-0.2L34.6,71.7C34.6,71.7,34.6,71.7,34.6,71.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_338_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1147_",
    className: "st3",
    d: "M35.3,72.8C35.3,72.8,35.3,72.8,35.3,72.8c-0.2-0.1-0.2-0.1-0.2-0.3v-1.1 c0-0.2,0.1-0.3,0.2-0.4l1.9-1.1c0.1,0,0.2,0,0.2,0c0.1,0,0.1,0.1,0.1,0.2v1.1c0,0.2-0.1,0.3-0.2,0.4l-1.9,1.1 C35.4,72.8,35.4,72.8,35.3,72.8z M37.4,70.1C37.4,70.1,37.4,70.1,37.4,70.1l-2,1.1c-0.1,0-0.1,0.1-0.1,0.2v1.1c0,0,0,0,0,0.1 c0,0,0,0,0,0l1.9-1.1c0.1,0,0.1-0.1,0.1-0.2L37.4,70.1C37.4,70.1,37.4,70.1,37.4,70.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_364_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1144_",
    className: "st3",
    d: "M33.9,73.6C33.8,73.6,33.8,73.6,33.9,73.6c-0.2-0.1-0.2-0.1-0.2-0.2v-1.1 c0-0.2,0.1-0.3,0.2-0.4l0.4-0.2c0,0,0,0,0,0l0.1,0.2l0,0l0,0c-0.1,0-0.1,0.2-0.1,0.2v1.1c0,0,0,0,0,0c0,0,0,0,0,0l0,0 l0.1,0.2l0,0L34,73.6C34,73.6,33.9,73.6,33.9,73.6z M34.1,72L34.1,72c-0.1,0.1-0.2,0.2-0.2,0.3v1.1c0,0,0,0,0,0c0,0,0,0,0,0 l0.2-0.1c0,0,0-0.1,0-0.1L34.1,72C34.1,72,34.1,72,34.1,72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_362_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1141_",
    className: "st3",
    d: "M35.3,72.8C35.3,72.8,35.2,72.8,35.3,72.8c-0.2-0.1-0.2-0.1-0.2-0.2v-1.1 c0-0.2,0.1-0.3,0.2-0.4l0.4-0.2v0l0.1,0.2c-0.1,0-0.1,0.2-0.1,0.2v1.1c0,0,0,0,0,0c0,0,0,0,0,0l0.1,0.2c0,0,0,0,0,0l-0.4,0.2 C35.4,72.8,35.4,72.8,35.3,72.8z M35.5,71.2L35.5,71.2c-0.1,0.1-0.2,0.2-0.2,0.3v1.1c0,0,0,0,0,0c0,0,0,0,0,0l0.2-0.1 c0,0,0-0.1,0-0.1L35.5,71.2C35.5,71.2,35.5,71.2,35.5,71.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_371_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1140_",
    className: "st3",
    d: "M30.6,71.1c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.1-0.2v-1c0-0.2,0.1-0.4,0.3-0.5l2.6-1.5 l0.1,0.2l-2.6,1.5c-0.1,0.1-0.2,0.2-0.2,0.3v1c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0l2.9-1.7l0.1,0.2l-2.9,1.7 C30.7,71.1,30.6,71.1,30.6,71.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_355_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1137_",
    className: "st3",
    d: "M30.6,71.1c0,0-0.1,0-0.1,0c-0.1,0-0.1-0.1-0.1-0.2v-1c0-0.2,0.1-0.4,0.3-0.5l0.4-0.2 c0,0,0,0,0,0l0.1,0.2c-0.1,0.1-0.2,0.2-0.2,0.3v1c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0l0.1,0.2c0,0,0,0,0,0l-0.4,0.2 C30.7,71.1,30.6,71.1,30.6,71.1z M30.8,69.5L30.8,69.5c-0.1,0.1-0.2,0.2-0.2,0.3v1c0,0,0,0.1,0,0.1c0,0,0,0,0.1,0l0.2-0.1 c0,0-0.1-0.1-0.1-0.2L30.8,69.5C30.8,69.6,30.8,69.5,30.8,69.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_340_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1136_",
    x: 23.4,
    y: 79.4,
    transform: "matrix(0.8658 -0.5003 0.5003 0.8658 -36.4513 23.1002)",
    className: "st3",
    width: 3,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_344_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1135_",
    x: 33,
    y: 72.9,
    transform: "matrix(0.8658 -0.5004 0.5004 0.8658 -31.6539 27.9042)",
    className: "st3",
    width: 6.5,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_314_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1134_",
    x: 30.1,
    y: 55.8,
    transform: "matrix(0.8658 -0.5004 0.5004 0.8658 -23.6623 23.5854)",
    className: "st3",
    width: 4.1,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_369_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1133_",
    className: "st3",
    d: "M23.5,74l-0.2-0.1c0.2-0.5,0.6-0.8,1.1-1.1l1.4-0.8l0.1,0.2L24.5,73 C24,73.3,23.7,73.6,23.5,74z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_357_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1132_",
    x: 29.4,
    y: 59.6,
    transform: "matrix(0.8658 -0.5003 0.5003 0.8658 -25.7917 23.2243)",
    className: "st3",
    width: 2.1,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_343_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1131_",
    x: 23.3,
    y: 77.4,
    transform: "matrix(0.8658 -0.5003 0.5003 0.8658 -35.3982 22.9343)",
    className: "st3",
    width: 3.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_345_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1130_",
    x: 34.7,
    y: 71.7,
    transform: "matrix(0.8658 -0.5004 0.5004 0.8658 -31.2307 27.1271)",
    className: "st3",
    width: 0.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_347_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1129_",
    x: 37.4,
    y: 69.8,
    transform: "matrix(0.8658 -0.5003 0.5003 0.8658 -29.8367 28.5125)",
    className: "st3",
    width: 1.7,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_329_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1128_",
    x: 33,
    y: 72.6,
    transform: "matrix(0.8658 -0.5004 0.5004 0.8658 -31.8847 26.4735)",
    className: "st3",
    width: 0.8,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_354_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1069_",
    className: "st2",
    d: "M42.7,69.4l-0.7,0.4c-0.1,0-0.1,0-0.1-0.1v-0.2c0-0.1,0.1-0.2,0.1-0.2l0.7-0.4 c0.1,0,0.1,0,0.1,0.1v0.2C42.9,69.3,42.8,69.4,42.7,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1070_",
    className: "st3",
    d: "M42,69.9C42,69.9,42,69.9,42,69.9c-0.1-0.1-0.2-0.1-0.2-0.2v-0.2 c0-0.1,0.1-0.3,0.2-0.3l0.7-0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.2v0.2c0,0.1-0.1,0.3-0.2,0.3h0L42,69.9 C42.1,69.9,42,69.9,42,69.9z M42.8,69.1l-0.7,0.4c0,0-0.1,0.1-0.1,0.1v0.2l0.7-0.4c0,0,0.1-0.1,0.1-0.1V69.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_390_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1058_",
    className: "st2",
    d: "M24.9,77.8l-0.7,0.4c-0.1,0-0.1,0-0.1-0.1V78c0-0.1,0.1-0.2,0.1-0.2l0.7-0.4 c0.1,0,0.1,0,0.1,0.1v0.2C25,77.7,24.9,77.8,24.9,77.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1061_",
    className: "st3",
    d: "M24.1,78.4C24.1,78.4,24.1,78.3,24.1,78.4c-0.1-0.1-0.2-0.1-0.2-0.2V78 c0-0.1,0.1-0.3,0.2-0.3l0.7-0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.2v0.2c0,0.1-0.1,0.3-0.2,0.3h0L24.1,78.4 C24.2,78.3,24.1,78.4,24.1,78.4z M24.9,77.5l-0.7,0.4c0,0-0.1,0.1-0.1,0.1v0.2l0.7-0.4c0,0,0.1-0.1,0.1-0.1V77.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_389_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1048_",
    className: "st2",
    d: "M44.3,68.5l-0.7,0.4c-0.1,0-0.1,0-0.1-0.1v-0.2c0-0.1,0.1-0.2,0.1-0.2l0.7-0.4 c0.1,0,0.1,0,0.1,0.1v0.2C44.4,68.4,44.3,68.5,44.3,68.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1049_",
    className: "st3",
    d: "M43.5,69.1C43.5,69.1,43.5,69.1,43.5,69.1c-0.1-0.1-0.2-0.1-0.2-0.2v-0.2 c0-0.1,0.1-0.3,0.2-0.3l0.7-0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.2v0.2c0,0.1-0.1,0.3-0.2,0.3L43.5,69.1 C43.6,69,43.6,69.1,43.5,69.1z M44.3,68.2l-0.7,0.4c0,0-0.1,0.1-0.1,0.1v0.2l0.7-0.4c0,0,0.1-0.1,0.1-0.1V68.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_669_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_366_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_368_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1042_",
    className: "st2",
    d: "M47.2,67.6L47.2,67.6c-0.2,0.1-0.4,0-0.4-0.2l0,0c0-2.5,1.7-5.5,3.9-6.7 c2.1-1.2,3.9-0.2,3.9,2.2l0,0c0,0.2-0.2,0.5-0.4,0.6l0,0c-0.2,0.1-0.4,0-0.4-0.2l0,0c0-2-1.4-2.8-3.1-1.8 c-1.7,1-3.1,3.4-3.1,5.4l0,0.1C47.6,67.2,47.4,67.5,47.2,67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1045_",
    className: "st2",
    d: "M47.1,67.7c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.2-0.2-0.2-0.3l0,0c0-2.5,1.8-5.5,3.9-6.8 c1.1-0.6,2.1-0.7,2.8-0.3c0.8,0.4,1.2,1.4,1.2,2.6c0,0.3-0.2,0.6-0.4,0.7c-0.1,0.1-0.3,0.1-0.4,0c-0.1-0.1-0.2-0.2-0.2-0.3 c0-1-0.3-1.6-0.9-2c-0.6-0.3-1.3-0.2-2.1,0.2c-1.7,1-3.1,3.4-3.1,5.3l0,0.1c0,0.3-0.2,0.6-0.4,0.7 C47.2,67.7,47.1,67.7,47.1,67.7z M52.5,60.2c-0.5,0-1.1,0.2-1.7,0.5c-2.1,1.2-3.8,4.2-3.8,6.6l0,0c0,0.1,0,0.1,0.1,0.2 c0,0,0.1,0,0.2,0h0c0.2-0.1,0.3-0.3,0.3-0.6l0-0.1c0-2,1.4-4.5,3.2-5.5c0.9-0.5,1.7-0.6,2.3-0.2c0.6,0.4,1,1.1,1,2.1 c0,0.1,0,0.1,0.1,0.2c0,0,0.1,0,0.2,0c0.2-0.1,0.3-0.4,0.3-0.6c0-1.2-0.4-2-1.1-2.4C53.1,60.3,52.8,60.2,52.5,60.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_671_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1044_",
    className: "st3",
    d: "M54.4,63.2h-0.2c0-1.7-0.9-2.3-0.9-2.3l0.1-0.2C53.4,60.7,54.4,61.4,54.4,63.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_672_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1043_",
    className: "st3",
    d: "M47.5,66l-0.2,0c0,0,0.2-1,0.6-1.7l0.2,0.1C47.7,65,47.5,65.9,47.5,66z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_799_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_720_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1037_",
    className: "st3",
    d: "M18,60c-3.5-2-4.3-3.2-4.4-3.5l-0.7,8.1c0,0,0.5,1.2,4.4,3.5c3.9,2.2,5.3,2.1,5.3,2.1 l0.7-8C22.9,62.1,21.3,61.8,18,60z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1039_",
    className: "st2",
    d: "M22.6,70.3c-0.3,0-1.8-0.1-5.4-2.1c-3.9-2.2-4.4-3.5-4.4-3.5l0,0l0,0l0.8-8.4l0.2,0.3 c0.1,0.2,0.9,1.4,4.4,3.4c3.3,1.9,4.8,2.1,5.2,2.1l0.1,0l-0.7,8.2L22.6,70.3C22.6,70.3,22.6,70.3,22.6,70.3z M13,64.5 c0.1,0.2,0.7,1.4,4.3,3.4c3.3,1.9,4.8,2.1,5.2,2.1l0.7-7.8c-0.6-0.1-2.2-0.4-5.2-2.2l0,0c-2.8-1.6-3.9-2.7-4.3-3.3L13,64.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_849_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1025_",
    className: "st3",
    d: "M17.9,62.4c3.1,1.7,4.6,2.1,5.1,2.1l0.2-2.5c-0.5,0-2-0.3-5.3-2.2 c-2.8-1.6-3.9-2.7-4.2-3.2l-0.2,2.2C13.6,58.9,14,60.2,17.9,62.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1026_",
    className: "st2",
    d: "M23.1,64.6l-0.1,0c-0.5-0.1-2.1-0.4-5.2-2.1l0,0c-3.9-2.2-4.4-3.5-4.4-3.5l0,0l0.2-2.5 l0.2,0.2c0.4,0.5,1.4,1.6,4.2,3.2c3.3,1.9,4.8,2.1,5.2,2.1l0.1,0L23.1,64.6z M18,62.3c2.9,1.6,4.4,2,5,2.1l0.2-2.3 c-0.6-0.1-2.2-0.4-5.2-2.2c-2.5-1.4-3.6-2.5-4.1-3l-0.2,2C13.7,59,14.4,60.3,18,62.3L18,62.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_749_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1021_",
    className: "st3",
    d: "M18,67.3c-2.9-1.6-4-2.5-4.4-2.9c-0.1-0.1-0.2-0.3-0.2-0.5l0.6-6.8 c-0.3-0.3-0.4-0.5-0.5-0.6l-0.7,8.1c0,0,0.5,1.2,4.4,3.5c3.9,2.2,5.3,2.1,5.3,2.1l0.1-0.8C21.4,68.9,19.8,68.3,18,67.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1022_",
    className: "st2",
    d: "M22.6,70.3c-0.3,0-1.8-0.1-5.4-2.1c-3.9-2.2-4.4-3.5-4.4-3.5l0,0l0,0l0.8-8.4l0.2,0.3 c0,0.1,0.2,0.3,0.5,0.6l0,0l-0.6,6.8c0,0.1,0,0.3,0.1,0.4c0.4,0.4,1.5,1.3,4.3,2.9l0,0c1.5,0.8,3.1,1.5,4.7,2l0.1,0l-0.1,1 L22.6,70.3C22.6,70.3,22.6,70.3,22.6,70.3z M13,64.5c0.1,0.2,0.7,1.4,4.3,3.4c3.3,1.9,4.8,2.1,5.2,2.1l0.1-0.7 c-1.6-0.5-3.2-1.2-4.6-2c-2.8-1.6-4-2.5-4.4-2.9c-0.1-0.1-0.2-0.3-0.2-0.5l0.6-6.8c-0.1-0.1-0.2-0.3-0.3-0.4L13,64.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_750_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_743_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1013_",
    className: "st2",
    d: "M17.2,68.1c-3.9-2.2-4.4-3.5-4.4-3.5s-0.2,0.8,0.4,1.6c0.1,0.1,0.2,0.2,0.4,0.4 c1.8,1.9,4.2,3.2,6.7,3.8c0.4,0.1,0.7,0.2,1,0.2c1.5,0.1,1.2-0.4,1.2-0.4S21.2,70.3,17.2,68.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1018_",
    className: "st2",
    d: "M21.8,70.7c-0.1,0-0.3,0-0.4,0c-0.3,0-0.6-0.1-1-0.2c-2.6-0.6-4.9-1.9-6.8-3.9 c-0.2-0.2-0.3-0.3-0.4-0.4c-0.6-0.8-0.5-1.6-0.4-1.6l0.1-0.3l0.1,0.3c0,0,0.5,1.3,4.3,3.4c3.8,2.2,5.3,2.1,5.3,2.1l0.1,0 l0,0.1c0,0.1,0.1,0.2,0,0.3C22.6,70.6,22.3,70.7,21.8,70.7z M13,64.9c0,0.3,0.1,0.7,0.4,1.2c0.1,0.1,0.2,0.2,0.4,0.4 c1.8,1.9,4.1,3.2,6.7,3.8c0.4,0.1,0.7,0.2,1,0.2c0.9,0.1,1-0.1,1.1-0.1c0,0,0,0,0,0c-0.4,0-1.9-0.2-5.3-2.1 C14.3,66.5,13.3,65.4,13,64.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_752_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1017_",
    className: "st3",
    d: "M19.9,69.9c-0.4-0.1-0.7-0.3-1.1-0.5l0.1-0.2c0.4,0.2,0.7,0.3,1.1,0.4L19.9,69.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_742_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1016_",
    className: "st3",
    d: "M18.4,69.2c-0.4-0.2-0.7-0.3-1.1-0.5l0.1-0.2c0.3,0.2,0.7,0.4,1.1,0.5L18.4,69.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_751_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1015_",
    className: "st3",
    d: "M17,68.5c-0.4-0.2-0.8-0.4-1.1-0.7l0.1-0.2c0.4,0.2,0.7,0.5,1.1,0.7L17,68.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_741_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1014_",
    className: "st3",
    d: "M15.6,67.7c-0.4-0.2-0.7-0.5-1-0.7l0.1-0.2c0.3,0.2,0.7,0.5,1,0.7L15.6,67.7z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_838_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_842_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1009_",
    className: "st3",
    d: "M22.9,76.1l-2.3-1.3c-0.2-0.1-0.3-0.5-0.2-0.6l0,0c0.3-0.3,0.8-0.3,1.3-0.1l1.1,0.5 c0.2,0.1,0.4,0.4,0.4,0.6v0.7C23.2,76.1,23.1,76.2,22.9,76.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1010_",
    className: "st2",
    d: "M23.1,76.2c-0.1,0-0.1,0-0.2,0l-2.3-1.3c-0.2-0.1-0.3-0.3-0.3-0.5c0-0.1,0-0.2,0.1-0.3 c0.3-0.3,0.8-0.4,1.4-0.1l1.1,0.5c0.2,0.1,0.4,0.4,0.4,0.7v0.7c0,0.1,0,0.2-0.1,0.3C23.1,76.2,23.1,76.2,23.1,76.2z M23,76 C23,76,23.1,76,23,76c0.1,0,0.1,0,0.1-0.1v-0.7c0-0.2-0.1-0.4-0.3-0.5l-1.1-0.5c-0.5-0.2-0.9-0.2-1.1,0.1c0,0,0,0.1,0,0.1 c0,0.1,0.1,0.3,0.2,0.3L23,76z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_834_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_837_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_997_",
    className: "st3",
    d: "M23,77.6l-1.8-1c-0.2-0.1-0.4-0.4-0.5-0.6l-0.1-0.3c-0.1-0.2,0-0.3,0.2-0.2l2.3,1.3 c0.1,0.1,0.2,0.2,0.2,0.4v0.4C23.2,77.6,23.1,77.7,23,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1000_",
    className: "st2",
    d: "M23.1,77.7c0,0-0.1,0-0.1,0l-1.8-1c-0.2-0.1-0.4-0.4-0.5-0.7l-0.1-0.3 c-0.1-0.1,0-0.3,0.1-0.3c0.1-0.1,0.2-0.1,0.3,0l2.3,1.3c0.2,0.1,0.3,0.3,0.3,0.5v0.4c0,0.1,0,0.2-0.1,0.2 C23.2,77.7,23.1,77.7,23.1,77.7z M20.6,75.4C20.6,75.4,20.6,75.4,20.6,75.4c0,0,0,0,0,0.1l0.1,0.3c0.1,0.2,0.3,0.5,0.4,0.6 l1.8,1c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1v-0.4c0-0.1-0.1-0.2-0.2-0.3L20.6,75.4C20.7,75.4,20.6,75.4,20.6,75.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_865_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_973_",
    className: "st4",
    d: "M23,76.7l-1.8-1.1c-0.1,0-0.1,0.1-0.1,0.2l0.1,0.3c0.1,0.3,0.3,0.5,0.5,0.6l1.4,0.8 c0.1,0,0.1-0.1,0.1-0.2v-0.4C23.2,76.9,23.1,76.8,23,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_977_",
    className: "st2",
    d: "M23.1,77.8C23.1,77.8,23.1,77.8,23.1,77.8L23.1,77.8l-1.5-0.8c-0.2-0.1-0.4-0.4-0.5-0.7 L21,75.9c0-0.1,0-0.2,0-0.3c0-0.1,0.1-0.1,0.2-0.1l0,0l0,0l1.8,1.1c0.2,0.1,0.3,0.3,0.3,0.5v0.4c0,0.1,0,0.2-0.1,0.2 C23.2,77.7,23.2,77.8,23.1,77.8z M21.2,75.7c0,0,0,0.1,0,0.1l0.1,0.3c0.1,0.2,0.3,0.5,0.4,0.6l1.4,0.8c0,0,0,0,0-0.1v-0.4 c0-0.1-0.1-0.2-0.2-0.3L21.2,75.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_828_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_832_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_969_",
    className: "st3",
    d: "M12.3,70l2.3,1.3c0.2,0.1,0.3-0.1,0.2-0.4l0,0c-0.3-0.6-0.8-1.2-1.3-1.6l-1.1-0.8 c-0.2-0.1-0.4-0.1-0.4,0.2v0.7C12.1,69.7,12.2,69.9,12.3,70z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_970_",
    className: "st2",
    d: "M14.7,71.4c-0.1,0-0.1,0-0.2,0L12.3,70c-0.2-0.1-0.3-0.3-0.3-0.5v-0.7 c0-0.1,0.1-0.3,0.2-0.3c0.1-0.1,0.2,0,0.4,0.1l1.1,0.8c0.5,0.4,1,0.9,1.3,1.6c0.1,0.2,0.1,0.4,0,0.5 C14.8,71.4,14.8,71.4,14.7,71.4z M12.4,69.9l2.3,1.3c0,0,0.1,0,0.1,0c0,0,0-0.1,0-0.2c-0.3-0.6-0.7-1.2-1.2-1.5l-1.1-0.8 c-0.1,0-0.1-0.1-0.2,0c0,0,0,0.1,0,0.1v0.7C12.2,69.6,12.3,69.8,12.4,69.9L12.4,69.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_824_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_827_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_965_",
    className: "st3",
    d: "M12.3,71.4l1.8,1c0.2,0.1,0.4,0.1,0.5-0.1l0.1-0.2c0.1-0.1,0-0.3-0.2-0.4l-2.3-1.3 c-0.1-0.1-0.2,0-0.2,0.1V71C12.1,71.2,12.2,71.4,12.3,71.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_966_",
    className: "st2",
    d: "M14.3,72.6c-0.1,0-0.2,0-0.3-0.1l-1.8-1C12.1,71.4,12,71.2,12,71v-0.4 c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.3,0l2.3,1.3c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.2,0,0.2l-0.1,0.2 C14.6,72.6,14.5,72.6,14.3,72.6z M12.3,71.3l1.8,1c0.1,0,0.3,0.1,0.4,0l0.1-0.2c0,0,0,0,0-0.1c0-0.1-0.1-0.2-0.1-0.2 l-2.3-1.3c0,0-0.1,0-0.1,0c0,0,0,0,0,0.1V71C12.2,71.1,12.2,71.3,12.3,71.3L12.3,71.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_864_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_961_",
    className: "st4",
    d: "M14.3,71.7l-2.1-1.2c-0.1-0.1-0.2,0-0.2,0.1V71c0,0.1,0.1,0.3,0.2,0.4l1.6,0.9 c0.1,0,0.3,0,0.3-0.2l0.1-0.2C14.4,71.8,14.4,71.8,14.3,71.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_962_",
    className: "st2",
    d: "M13.9,72.4C13.9,72.4,13.9,72.4,13.9,72.4L13.9,72.4l-1.7-0.9C12.1,71.4,12,71.2,12,71 v-0.4c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.3,0l2.1,1.2l0,0c0,0.1,0,0.2,0,0.3l-0.1,0.2C14.2,72.3,14.1,72.4,13.9,72.4z  M13.9,72.2c0.1,0,0.2,0,0.2-0.1l0.1-0.2c0,0,0-0.1,0-0.1l-2-1.2c0,0-0.1,0-0.1,0c0,0,0,0,0,0.1V71c0,0.1,0.1,0.2,0.2,0.3 L13.9,72.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_823_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_955_",
    className: "st3",
    d: "M18.8,79.3l-2.6-1.5c-0.1-0.1-0.2-0.2-0.2-0.3v-0.6c0-0.1,0.1-0.2,0.2-0.1l2.6,1.5 c0.1,0.1,0.2,0.2,0.2,0.3v0.6C19,79.3,18.9,79.4,18.8,79.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_958_",
    className: "st2",
    d: "M18.9,79.5c0,0-0.1,0-0.1,0l-2.6-1.5c-0.1-0.1-0.2-0.3-0.2-0.4v-0.6c0-0.1,0-0.2,0.1-0.2 c0.1,0,0.1,0,0.2,0l2.6,1.5c0.1,0.1,0.2,0.3,0.2,0.4v0.6C19.1,79.3,19.1,79.4,18.9,79.5C19,79.5,18.9,79.5,18.9,79.5z  M16.2,76.9C16.2,76.9,16.2,76.9,16.2,76.9l0,0.6c0,0.1,0.1,0.2,0.1,0.2l2.6,1.5c0,0,0,0,0,0c0,0,0,0,0-0.1v-0.6 c0-0.1-0.1-0.2-0.1-0.2L16.2,76.9C16.2,76.9,16.2,76.9,16.2,76.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_819_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_957_",
    className: "st2",
    d: "M17.6,76.9l-2.3-1.3c-0.2-0.1-0.5-0.2-0.6-0.1c-0.5,0.3-1.1,0.2-1.8-0.1L12,74.9l0.1-0.2 l0.9,0.5c0.6,0.3,1.1,0.4,1.5,0.1c0.2-0.1,0.5-0.1,0.8,0.1l2.3,1.3L17.6,76.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_818_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_956_",
    className: "st2",
    d: "M23.1,81.2l-0.9-0.5c-0.6-0.4-1.2-1-1.7-1.8c-0.2-0.3-0.4-0.6-0.7-0.7l-2.3-1.3l0.1-0.2 L20,78c0.3,0.2,0.6,0.5,0.8,0.8c0.4,0.7,1,1.4,1.6,1.7l0.9,0.5L23.1,81.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_815_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_817_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_951_",
    className: "st4",
    d: "M13,74.7l-0.6-0.3c-0.1-0.1-0.2-0.3-0.2-0.4v-0.2c0-0.2,0.1-0.2,0.2-0.1l1.1,0.7 c0.1,0.1,0.2,0.3,0.1,0.4l0,0C13.6,74.8,13.3,74.9,13,74.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_952_",
    className: "st2",
    d: "M13.4,74.9c-0.1,0-0.3,0-0.4-0.1l-0.6-0.3c-0.2-0.1-0.3-0.3-0.3-0.5v-0.2 c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.3,0l1.1,0.7c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0,0.2,0,0.2C13.7,74.8,13.6,74.9,13.4,74.9z  M13.1,74.6c0.2,0.1,0.5,0.1,0.6,0c0,0,0,0,0-0.1c0-0.1-0.1-0.1-0.1-0.2l-1.1-0.7c0,0-0.1,0-0.1,0c0,0,0,0,0,0.1v0.2 c0,0.1,0.1,0.3,0.2,0.3L13.1,74.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_816_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_947_",
    className: "st3",
    d: "M12.7,74.2V74c0-0.2,0.1-0.2,0.2-0.1l-0.5-0.3c-0.1-0.1-0.2,0-0.2,0.1v0.2 c0,0.2,0.1,0.4,0.2,0.4l0.5,0.3C12.8,74.5,12.7,74.4,12.7,74.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_948_",
    className: "st2",
    d: "M12.9,74.7C12.9,74.7,12.9,74.7,12.9,74.7l-0.5-0.3c-0.2-0.1-0.3-0.3-0.3-0.5v-0.2 c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.3,0l0.5,0.3L12.9,74c0,0-0.1,0-0.1,0c0,0,0,0,0,0.1v0.2c0,0.1,0.1,0.3,0.2,0.3l0,0 L12.9,74.7z M12.4,73.7C12.3,73.7,12.3,73.7,12.4,73.7C12.3,73.7,12.3,73.7,12.4,73.7l0,0.3c0,0.1,0.1,0.3,0.2,0.3l0.1,0 c0,0,0-0.1,0-0.1V74c0-0.1,0-0.1,0.1-0.2L12.4,73.7C12.4,73.7,12.4,73.7,12.4,73.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_812_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_814_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_943_",
    className: "st4",
    d: "M22.3,80.1l0.6,0.3c0.1,0.1,0.2,0,0.2-0.1v-0.2c0-0.2-0.1-0.4-0.2-0.4L21.8,79 c-0.1-0.1-0.2,0-0.1,0.2l0,0C21.8,79.6,22,79.9,22.3,80.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_944_",
    className: "st2",
    d: "M23,80.5c-0.1,0-0.1,0-0.2,0l-0.6-0.3c-0.3-0.2-0.6-0.5-0.7-0.9c0-0.1,0-0.2,0-0.3 c0.1-0.1,0.2-0.1,0.2,0l1.1,0.7c0.2,0.1,0.3,0.3,0.3,0.5v0.2c0,0.1,0,0.2-0.1,0.2C23.1,80.5,23.1,80.5,23,80.5z M21.7,79.1 C21.7,79.1,21.7,79.1,21.7,79.1c0.2,0.4,0.4,0.8,0.7,0.9l0.6,0.3c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1v-0.2c0-0.1-0.1-0.3-0.2-0.3 L21.7,79.1C21.7,79.1,21.7,79.1,21.7,79.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_813_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_939_",
    className: "st3",
    d: "M22.7,80v-0.2c0-0.2-0.1-0.4-0.2-0.4l0.5,0.3c0.1,0.1,0.2,0.3,0.2,0.4v0.2 c0,0.2-0.1,0.2-0.2,0.1l-0.5-0.3C22.6,80.2,22.7,80.1,22.7,80z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_940_",
    className: "st2",
    d: "M23,80.5c-0.1,0-0.1,0-0.2,0l-0.5-0.3c0,0,0,0,0,0l0.1-0.2l0,0h0c0,0,0.1,0,0.1,0 c0,0,0,0,0-0.1v-0.2c0-0.1-0.1-0.3-0.2-0.3l0,0l0.1-0.2c0,0,0,0,0,0l0.5,0.3c0.2,0.1,0.3,0.3,0.3,0.5v0.2 c0,0.1,0,0.2-0.1,0.2C23.1,80.5,23.1,80.5,23,80.5z M22.7,80.2l0.2,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1v-0.2 c0-0.1-0.1-0.3-0.2-0.3l-0.1,0c0,0,0,0.1,0,0.1V80C22.8,80.1,22.8,80.1,22.7,80.2z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_800_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_833_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_935_",
    className: "st3",
    d: "M20.7,72.2L20.7,72.2c-2.1-0.9-4.1-2-5.9-3.4l-0.2-0.1c-0.1,0-0.1,0,0,0.1 c0.2,0.4,0.7,1.2,0.9,2.2c0.2,1,0.1,1.5,0,1.7c0,0.1,0,0.2,0.1,0.2l2.1,1.2l2.1,1.2c0.1,0,0.1,0,0.1-0.1 c-0.1-0.3-0.3-1,0-1.7c0.2-0.7,0.7-1,0.9-1.1C20.8,72.4,20.7,72.3,20.7,72.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_936_",
    className: "st2",
    d: "M19.8,75.4c0,0-0.1,0-0.1,0L15.5,73c-0.1,0-0.1-0.1-0.2-0.2c0-0.1,0-0.1,0-0.2 c0.1-0.2,0.3-0.6,0-1.6c-0.2-1-0.7-1.8-0.9-2.2c-0.1-0.1-0.1-0.2,0-0.2c0,0,0.1-0.1,0.2,0l0.2,0.1c1.8,1.3,3.8,2.5,5.9,3.4 l0,0c0.1,0,0.1,0.1,0.1,0.2c0,0.1,0,0.1-0.1,0.1c-0.2,0.1-0.7,0.4-0.9,1c-0.2,0.7-0.1,1.3,0,1.6 C19.9,75.2,19.9,75.3,19.8,75.4C19.8,75.4,19.8,75.4,19.8,75.4z M14.7,68.9c0.3,0.4,0.6,1.2,0.9,2.1c0.3,1,0.1,1.5,0,1.7 c0,0,0,0.1,0.1,0.1l4.1,2.4c-0.1-0.3-0.3-1,0-1.7c0.2-0.7,0.7-1,1-1.1c0,0,0,0,0,0C18.5,71.4,16.6,70.3,14.7,68.9L14.7,68.9z "
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_811_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_927_",
    className: "st4",
    d: "M18.3,71.3l-1-0.6c-0.1-0.1-0.2-0.2-0.2-0.4l0,0c0-0.1,0.1-0.2,0.2-0.1l1,0.6 c0.1,0.1,0.2,0.2,0.2,0.4l0,0C18.5,71.3,18.4,71.4,18.3,71.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_932_",
    className: "st2",
    d: "M18.4,71.4c0,0-0.1,0-0.1,0l-1-0.6c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.1,0-0.2,0.1-0.2 c0.1,0,0.2,0,0.2,0l1,0.6c0.1,0.1,0.2,0.3,0.2,0.5c0,0.1,0,0.2-0.1,0.2C18.4,71.4,18.4,71.4,18.4,71.4z M18.3,71.2 C18.4,71.2,18.4,71.2,18.3,71.2C18.4,71.2,18.4,71.2,18.3,71.2c0-0.2,0-0.3-0.1-0.4l-1-0.6c0,0,0,0,0,0c0,0,0,0,0,0.1 c0,0.1,0.1,0.2,0.1,0.3L18.3,71.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_809_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_931_",
    x: 17.6,
    y: 69.7,
    transform: "matrix(0.5 -0.866 0.866 0.5 -53.4134 51.1896)",
    className: "st2",
    width: 0.2,
    height: 4.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_808_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_930_",
    x: 17.6,
    y: 70.4,
    transform: "matrix(0.5 -0.866 0.866 0.5 -53.8325 51.4356)",
    className: "st2",
    width: 0.2,
    height: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_807_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_929_",
    x: 17.6,
    y: 70.9,
    transform: "matrix(0.5 -0.866 0.866 0.5 -54.236 51.6668)",
    className: "st2",
    width: 0.2,
    height: 3.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_806_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_928_",
    x: 17.6,
    y: 71.4,
    transform: "matrix(0.5 -0.866 0.866 0.5 -54.6531 51.9062)",
    className: "st2",
    width: 0.2,
    height: 3.9
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_805_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_923_",
    className: "st4",
    d: "M16.2,76.3L16.2,76.3C16.1,76.2,16,76.1,16,76v-0.3c0-0.1,0.1-0.2,0.2-0.1l0,0 c0.1,0,0.2,0.2,0.2,0.3v0.3C16.3,76.3,16.3,76.3,16.2,76.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_924_",
    className: "st2",
    d: "M16.2,76.4c0,0-0.1,0-0.1,0l0,0c-0.1-0.1-0.2-0.2-0.2-0.4v-0.3c0-0.1,0-0.2,0.1-0.2 c0.1,0,0.1,0,0.2,0l0,0c0.1,0.1,0.2,0.2,0.2,0.4v0.3C16.4,76.3,16.4,76.4,16.2,76.4C16.3,76.4,16.3,76.4,16.2,76.4z  M16.1,75.6C16.1,75.6,16.1,75.6,16.1,75.6l0,0.4c0,0.1,0.1,0.2,0.1,0.2l0,0c0,0,0,0,0,0v-0.3C16.2,75.8,16.2,75.7,16.1,75.6 L16.1,75.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_804_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_919_",
    className: "st4",
    d: "M16.9,76.7L16.9,76.7c-0.1-0.1-0.2-0.2-0.2-0.3v-0.3c0-0.1,0.1-0.2,0.2-0.1l0,0 c0.1,0,0.2,0.2,0.2,0.3v0.3C17.1,76.7,17,76.8,16.9,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_920_",
    className: "st2",
    d: "M17,76.9c0,0-0.1,0-0.1,0h0l0,0c-0.1-0.1-0.2-0.2-0.2-0.4v-0.3c0-0.1,0-0.2,0.1-0.2 c0.1,0,0.1,0,0.2,0l0,0c0.1,0.1,0.2,0.2,0.2,0.4v0.3C17.2,76.7,17.2,76.8,17,76.9C17.1,76.9,17,76.9,17,76.9z M16.9,76.1 C16.9,76.1,16.9,76.1,16.9,76.1l0,0.4c0,0.1,0.1,0.2,0.1,0.2l0,0c0,0,0,0,0,0v-0.3C17,76.2,16.9,76.1,16.9,76.1L16.9,76.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_803_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_915_",
    className: "st4",
    d: "M17.7,77.2L17.7,77.2c-0.1-0.1-0.2-0.2-0.2-0.3v-0.3c0-0.1,0.1-0.2,0.2-0.1l0,0 c0.1,0,0.2,0.2,0.2,0.3v0.3C17.9,77.2,17.8,77.2,17.7,77.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_916_",
    className: "st2",
    d: "M17.8,77.3c0,0-0.1,0-0.1,0h0l0,0c-0.1-0.1-0.2-0.2-0.2-0.4v-0.3c0-0.1,0-0.2,0.1-0.2 c0.1,0,0.1,0,0.2,0l0,0c0.1,0.1,0.2,0.2,0.2,0.4v0.3C18,77.2,17.9,77.2,17.8,77.3C17.8,77.3,17.8,77.3,17.8,77.3z M17.6,76.5 C17.6,76.5,17.6,76.5,17.6,76.5l0,0.4c0,0.1,0.1,0.2,0.1,0.2l0,0c0,0,0,0,0,0v-0.3C17.8,76.6,17.7,76.5,17.6,76.5L17.6,76.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_802_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_911_",
    className: "st4",
    d: "M18.5,77.6L18.5,77.6c-0.1-0.1-0.2-0.2-0.2-0.3V77c0-0.1,0.1-0.2,0.2-0.1l0,0 c0.1,0,0.2,0.2,0.2,0.3v0.3C18.6,77.6,18.6,77.7,18.5,77.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_912_",
    className: "st2",
    d: "M18.5,77.7c0,0-0.1,0-0.1,0l0,0c-0.1-0.1-0.2-0.2-0.2-0.4V77c0-0.1,0-0.2,0.1-0.2 c0.1,0,0.1,0,0.2,0l0,0c0.1,0.1,0.2,0.2,0.2,0.4v0.3C18.7,77.6,18.7,77.7,18.5,77.7C18.6,77.7,18.6,77.7,18.5,77.7z M18.4,77 C18.4,77,18.4,77,18.4,77l0,0.4c0,0.1,0.1,0.2,0.1,0.2l0,0c0,0,0,0,0,0v-0.3C18.5,77.1,18.5,77,18.4,77L18.4,77z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_801_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_841_",
    className: "st4",
    d: "M19.2,78.1L19.2,78.1c-0.1-0.1-0.2-0.2-0.2-0.3v-0.3c0-0.1,0.1-0.2,0.2-0.1l0,0 c0.1,0,0.2,0.2,0.2,0.3v0.3C19.4,78.1,19.3,78.1,19.2,78.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_867_",
    className: "st2",
    d: "M19.3,78.2c0,0-0.1,0-0.1,0l0,0C19,78.1,19,77.9,19,77.8v-0.3c0-0.1,0-0.2,0.1-0.2 c0.1,0,0.1,0,0.2,0l0,0c0.1,0.1,0.2,0.2,0.2,0.4v0.3C19.5,78,19.4,78.1,19.3,78.2C19.4,78.2,19.3,78.2,19.3,78.2z M19.2,77.4 C19.2,77.4,19.2,77.4,19.2,77.4l0,0.4c0,0.1,0.1,0.2,0.1,0.2l0,0c0,0,0,0,0,0v-0.3C19.3,77.5,19.2,77.4,19.2,77.4L19.2,77.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_723_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_330_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_718_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_795_",
    className: "st2",
    d: "M13,56.9c0,0,0.5,1.9,4.2,4.1c3.7,2.2,5.4,2.1,6.2,1.9c0,0,0.2-0.8,0.8-1.1 c0.6-0.3,0.9-1,0.3-1.5c-0.5-0.5-8.9-5.3-10.4-6.2c-0.2-0.1-0.3-0.1-0.5,0C13.5,54.4,13.1,55.4,13,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_796_",
    className: "st2",
    d: "M22.7,63.1c-1.3,0-3.1-0.7-5.5-2c-3.7-2.2-4.3-4-4.3-4.1l0,0l0,0 c0.1-1.5,0.5-2.6,0.8-2.9c0.2-0.1,0.4-0.2,0.6-0.1c1.6,1,9.9,5.7,10.4,6.2c0.2,0.2,0.3,0.5,0.3,0.8c0,0.3-0.3,0.7-0.7,0.9 c-0.5,0.3-0.8,1.1-0.8,1.1l0,0.1l-0.1,0C23.3,63,23,63.1,22.7,63.1z M13.2,56.9c0.1,0.2,0.7,2,4.2,4 c2.7,1.6,4.8,2.2,6.1,1.9c0.1-0.2,0.3-0.8,0.8-1.1c0.3-0.2,0.5-0.5,0.6-0.8c0-0.2-0.1-0.4-0.2-0.6 c-0.4-0.4-5.8-3.5-10.3-6.2c-0.1-0.1-0.3-0.1-0.4,0C13.6,54.4,13.2,55.5,13.2,56.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_740_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_791_",
    className: "st4",
    d: "M13.8,54.1c-0.3,0.3-0.7,1.4-0.8,2.8c0,0,0.5,1.9,4.2,4.1c1.6,0.9,2.8,1.4,3.7,1.7 c0,0,1.5-0.7,2.3-1.7c0.8-1,0.6-1.4,0.3-1.6c-2.5-1.5-8-4.7-9.2-5.4C14.2,53.9,14,54,13.8,54.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_792_",
    className: "st2",
    d: "M21,62.8L21,62.8c-1.1-0.3-2.3-0.9-3.8-1.7c-3.7-2.2-4.3-4-4.3-4.1l0,0l0,0 c0.1-1.5,0.5-2.6,0.8-2.9v0c0.2-0.1,0.4-0.2,0.6-0.1c1.1,0.6,6.8,3.9,9.2,5.4c0.2,0.1,0.3,0.2,0.3,0.4 c0.1,0.3-0.1,0.7-0.6,1.3C22.5,62.1,21.1,62.7,21,62.8L21,62.8z M13.2,56.9c0.1,0.2,0.7,2,4.2,4c1.4,0.8,2.6,1.4,3.6,1.7 c0.2-0.1,1.5-0.7,2.2-1.6c0.5-0.6,0.5-1,0.5-1.1c0-0.1-0.1-0.2-0.2-0.3c-2.5-1.5-8.1-4.8-9.2-5.4c-0.1-0.1-0.3-0.1-0.4,0 C13.6,54.4,13.2,55.5,13.2,56.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_845_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_786_",
    className: "st3",
    d: "M23.1,60.2c-2.5-1.5-8-4.7-9.2-5.4c-0.2-0.1-0.3-0.1-0.5,0c0,0,0,0,0,0 c-0.2,0.5-0.3,1.2-0.4,2.1c0,0,0.5,1.9,4.2,4.1c1.6,0.9,2.8,1.4,3.7,1.7c0,0,1.5-0.7,2.3-1.7c0,0,0.1-0.1,0.1-0.1 C23.5,60.5,23.3,60.3,23.1,60.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_788_",
    className: "st2",
    d: "M21,62.8L21,62.8c-1.1-0.3-2.3-0.9-3.8-1.7c-3.7-2.2-4.3-4-4.3-4.1l0,0l0,0 c0-0.8,0.2-1.5,0.4-2.1l0,0l0,0c0,0,0,0,0,0c0.2-0.1,0.4-0.2,0.6-0.1c1.1,0.6,6.7,3.9,9.2,5.4h0c0.3,0.2,0.4,0.4,0.3,0.8 l0,0c0,0.1-0.1,0.1-0.1,0.1C22.5,62.1,21.1,62.7,21,62.8L21,62.8z M13.2,56.9c0.1,0.2,0.7,2,4.2,4c1.4,0.8,2.6,1.4,3.6,1.7 c0.2-0.1,1.5-0.7,2.2-1.6c0,0,0.1-0.1,0.1-0.1c0.1-0.3,0-0.5-0.2-0.6h0c-2.5-1.5-8.1-4.8-9.2-5.4c-0.1-0.1-0.3-0.1-0.4,0 C13.3,55.4,13.2,56.1,13.2,56.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_722_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_787_",
    className: "st3",
    d: "M23.7,62.7l-0.2-0.1c0,0,0.2-0.6,0.6-0.9c0.1,0,0.1-0.1,0.2-0.1 c0.4-0.3,0.7-0.5,0.5-1.1l0.2-0.1c0.3,0.7-0.2,1-0.6,1.3c-0.1,0-0.1,0.1-0.2,0.1C23.9,62.2,23.7,62.7,23.7,62.7z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_820_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_782_",
    className: "st3",
    d: "M19.9,77l-4.6-2.7c-0.2-0.1-0.3-0.3-0.3-0.6l0,0c0-0.2,0.1-0.3,0.3-0.2l4.6,2.7 c0.2,0.1,0.3,0.3,0.3,0.6l0,0C20.1,76.9,20,77,19.9,77z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_783_",
    className: "st2",
    d: "M20,77.1c-0.1,0-0.1,0-0.2,0v0l-4.6-2.7c-0.2-0.1-0.3-0.4-0.3-0.6c0-0.1,0.1-0.3,0.2-0.3 c0.1,0,0.2,0,0.3,0l4.6,2.7c0.2,0.1,0.3,0.4,0.3,0.6c0,0.1-0.1,0.3-0.2,0.3C20.1,77.1,20,77.1,20,77.1z M19.9,76.9 C19.9,76.9,20,76.9,19.9,76.9c0.1,0,0.1,0,0.1-0.1c0-0.2-0.1-0.4-0.2-0.5l-4.6-2.7c0,0-0.1,0-0.1,0c0,0,0,0.1,0,0.1 c0,0.2,0.1,0.4,0.2,0.5L19.9,76.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_844_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_778_",
    className: "st4",
    d: "M17.3,68c3.9,2.2,5.3,2.1,5.3,2.1l0.1-0.8c-1.3-0.4-2.9-1-4.7-2c-2.9-1.6-4-2.5-4.4-2.9 c-0.1-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0,0c-0.5,0.2-0.6,0.4-0.6,0.4S13.3,65.8,17.3,68z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_779_",
    className: "st2",
    d: "M22.6,70.3c-0.3,0-1.8-0.1-5.4-2.1c-3.9-2.2-4.4-3.5-4.4-3.5l0-0.1l0.1,0 c0,0,0.2-0.2,0.6-0.4l0,0l0.1,0l0,0.1c0,0.1,0.1,0.1,0.1,0.2c0.4,0.4,1.5,1.3,4.3,2.9c1.5,0.8,3.1,1.5,4.7,2l0.1,0l-0.1,1 L22.6,70.3C22.6,70.3,22.6,70.3,22.6,70.3z M13,64.6c0.2,0.3,1,1.5,4.3,3.4c3.3,1.9,4.8,2.1,5.2,2.1l0.1-0.7 c-1.6-0.5-3.2-1.2-4.6-2c-2.8-1.6-4-2.5-4.4-2.9c0,0-0.1-0.1-0.1-0.1C13.2,64.4,13.1,64.5,13,64.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_332_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_774_",
    className: "st3",
    d: "M15.6,55.6c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3 C15.5,55.2,15.6,55.4,15.6,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_775_",
    className: "st2",
    d: "M15.3,56c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4 C15.7,55.8,15.5,56,15.3,56z M15.3,55.4c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2 C15.5,55.5,15.4,55.4,15.3,55.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_822_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_770_",
    className: "st3",
    cx: 21.7,
    cy: 59.3,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_771_",
    className: "st2",
    d: "M21.7,59.8c-0.2,0-0.4-0.2-0.4-0.4s0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4 S22,59.8,21.7,59.8z M21.7,59.1c-0.1,0-0.2,0.1-0.2,0.2s0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2S21.9,59.1,21.7,59.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_843_"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_766_",
    className: "st3",
    cx: 18.4,
    cy: 57.4,
    r: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_767_",
    className: "st2",
    d: "M18.4,57.9c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4 C18.9,57.7,18.7,57.9,18.4,57.9z M18.4,57.2c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2 C18.6,57.3,18.5,57.2,18.4,57.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_847_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_762_",
    className: "st3",
    d: "M17.2,56.5c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3 C17,56.2,17.2,56.3,17.2,56.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_763_",
    className: "st2",
    d: "M16.8,56.9c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4 C17.3,56.7,17.1,56.9,16.8,56.9z M16.8,56.3c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2 C17.1,56.4,17,56.3,16.8,56.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_848_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_757_",
    className: "st3",
    d: "M20.4,58.3c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3 C20.3,58,20.4,58.2,20.4,58.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_759_",
    className: "st2",
    d: "M20.1,58.8c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4 C20.5,58.6,20.3,58.8,20.1,58.8z M20.1,58.1c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2 C20.3,58.2,20.2,58.1,20.1,58.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_851_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_846_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_758_",
    x: 19.7,
    y: 64.9,
    transform: "matrix(0.8174 -0.5761 0.5761 0.8174 -35.1192 23.7076)",
    className: "st2",
    width: 0.2,
    height: 4.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_821_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_746_",
    className: "st2",
    points: "19.6,66.9 20,68 20.2,68.4 20.7,68.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_747_",
    className: "st2",
    d: "M21,68.8l-0.9-0.4l-0.3-0.4l-0.7-1.8L21,68.8z M20.3,68.3l0.2,0.1L20,67.6l0.1,0.4 L20.3,68.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_850_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_724_",
    className: "st2",
    points: "20.2,68.3 20.2,68.9 20.6,69.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_745_",
    className: "st2",
    points: "20.5,69.7 20.1,68.9 20.1,68.3 20.3,68.3 20.3,68.9 20.7,69.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_853_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_856_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_744_",
    x: 15.6,
    y: 62.9,
    transform: "matrix(0.8174 -0.5761 0.5761 0.8174 -34.7077 20.9795)",
    className: "st2",
    width: 0.2,
    height: 4.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_855_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_705_",
    className: "st2",
    points: "15.5,64.9 15.9,66 16.1,66.4 16.6,66.6  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_708_",
    className: "st2",
    d: "M16.9,66.8l-0.9-0.4l-0.3-0.4l-0.7-1.8L16.9,66.8z M16.2,66.3l0.2,0.1l-0.5-0.7L16,66 L16.2,66.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_854_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_693_",
    className: "st2",
    points: "16.1,66.3 16.1,66.9 16.5,67.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_703_",
    className: "st2",
    points: "16.4,67.7 16,66.9 16,66.3 16.2,66.2 16.2,66.8 16.6,67.6  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_858_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_696_",
    x: 21.8,
    y: 67.8,
    transform: "matrix(8.794861e-02 -0.9961 0.9961 8.794861e-02 -47.4219 84.0562)",
    className: "st2",
    width: 0.7,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_852_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_695_",
    x: 21.4,
    y: 66.2,
    transform: "matrix(0.1075 -0.9942 0.9942 0.1075 -45.9424 81.3769)",
    className: "st2",
    width: 1.9,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_860_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_658_",
    className: "st3",
    d: "M32.3,52l-8.3-4.6c0,0-4.7,3.4-6.6,5.8c-0.2,0.2-0.1,0.5,0.1,0.6l6.9,4.1 c0.3,0.2,0.8,0.1,1-0.2c0.7-0.7,1.9-2.1,3-3C30.2,53.5,32.3,52,32.3,52z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_659_",
    className: "st2",
    d: "M25,58.1c-0.2,0-0.3,0-0.5-0.1l-6.9-4.1c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1,0-0.3,0.1-0.4 c1.9-2.4,6.6-5.8,6.6-5.8l0,0l8.4,4.7l-0.1,0.1c0,0-2.1,1.5-3.7,2.7c-1.1,0.9-2.4,2.2-3,3C25.5,58,25.2,58.1,25,58.1z  M24.1,47.5c-0.5,0.4-4.7,3.5-6.5,5.7c-0.1,0.1-0.1,0.2-0.1,0.3c0,0.1,0.1,0.2,0.1,0.2l6.9,4.1c0.3,0.2,0.7,0.1,0.9-0.1 c0.7-0.7,1.9-2.1,3-3c1-0.8,3-2.3,3.6-2.7L24.1,47.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_863_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_654_",
    className: "st4",
    d: "M25.2,47.8c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3 C25,47.5,25.2,47.7,25.2,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_655_",
    className: "st2",
    d: "M24.8,48.3c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4 C25.3,48.1,25.1,48.3,24.8,48.3z M24.8,47.6c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2 C25.1,47.7,25,47.6,24.8,47.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_862_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_650_",
    className: "st4",
    d: "M31.6,51.6c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3 C31.5,51.3,31.6,51.4,31.6,51.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_651_",
    className: "st2",
    d: "M31.3,52c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4 C31.7,51.8,31.5,52,31.3,52z M31.3,51.4c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2 C31.5,51.5,31.4,51.4,31.3,51.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_859_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_641_",
    className: "st4",
    d: "M28.3,49.7c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3 C28.2,49.4,28.3,49.5,28.3,49.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_643_",
    className: "st2",
    d: "M28,50.1c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4s0.4,0.2,0.4,0.4 C28.4,49.9,28.2,50.1,28,50.1z M28,49.5c-0.1,0-0.2,0.1-0.2,0.2s0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2S28.1,49.5,28,49.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_857_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_636_",
    className: "st4",
    d: "M26.7,48.7c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3 C26.6,48.4,26.7,48.6,26.7,48.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_637_",
    className: "st2",
    d: "M26.4,49.2c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4 C26.8,49,26.6,49.2,26.4,49.2z M26.4,48.5c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2 C26.6,48.6,26.5,48.5,26.4,48.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_748_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_631_",
    className: "st4",
    d: "M30,50.6c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3 C29.8,50.3,30,50.4,30,50.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_633_",
    className: "st2",
    d: "M29.6,51c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.2,0,0.4,0.2,0.4,0.4 C30.1,50.8,29.9,51,29.6,51z M29.6,50.4c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2 C29.9,50.5,29.8,50.4,29.6,50.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_826_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_632_",
    x: 21.5,
    y: 51.7,
    transform: "matrix(0.5096 -0.8604 0.8604 0.5096 -37.0697 45.7692)",
    className: "st2",
    width: 0.2,
    height: 7.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_839_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_627_",
    className: "st4",
    d: "M12.7,68.8l-0.3-0.2c-0.2-0.1-0.4-0.1-0.4,0.2v0.7c0,0.2,0.1,0.4,0.3,0.5l1.8,1l0,0 C14.2,69.9,12.7,68.8,12.7,68.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_628_",
    className: "st2",
    d: "M14.2,71.2l-1.9-1.1C12.1,70,12,69.7,12,69.5v-0.7c0-0.1,0.1-0.3,0.2-0.3 c0.1-0.1,0.2,0,0.4,0.1l0.3,0.2c0.1,0,1.5,1.2,1.4,2.3L14.2,71.2z M12.2,68.6C12.2,68.6,12.2,68.6,12.2,68.6 c-0.1,0-0.1,0.1-0.1,0.1v0.7c0,0.1,0.1,0.3,0.2,0.4l1.6,0.9c-0.1-0.9-1.3-1.9-1.4-2l-0.3-0.2C12.3,68.6,12.3,68.6,12.2,68.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_835_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_620_",
    className: "st4",
    d: "M22.8,74.6l-0.3-0.1c-1.5-0.4-1.7,0.4-1.7,0.4l2.1,1.2c0.1,0.1,0.3,0,0.3-0.2v-0.7 C23.2,75,23,74.7,22.8,74.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_623_",
    className: "st2",
    d: "M23.1,76.2c-0.1,0-0.1,0-0.2,0l-2.2-1.2l0-0.1c0,0,0-0.3,0.3-0.4 c0.3-0.2,0.8-0.2,1.5-0.1l0.3,0.2c0.2,0.1,0.4,0.4,0.4,0.7v0.7c0,0.1,0,0.2-0.1,0.3C23.1,76.2,23.1,76.2,23.1,76.2z M21,74.8 l2,1.2c0,0,0.1,0,0.1,0c0,0,0,0,0-0.1v-0.7c0-0.2-0.1-0.4-0.3-0.5l0,0l-0.3-0.1c-0.7-0.2-1.1-0.1-1.3,0.1 C21.1,74.7,21,74.8,21,74.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_825_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_622_",
    x: 13.2,
    y: 69.3,
    transform: "matrix(0.5091 -0.8607 0.8607 0.5091 -53.7363 45.8499)",
    className: "st2",
    width: 0.2,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_829_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_621_",
    x: 21.7,
    y: 74.2,
    transform: "matrix(0.5091 -0.8607 0.8607 0.5091 -53.7731 55.5017)",
    className: "st2",
    width: 0.2,
    height: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_875_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_882_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_615_",
    className: "st3",
    d: "M25.5,68.1l-0.4-0.2c-0.1-0.1-0.2-0.1-0.3,0L24.4,68l0.3,1v0.9c0,0.2,0.1,0.4,0.3,0.4 l-0.2,0.2l0.3,0.1l0.4-0.2l0,0c0.2-0.1,0.3-0.4,0.3-0.7v-0.8C25.9,68.5,25.7,68.2,25.5,68.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_617_",
    className: "st2",
    d: "M25.1,70.5l-0.5-0.1l0.2-0.2c-0.1-0.1-0.2-0.3-0.2-0.4V69l-0.3-1l0.4-0.2 c0.1-0.1,0.3-0.1,0.4,0l0.4,0.2c0.2,0.1,0.4,0.5,0.4,0.7v0.8c0,0.4-0.1,0.7-0.4,0.8L25.1,70.5z M25,70.3L25,70.3l0.5-0.2 c0.2-0.1,0.3-0.3,0.3-0.6v-0.8c0-0.2-0.1-0.5-0.3-0.6L25,67.9c0,0-0.1-0.1-0.2,0l0,0l-0.3,0.2l0.3,0.9v0.9 c0,0.1,0.1,0.3,0.2,0.3l0.2,0L25,70.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_881_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_608_",
    className: "st3",
    d: "M25.9,67.2c0-0.1-0.1-0.3-0.2-0.4l-0.8-0.4c0,0-0.1,0-0.1,0l-0.4,0.2c0,0,0,0,0,0l1,1.2 c0,0,0,0,0,0l0.4-0.3c0,0,0.1-0.1,0.1-0.1V67.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_610_",
    className: "st2",
    d: "M25.4,68L25.4,68l-1.1-1.3l0-0.1l0,0l0.4-0.2c0,0,0.1,0,0.2,0l0.8,0.4 c0.1,0.1,0.2,0.3,0.2,0.5v0.3c0,0.1-0.1,0.2-0.1,0.2l0,0L25.4,68z M24.5,66.7l0.9,1.1l0.3-0.2c0,0,0-0.1,0-0.1v-0.3 c0-0.1-0.1-0.2-0.1-0.3l-0.8-0.4c0,0,0,0,0,0L24.5,66.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_877_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_880_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_600_",
    className: "st3",
    d: "M24.7,70.5l-0.2,0c-0.1,0-0.3-0.2-0.3-0.4v-1.8c0-0.2,0.2-0.3,0.4-0.2l0.4,0.2 c0.2,0.1,0.4,0.4,0.4,0.6v0.8C25.4,70.3,25.2,70.6,24.7,70.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_603_",
    className: "st2",
    d: "M24.8,70.6c0,0-0.1,0-0.1,0l-0.2,0c-0.2,0-0.4-0.3-0.4-0.5v-1.8c0-0.2,0.1-0.3,0.2-0.3 c0.1-0.1,0.2,0,0.4,0l0.4,0.2c0.2,0.1,0.4,0.5,0.4,0.7v0.8c0,0.3-0.1,0.6-0.3,0.7C25.1,70.6,25,70.6,24.8,70.6z M24.5,68.1 C24.5,68.1,24.4,68.1,24.5,68.1c-0.1,0-0.1,0.1-0.1,0.2v1.8c0,0.1,0.1,0.3,0.2,0.3l0.2,0c0.2,0,0.3,0,0.4-0.1 c0.1-0.1,0.2-0.3,0.2-0.6v-0.8c0-0.2-0.1-0.5-0.3-0.6l-0.4-0.2C24.6,68.1,24.5,68.1,24.5,68.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_878_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_593_",
    className: "st3",
    d: "M25.2,67.9l-0.8-0.4c-0.1-0.1-0.2-0.2-0.2-0.4v-0.3c0-0.1,0.1-0.2,0.2-0.2l0.8,0.4 c0.1,0.1,0.2,0.2,0.2,0.4v0.3C25.4,67.9,25.3,68,25.2,67.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_594_",
    className: "st2",
    d: "M25.3,68c0,0-0.1,0-0.1,0v0l-0.8-0.4c-0.1-0.1-0.2-0.3-0.2-0.5v-0.3 c0-0.1,0-0.2,0.1-0.2c0.1,0,0.2,0,0.2,0l0.8,0.4c0.1,0.1,0.2,0.3,0.2,0.5v0.3c0,0.1,0,0.2-0.1,0.2C25.4,68,25.4,68,25.3,68z  M25.3,67.8C25.3,67.8,25.3,67.8,25.3,67.8C25.3,67.8,25.3,67.8,25.3,67.8l0-0.3c0-0.1-0.1-0.2-0.1-0.3l-0.8-0.4 c0,0,0,0,0,0c0,0,0,0,0,0.1v0.3c0,0.1,0.1,0.2,0.1,0.3L25.3,67.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_692_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_871_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_586_",
    className: "st4",
    d: "M44.6,65.1l-0.4-0.2c-0.1-0.1-0.2-0.1-0.3,0l-3.6,2.1c0,0,0,0,0,0l0.3,0.9v0.9 c0,0.2,0.1,0.4,0.3,0.4l-0.2,0.2l0.3,0.1l3.7-2.1l0,0c0.2-0.1,0.3-0.4,0.3-0.7v-0.8C44.9,65.5,44.8,65.2,44.6,65.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_587_",
    className: "st2",
    d: "M41,69.4l-0.5-0.1l0.2-0.2c-0.1-0.1-0.2-0.3-0.2-0.4v-0.8L40.1,67c0-0.1,0-0.1,0.1-0.1 l3.6-2c0.1-0.1,0.3-0.1,0.4,0l0.4,0.2c0.2,0.1,0.4,0.5,0.4,0.7v0.8c0,0.3-0.1,0.6-0.3,0.8v0l-0.1,0L41,69.4z M40.8,69.2 L40.8,69.2l3.7-2.1c0.2-0.1,0.3-0.3,0.3-0.6v-0.8c0-0.2-0.1-0.5-0.3-0.6L44.1,65c0,0-0.1-0.1-0.2,0l0,0l-3.6,2l0.3,0.9v0.9 c0,0.1,0.1,0.3,0.2,0.3l0.2,0L40.8,69.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_872_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_573_",
    className: "st3",
    d: "M44.9,65.6C44.9,65.6,44.9,65.6,44.9,65.6c0-0.1,0-0.1,0-0.1c0,0,0,0,0,0 c0,0-0.1,0-0.1-0.1l0.1,0l-3.7,2.1l-0.6,0.4l0,0.1v0.9v0c0,0.2,0.1,0.4,0.3,0.4l-0.2,0.2l0.3,0.1l3.7-2.1l0,0 c0.2-0.1,0.3-0.4,0.3-0.7v-0.8C44.9,65.8,44.9,65.7,44.9,65.6C44.9,65.7,44.9,65.7,44.9,65.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_574_",
    className: "st2",
    d: "M41,69.5l-0.5-0.1l0.2-0.2c-0.1-0.1-0.2-0.3-0.2-0.4v-0.8l0-0.1l0.7-0.4l3.8-2.1l0,0.1 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0.1,0,0.1l0,0l-0.1,0l0.1,0c0,0,0,0,0,0.1c0,0,0,0.1,0,0.1v0.8c0,0.3-0.1,0.6-0.3,0.8v0 l-0.1,0L41,69.5z M40.8,69.2L40.8,69.2l3.7-2.1c0.2-0.1,0.3-0.3,0.3-0.6v-0.8c0,0,0,0,0-0.1c0,0,0,0,0-0.1l0,0c0,0,0,0,0-0.1 c0,0,0,0,0,0l-4.2,2.3l0,0v0.9c0,0.1,0.1,0.3,0.2,0.3l0.2,0L40.8,69.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_831_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_869_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_559_",
    className: "st3",
    d: "M40.6,69.4l-0.2,0c-0.1,0-0.3-0.2-0.3-0.4v-1.8c0-0.2,0.2-0.3,0.4-0.2l0.4,0.2 c0.2,0.1,0.4,0.4,0.4,0.6v0.8C41.3,69.2,41,69.5,40.6,69.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_560_",
    className: "st2",
    d: "M40.7,69.5c0,0-0.1,0-0.1,0l-0.2,0c-0.2,0-0.4-0.3-0.4-0.5v-1.8c0-0.2,0.1-0.3,0.2-0.3 c0.1-0.1,0.2,0,0.4,0l0.4,0.2c0.2,0.1,0.4,0.5,0.4,0.7v0.8c0,0.3-0.1,0.6-0.3,0.7C41,69.5,40.8,69.5,40.7,69.5z M40.3,67 C40.3,67,40.3,67,40.3,67c-0.1,0-0.1,0.1-0.1,0.2V69c0,0.1,0.1,0.3,0.2,0.3l0.2,0c0.2,0,0.3,0,0.4-0.1 c0.1-0.1,0.2-0.3,0.2-0.6v-0.8c0-0.2-0.1-0.5-0.3-0.6l-0.4-0.2C40.4,67,40.3,67,40.3,67z"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_978_"
  }, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2810_",
    d: "M84.2,24L70,15.5l-45.8,27l-1,4l1.4,0.6l0.2,0.1l0.1,0.3l0.2,0.1l0-0.3l8.9,5.2c0,0,0,0.5,0,0.5l0,0 c0,0,0,0,0,0v1.6l0.1,0c0.3,0.5,0.3,1.1,0.2,1.8c-0.3,1.7-0.8,5.3-0.8,9.6c0,0,0,0.6,0,1c0,0.4,0,0.8,0.1,1.1l0,0 c0.1,0.3,0.1,0.6,0.1,1l0,1.4c0,0.2,0.1,0.3,0.3,0.2l12-6.9c0.3-0.2,0.5,0,0.5,0.3c0,0.2,0,0.5,0,0.7c0,0.8-0.1,1.6-0.4,2.4 l0,0l0,0l7.2,0.8c0,0,11.3-3.6,13.6-6.1c2.2-2.5,19.6-13.2,19.6-13.2L84.2,24z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000052789690826353782920000005701051546055969196_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2810_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_874_",
    style: {
      clipPath: "url(#XMLID_00000052789690826353782920000005701051546055969196_)"
    }
  }, _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_712_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_533_",
    className: "st3",
    d: "M71,19.2C71,19.1,71,19.1,71,19.2L71,19.2L71,19.2c-0.1,0-0.2,0-0.2,0L25.5,45.4 c-0.2,0.1-0.3,0.4-0.3,0.6l0,1.8c0,0-1.1,6.5-1.2,10.9c0,0.2,0.1,0.4,0.2,0.4c0.2,0.1,0.6,0.4,0.6,1.6V62 c0,0.2,0.1,0.2,0.2,0.2l11,6.2l4.3-7.4l10.1-13.5l18.1-10.5l4.2-2.1c0,0,6.5-4.6,6.8-4.7c0.4-0.1,2.6-4.9,2.6-4.9L71,19.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_536_",
    className: "st2",
    d: "M35.9,68.6l-11.1-6.3c-0.1,0-0.1,0-0.2-0.1c-0.1-0.1-0.1-0.2-0.1-0.3v-1.4 c0-1.2-0.3-1.4-0.5-1.5c-0.2-0.1-0.3-0.2-0.3-0.5c0.1-4.3,1.2-10.9,1.2-10.9l0-1.8c0-0.3,0.2-0.5,0.4-0.7l45.3-26.2 C70.8,19,71,19,71,19c0,0,0,0,0,0l11.1,6.3l0,0.1c-0.5,1.1-2.3,4.8-2.7,5c-0.3,0.1-5,3.4-6.8,4.7l-4.2,2.1L50.4,47.7 L40.3,61.2L35.9,68.6z M24.9,62.2L24.9,62.2l10.9,6.2l4.3-7.3l10.1-13.5l0,0l18.1-10.5l4.2-2.1c0.3-0.2,6.5-4.6,6.9-4.7 c0.3-0.1,1.7-3,2.5-4.8l-11-6.2c0,0,0,0,0,0c0,0-0.1,0-0.1,0L25.5,45.4c-0.2,0.1-0.3,0.3-0.3,0.5l0,1.8 c0,0.1-1.1,6.6-1.2,10.9c0,0.1,0,0.3,0.2,0.3c0.3,0.1,0.7,0.4,0.7,1.7V62C24.8,62.1,24.8,62.1,24.9,62.2 C24.9,62.2,24.9,62.2,24.9,62.2L24.9,62.2z"
  }))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_719_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_527_",
    className: "st4",
    d: "M74.9,33.4c1.4-1,3.2-2.2,4-2.8l1.1-4.2l-11-6.3l0,0L25.5,45.3 c-0.2,0.1-0.3,0.4-0.3,0.6l11.1,6.2L74.9,33.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_529_",
    className: "st2",
    d: "M36.2,52.3L25,46l0-0.1c0-0.3,0.2-0.5,0.4-0.7L69,20.1l0,0l11.1,6.3L79,30.7l0,0 c-0.9,0.6-2.7,1.8-4,2.8l0,0L36.2,52.3z M25.2,45.9l11,6.2l38.6-18.7c1.3-0.9,3.1-2.2,4-2.8l1.1-4.1L69,20.3L25.5,45.4 C25.4,45.5,25.3,45.7,25.2,45.9z"
  }))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_386_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_365_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_517_",
    className: "st2",
    d: "M36.2,54c0,0-1.1,6.5-1.2,10.9c0,0.2,0.1,0.4,0.2,0.4c0.2,0.1,0.6,0.4,0.6,1.6v1.4 c0,0.2,0.1,0.3,0.3,0.2L81.9,42c0.2-0.1,0.3-0.4,0.3-0.6V25.6c0-0.2-0.1-0.3-0.3-0.2L36.5,51.6c-0.2,0.1-0.3,0.4-0.3,0.6 L36.2,54z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_523_",
    className: "st2",
    d: "M36,68.6c0,0-0.1,0-0.1,0c-0.1-0.1-0.1-0.2-0.1-0.3v-1.4c0-1.2-0.3-1.4-0.5-1.5 c-0.2-0.1-0.3-0.2-0.3-0.5c0.1-4.3,1.2-10.7,1.2-10.9l0-1.8c0-0.3,0.2-0.5,0.4-0.7l45.3-26.2c0.1-0.1,0.2-0.1,0.3,0 c0.1,0.1,0.1,0.2,0.1,0.3v15.9c0,0.2-0.2,0.5-0.4,0.7L36.2,68.6C36.1,68.6,36,68.6,36,68.6z M82,25.5 C82,25.5,82,25.5,82,25.5L36.6,51.7c-0.2,0.1-0.3,0.3-0.3,0.5l0,1.8c0,0.1-1.1,6.6-1.2,10.9c0,0.1,0,0.3,0.2,0.3 c0.3,0.1,0.7,0.4,0.7,1.7v1.4c0,0.1,0,0.1,0,0.1c0,0,0.1,0,0.1,0L81.8,42c0.2-0.1,0.3-0.3,0.3-0.5V25.6 C82.1,25.5,82.1,25.5,82,25.5C82,25.5,82,25.5,82,25.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_341_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_519_",
    className: "st3",
    d: "M36.7,67.4C36.7,67.4,36.6,67.4,36.7,67.4c-0.1-0.1-0.2-0.1-0.2-0.2v-0.8 c0-1.2-0.3-1.4-0.5-1.5c-0.2-0.1-0.3-0.2-0.3-0.5c0.1-4.3,1.2-10.9,1.2-10.9l0-1c0-0.3,0.2-0.5,0.4-0.7l43.9-25.3 c0.1,0,0.2-0.1,0.2,0c0.1,0,0.1,0.1,0.1,0.2v14.5c0,0.2-0.1,0.4-0.3,0.4L36.8,67.3C36.8,67.4,36.7,67.4,36.7,67.4z  M81.3,26.7C81.3,26.7,81.3,26.7,81.3,26.7L37.4,52.1c-0.2,0.1-0.3,0.3-0.3,0.5l0,1c0,0.1-1.1,6.6-1.2,10.9 c0,0.1,0,0.3,0.2,0.3c0.3,0.1,0.7,0.4,0.7,1.7v0.7l44.5-25.7c0.1,0,0.2-0.2,0.2-0.3L81.3,26.7 C81.3,26.7,81.3,26.7,81.3,26.7C81.3,26.7,81.3,26.7,81.3,26.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_398_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_510_",
    className: "st2",
    d: "M39.1,66.2l-0.7,0.4c-0.1,0-0.1,0-0.1-0.1v-0.2c0-0.1,0.1-0.2,0.1-0.2l0.7-0.4 c0.1,0,0.1,0,0.1,0.1v0.2C39.2,66,39.1,66.1,39.1,66.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_512_",
    className: "st3",
    d: "M38.3,66.7C38.3,66.7,38.3,66.7,38.3,66.7c-0.1-0.1-0.2-0.1-0.2-0.2v-0.2 c0-0.1,0.1-0.3,0.2-0.3l0.7-0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.2v0.2c0,0.1-0.1,0.3-0.2,0.3L38.3,66.7 C38.4,66.7,38.3,66.7,38.3,66.7z M39.1,65.8l-0.7,0.4c0,0-0.1,0.1-0.1,0.1v0.2l0.7-0.4c0,0,0.1-0.1,0.1-0.1V65.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_397_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_484_",
    className: "st2",
    d: "M78.3,43.5l-0.7,0.4c-0.1,0-0.1,0-0.1-0.1v-0.2c0-0.1,0.1-0.2,0.1-0.2l0.7-0.4 c0.1,0,0.1,0,0.1,0.1v0.2C78.4,43.3,78.4,43.4,78.3,43.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_506_",
    className: "st3",
    d: "M77.6,44C77.6,44,77.5,44,77.6,44c-0.1-0.1-0.2-0.1-0.2-0.2v-0.2 c0-0.1,0.1-0.3,0.2-0.3l0.7-0.4c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0.1,0.1,0.2v0.2c0,0.1-0.1,0.3-0.2,0.3L77.6,44 C77.6,44,77.6,44,77.6,44z M78.3,43.1l-0.7,0.4c0,0-0.1,0.1-0.1,0.1v0.2l0.7-0.4c0,0,0.1-0.1,0.1-0.1V43.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_402_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_505_",
    x: 51,
    y: 46.6,
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -14.5098 39.1888)",
    className: "st3",
    width: 29.7,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_403_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_503_",
    x: 48.4,
    y: 55.4,
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -20.9654 32.7434)",
    className: "st3",
    width: 4.4,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_404_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_502_",
    x: 45.9,
    y: 57.4,
    transform: "matrix(0.8658 -0.5004 0.5004 0.8658 -22.4532 31.3048)",
    className: "st3",
    width: 2.5,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_424_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_500_",
    x: 36.7,
    y: 63.1,
    transform: "matrix(0.8659 -0.5003 0.5003 0.8659 -26.5949 27.1523)",
    className: "st3",
    width: 1.3,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_425_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_499_",
    x: 38.3,
    y: 62.3,
    transform: "matrix(0.8658 -0.5003 0.5003 0.8658 -26.0611 27.6912)",
    className: "st3",
    width: 0.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_426_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_497_",
    x: 44.9,
    y: 58.5,
    transform: "matrix(0.8658 -0.5004 0.5004 0.8658 -23.2558 30.5026)",
    className: "st3",
    width: 0.6,
    height: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_427_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_496_",
    x: 79.2,
    y: 38.6,
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -8.689 45.0123)",
    className: "st3",
    width: 0.9,
    height: 0.2
  })))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_359_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_495_",
    x: 30.9,
    y: 42.1,
    transform: "matrix(0.4909 -0.8712 0.8712 0.4909 -26.4398 51.6833)",
    className: "st2",
    width: 0.2,
    height: 12.7
  }))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_870_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_492_",
    x: 73.6,
    y: 17.4,
    transform: "matrix(0.4909 -0.8712 0.8712 0.4909 16.8157 76.3528)",
    className: "st2",
    width: 0.2,
    height: 12.7
  }))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_873_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_491_",
    x: 32.1,
    y: 41.4,
    transform: "matrix(0.4909 -0.8712 0.8712 0.4909 -25.244 52.3348)",
    className: "st2",
    width: 0.2,
    height: 12.7
  }))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_713_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_489_",
    x: 30.4,
    y: 46,
    transform: "matrix(0.4909 -0.8712 0.8712 0.4909 -30.0817 53.2049)",
    className: "st2",
    width: 0.2,
    height: 12.7
  }))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_714_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_488_",
    x: 29.9,
    y: 49.2,
    transform: "matrix(0.4909 -0.8712 0.8712 0.4909 -33.173 54.4022)",
    className: "st2",
    width: 0.2,
    height: 12.7
  }))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_810_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_486_",
    x: 29.9,
    y: 56.1,
    transform: "matrix(0.4909 -0.8712 0.8712 0.4909 -39.1333 57.8852)",
    className: "st2",
    width: 0.2,
    height: 12.7
  }))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_840_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_485_",
    x: 30.1,
    y: 58.1,
    transform: "matrix(0.4909 -0.8712 0.8712 0.4909 -40.7869 59.1889)",
    className: "st2",
    width: 0.2,
    height: 12.7
  }))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_348_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_907_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_478_",
    className: "st4",
    d: "M73.4,20.3c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3 C73.3,19.9,73.4,20.1,73.4,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_479_",
    className: "st2",
    d: "M73.1,20.7L73.1,20.7c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4h0 c0.2,0,0.4,0.2,0.4,0.4v0C73.5,20.5,73.3,20.7,73.1,20.7z M73.1,20c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2h0 c0.1,0,0.2-0.1,0.2-0.2C73.3,20.1,73.2,20,73.1,20L73.1,20z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_906_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_473_",
    className: "st4",
    d: "M79.9,24c0,0.2-0.2,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 S79.9,23.8,79.9,24z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_474_",
    className: "st2",
    d: "M79.5,24.5L79.5,24.5c-0.1,0-0.2,0-0.3-0.1c-0.1-0.1-0.1-0.2-0.1-0.3 c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h0c0.2,0,0.4,0.2,0.4,0.4c0,0.1,0,0.2-0.1,0.3C79.8,24.4,79.6,24.5,79.5,24.5z  M79.5,23.8c-0.1,0-0.1,0-0.2,0.1c0,0-0.1,0.1-0.1,0.2c0,0.1,0,0.1,0.1,0.2c0,0,0.1,0.1,0.2,0.1c0,0,0,0,0,0 c0.1,0,0.1,0,0.2-0.1c0,0,0.1-0.1,0.1-0.2C79.8,23.9,79.7,23.8,79.5,23.8C79.5,23.8,79.5,23.8,79.5,23.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_905_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_467_",
    className: "st4",
    d: "M76.6,22.1c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.1-0.3,0.3-0.3 C76.4,21.8,76.6,21.9,76.6,22.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_468_",
    className: "st2",
    d: "M76.2,22.5c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0.1,0,0.2,0,0.3,0.1 c0.1,0.1,0.1,0.2,0.1,0.3C76.7,22.3,76.5,22.5,76.2,22.5z M76.2,21.9c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2 c0.1,0,0.2-0.1,0.2-0.2v0c0-0.1,0-0.1-0.1-0.2C76.3,21.9,76.3,21.9,76.2,21.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_904_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_461_",
    className: "st4",
    d: "M75,21.2c0,0.2-0.2,0.3-0.3,0.3s-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 C74.8,20.8,75,21,75,21.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_463_",
    className: "st2",
    d: "M74.6,21.6c-0.2,0-0.4-0.2-0.4-0.4c0-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2-0.1,0.3-0.1h0 c0.1,0,0.2,0,0.3,0.1c0.1,0.1,0.1,0.2,0.1,0.3C75.1,21.4,74.9,21.6,74.6,21.6z M74.6,20.9c-0.1,0-0.1,0-0.2,0.1 c0,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.2c0.1,0,0.2-0.1,0.2-0.2v0c0-0.1,0-0.1-0.1-0.2C74.8,21,74.7,20.9,74.6,20.9 L74.6,20.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_903_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_452_",
    className: "st4",
    d: "M78.2,23c0,0.2-0.2,0.3-0.3,0.3s-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 C78.1,22.7,78.2,22.8,78.2,23z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_457_",
    className: "st2",
    d: "M77.9,23.4L77.9,23.4c-0.2,0-0.4-0.2-0.4-0.4c0-0.2,0.2-0.4,0.4-0.4c0,0,0,0,0,0 c0.2,0,0.4,0.2,0.4,0.4v0C78.3,23.3,78.1,23.4,77.9,23.4z M77.9,22.8c-0.1,0-0.2,0.1-0.2,0.2c0,0.1,0.1,0.2,0.2,0.2h0 c0.1,0,0.2-0.1,0.2-0.2C78.1,22.9,78,22.8,77.9,22.8C77.9,22.8,77.9,22.8,77.9,22.8z"
  }))))))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_876_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3979_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3978_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_453_",
    className: "st2",
    d: "M43.8,42.8c-1.5,0-2.8-0.7-2.8-1.6s1.2-1.6,2.8-1.6c1.5,0,2.8,0.7,2.8,1.6 S45.3,42.8,43.8,42.8z M43.8,39.7c-1.4,0-2.6,0.6-2.6,1.4c0,0.8,1.2,1.4,2.6,1.4c1.4,0,2.6-0.6,2.6-1.4 C46.4,40.4,45.2,39.7,43.8,39.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3977_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3976_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_446_",
    className: "st3",
    d: "M45.7,41c0,0.6-0.8,1.1-1.8,1.1c-1,0-1.8-0.5-1.8-1.1s0.8-1.3,1.8-1.3 C44.8,39.7,45.7,40.4,45.7,41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_447_",
    className: "st2",
    d: "M43.8,42.2c-1.1,0-1.9-0.5-1.9-1.2c0-0.6,0.9-1.4,1.9-1.4c1.1,0,1.9,0.8,1.9,1.4 C45.8,41.7,44.9,42.2,43.8,42.2z M43.8,39.8c-0.9,0-1.7,0.7-1.7,1.2c0,0.5,0.8,1,1.7,1c0.9,0,1.7-0.4,1.7-1 C45.6,40.5,44.8,39.8,43.8,39.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3975_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3980_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_442_",
    className: "st2",
    d: "M43.9,39.8l0.3,0.9c0.1,0.1,0.3,0.6,0.5,1.3c0.5-0.2,0.9-0.5,0.9-0.9 C45.6,40.5,44.8,39.8,43.9,39.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_443_",
    className: "st2",
    d: "M44.7,42.1l0-0.1c-0.2-0.6-0.4-1.2-0.5-1.2l0,0l-0.4-1l0.1,0c1,0,1.8,0.8,1.8,1.4 c0,0.4-0.3,0.8-1,1L44.7,42.1z M44.3,40.6c0.1,0.1,0.3,0.6,0.5,1.2c0.4-0.1,0.7-0.4,0.7-0.8c0-0.5-0.7-1.1-1.5-1.2 L44.3,40.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3981_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_438_",
    className: "st2",
    d: "M42,41c0,0.2,0,0.2,0.1,0.4c0.4-1,1.1-1.1,1.1-1.1l0.1-0.4C42.5,40,42,40.6,42,41z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_439_",
    className: "st2",
    d: "M42.2,41.6l-0.1-0.1c-0.1-0.1-0.1-0.2-0.1-0.4c0,0,0,0,0-0.1c0-0.5,0.6-1.1,1.3-1.3 l0.1,0l-0.1,0.6l-0.1,0c0,0-0.6,0.2-1,1.1L42.2,41.6z M43.1,40c-0.6,0.2-1,0.7-1,1c0,0,0,0.1,0,0.1c0,0,0,0.1,0,0.1 c0.4-0.7,0.8-0.9,1-1L43.1,40z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3973_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "XMLID_434_",
    className: "st4",
    cx: 43.8,
    cy: 40.4,
    rx: 1.1,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_435_",
    className: "st2",
    d: "M43.8,41.1c-0.7,0-1.2-0.3-1.2-0.7c0-0.4,0.5-0.7,1.2-0.7c0.7,0,1.2,0.3,1.2,0.7 C45,40.8,44.5,41.1,43.8,41.1z M43.8,39.8c-0.6,0-1,0.2-1,0.5c0,0.3,0.5,0.5,1,0.5c0.6,0,1-0.2,1-0.5 C44.8,40.1,44.4,39.8,43.8,39.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3940_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3942_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3946_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_429_",
    className: "st3",
    d: "M44.1,26.2C44.1,26.2,44.1,26.2,44.1,26.2C44.1,26.2,44.1,26.2,44.1,26.2L44.1,26.2 c-0.6,0-1.2,0.2-1.8,0.6c-1.8,1.1-3.3,3.8-3.4,5.9c0,1.1,0.4,2,1,2.3l0,0c0,0,1.3,0.8,1.3,0.8c0.4,0.4,0.6,0.9,0.8,1.5 l0.1,0.3c0,0,0,0.1,0,0.1l0,0c0,0,0.4,0.9,1.8,1.1c0,0,0.1,0,0.1-0.1l1.6-8.4c0.1-0.4,0.2-0.8,0.2-1.2l0.1-0.7l1-0.6 C47.2,27.7,46,26.2,44.1,26.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_430_",
    className: "st2",
    d: "M44.1,38.9C44.1,38.9,44,38.9,44.1,38.9c-1.6-0.2-2-1.2-2-1.2l0,0c0,0,0-0.1,0-0.1 L42,37.3c-0.1-0.6-0.4-1.1-0.7-1.4c-0.1-0.1-1.3-0.7-1.3-0.7l0,0c-0.7-0.4-1.1-1.3-1-2.4c0-2.2,1.6-4.8,3.4-6 c0.6-0.4,1.1-0.5,1.6-0.6v0l0.1,0l0.1,0l0,0.1l0-0.1c0,0,0,0,0,0c1.9,0,3.1,1.5,3.1,1.6l0.1,0.1l-1.1,0.7l-0.1,0.7 c0,0.4-0.1,0.8-0.2,1.2l-1.6,8.4C44.3,38.9,44.2,38.9,44.1,38.9z M42.4,37.7c0.1,0.1,0.5,0.8,1.7,1l1.6-8.3 c0.1-0.4,0.2-0.8,0.2-1.2l0.2-0.8l0.9-0.6c-0.3-0.3-1.3-1.4-2.8-1.4c0,0,0,0,0,0l-0.1,0c-0.5,0-1.1,0.2-1.6,0.5 c-1.8,1.1-3.3,3.7-3.3,5.8c0,1.1,0.3,1.8,0.9,2.2l0,0l0,0c0,0,1.3,0.7,1.3,0.7l0,0c0.4,0.4,0.7,0.9,0.8,1.6L42.4,37.7 C42.3,37.6,42.3,37.6,42.4,37.7L42.4,37.7L42.4,37.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3945_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_420_",
    className: "st4",
    d: "M44,32.7l1.4-4.2c0,0-0.5-1.5-2.9-1.9c0,0-0.1,0-0.1,0.1c-1.4,0.9-2.6,2.5-3.1,4.2 C39.3,31,40.3,32.3,44,32.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_421_",
    className: "st2",
    d: "M44.1,32.9l-0.1,0c-3.7-0.4-4.8-1.7-4.8-1.8l0-0.1l0-0.1c0.5-1.8,1.8-3.5,3.1-4.3 c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0l0,0l0,0c2.4,0.4,3,1.9,3,2l0,0L44.1,32.9z M39.4,31c0.2,0.2,1.4,1.3,4.5,1.6l1.3-4 c-0.1-0.2-0.7-1.4-2.7-1.7c0,0,0,0,0,0c0,0,0,0-0.1,0C41.2,27.7,40,29.3,39.4,31z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3943_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_416_",
    className: "st2",
    d: "M47.8,29.7c0-2.3-1.6-3.2-3.6-1.9c-1.8,1.1-3.3,3.8-3.4,5.9c0,1.3,0.5,2.2,1.3,2.5 c0.9,0.3,1.5,1,1.8,2.1l0.1,0.3c0,0.2,0.2,0.2,0.3,0.1l0,0c0.2-0.1,0.3-0.3,0.3-0.5l0-0.3c0.2-1.4,0.8-2.9,1.7-4.2 C47.3,32.5,47.8,31,47.8,29.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_417_",
    className: "st2",
    d: "M44.2,38.9c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.2-0.2l-0.1-0.3c-0.2-1-0.8-1.7-1.7-2 c-0.9-0.3-1.5-1.3-1.4-2.6c0-2.2,1.6-4.8,3.4-6c1-0.6,2-0.8,2.7-0.3c0.7,0.4,1.1,1.3,1.1,2.4c0,1.3-0.5,2.8-1.4,4.1 c-0.8,1.2-1.4,2.7-1.7,4.1l0,0.3c0,0.2-0.2,0.5-0.4,0.6C44.3,38.9,44.2,38.9,44.2,38.9z M45.9,27.4c-0.5,0-1.1,0.2-1.6,0.5 c-1.8,1.1-3.3,3.7-3.3,5.8c0,1.2,0.4,2.1,1.2,2.4c1,0.3,1.6,1.1,1.8,2.2l0.1,0.3c0,0,0,0.1,0,0.1c0,0,0.1,0,0.1,0 c0.1-0.1,0.3-0.3,0.3-0.4l0-0.3c0.2-1.5,0.9-3,1.7-4.2c0.9-1.2,1.4-2.7,1.4-4c0-1-0.3-1.8-1-2.2 C46.5,27.4,46.2,27.4,45.9,27.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3974_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_181_",
    className: "st2",
    d: "M45.7,32.5c-0.8,1.3-2,2.1-2.8,1.6c-0.8-0.4-0.8-1.9,0-3.2c0.8-1.3,2-2.1,2.8-1.6 S46.5,31.2,45.7,32.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_413_",
    className: "st3",
    d: "M43.4,34.4c-0.2,0-0.4,0-0.6-0.1c-0.4-0.2-0.6-0.7-0.6-1.4c0-0.6,0.2-1.3,0.6-2 c0.4-0.7,0.9-1.2,1.4-1.5c0.6-0.3,1.1-0.4,1.5-0.1c0.8,0.5,0.9,2,0,3.4l0,0c-0.4,0.7-0.9,1.2-1.4,1.5 C44.1,34.3,43.7,34.4,43.4,34.4z M45.2,29.3c-0.2,0-0.5,0.1-0.8,0.3c-0.5,0.3-1,0.8-1.3,1.4c-0.4,0.6-0.6,1.3-0.6,1.9 c0,0.6,0.2,1,0.5,1.2c0.3,0.2,0.8,0.1,1.3-0.1c0.5-0.3,1-0.8,1.3-1.4c0.7-1.3,0.8-2.6,0-3C45.5,29.4,45.4,29.3,45.2,29.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_3999_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_410_",
    className: "st3",
    d: "M44.7,32.5l-0.1-0.3l-0.6,0.3L44,32.9l-0.5,0.3l0.6-2.4l0.7-0.4l0.6,1.8L44.7,32.5z  M44.5,31.7l-0.1-0.3c0-0.1,0-0.2-0.1-0.3c0-0.1,0-0.2-0.1-0.2c0,0.1,0,0.1,0,0.3c0,0.1-0.1,0.4-0.1,0.7L44.5,31.7z"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1775_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_893_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_894_"
  }, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2808_",
    d: "M84.9,64.3l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6l-1.9-1.2 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C84.6,63.9,84.6,64.2,84.9,64.3z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000012465675660781025770000006950614157352039060_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2808_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_974_",
    style: {
      clipPath: "url(#XMLID_00000012465675660781025770000006950614157352039060_)"
    }
  }, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2809_",
    d: "M88.4,66.7l-5.8-3.4c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9l-6.6,3.8C89.2,67,88.7,66.9,88.4,66.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000141416484291658967700000017901673977144838837_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2809_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_976_",
    style: {
      clipPath: "url(#XMLID_00000141416484291658967700000017901673977144838837_)"
    }
  }, _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1746_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_299_",
    x: 82.8,
    y: 61.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.0568 52.1823)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1745_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_298_",
    x: 83.2,
    y: 61.8,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -19.1121 52.4271)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1744_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_261_",
    x: 83.6,
    y: 62.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.1779 52.6338)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1743_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_260_",
    x: 84,
    y: 62.3,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -19.2299 52.8821)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1742_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_259_",
    x: 84.3,
    y: 62.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.3029 53.076)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1741_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_257_",
    x: 84.7,
    y: 62.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.3573 53.3102)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1740_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_256_",
    x: 85.1,
    y: 63,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.424 53.5274)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1739_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_255_",
    x: 85.5,
    y: 63.2,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -19.476 53.7759)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1738_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_253_",
    x: 85.9,
    y: 63.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.5418 53.9822)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1737_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_252_",
    x: 86.3,
    y: 63.6,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -19.5959 54.2307)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1736_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_250_",
    x: 86.7,
    y: 63.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.6617 54.437)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1735_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_249_",
    x: 87.1,
    y: 64.1,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -19.7137 54.6856)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1734_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_248_",
    x: 87.5,
    y: 64.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.7867 54.8792)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1733_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_229_",
    x: 87.9,
    y: 64.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.8411 55.1135)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1732_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_228_",
    x: 88.2,
    y: 64.8,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.9078 55.3307)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1731_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_226_",
    x: 88.7,
    y: 65,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -19.9598 55.5794)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1730_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_225_",
    x: 89,
    y: 65.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -20.0256 55.7855)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1729_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_223_",
    x: 81.2,
    y: 60.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -18.8271 51.2669)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1728_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_222_",
    x: 81.6,
    y: 61,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -18.8824 51.5115)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1727_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_221_",
    x: 82,
    y: 61.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -18.9482 51.7183)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1726_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_218_",
    x: 82.4,
    y: 61.4,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -19.0002 51.9664)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1725_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_217_",
    x: 82.8,
    y: 61.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.066 52.1732)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1747_"
  }, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2806_",
    d: "M81,63.9l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6l-1.9-1.2 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C80.7,63.4,80.7,63.8,81,63.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000089551307654015120500000004483149203562341798_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2806_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1749_",
    style: {
      clipPath: "url(#XMLID_00000089551307654015120500000004483149203562341798_)"
    }
  }, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2807_",
    d: "M84.5,66.2l-5.8-3.4c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9l-6.6,3.8C85.3,66.5,84.8,66.4,84.5,66.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000128450513456301385050000015399709313376157117_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2807_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1751_",
    style: {
      clipPath: "url(#XMLID_00000128450513456301385050000015399709313376157117_)"
    }
  }, _g266 || (_g266 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1773_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_215_",
    x: 78.9,
    y: 61.2,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -19.3448 50.1833)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1772_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_214_",
    x: 79.3,
    y: 61.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.3981 50.4075)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1771_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_213_",
    x: 79.7,
    y: 61.6,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -19.4659 50.6349)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1770_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_209_",
    x: 80.1,
    y: 61.8,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.5159 50.8623)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1769_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_207_",
    x: 80.4,
    y: 62.1,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -19.5909 51.0771)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1768_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_206_",
    x: 80.8,
    y: 62.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.6442 51.3011)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1767_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_205_",
    x: 81.2,
    y: 62.5,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -19.712 51.5287)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g273 || (_g273 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1766_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_203_",
    x: 81.6,
    y: 62.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.762 51.7559)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g274 || (_g274 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1765_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_202_",
    x: 82,
    y: 63,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -19.8298 51.9836)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g275 || (_g275 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1764_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_200_",
    x: 82.4,
    y: 63.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.8819 52.2107)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g276 || (_g276 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1763_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_199_",
    x: 82.8,
    y: 63.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.9486 52.4279)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g277 || (_g277 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1762_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_197_",
    x: 83.2,
    y: 63.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.9997 52.6655)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g278 || (_g278 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1761_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_196_",
    x: 83.6,
    y: 63.9,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -20.0747 52.8807)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g279 || (_g279 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1760_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_194_",
    x: 84,
    y: 64.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -20.128 53.1044)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g280 || (_g280 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1759_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_193_",
    x: 84.3,
    y: 64.3,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -20.1958 53.3322)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g281 || (_g281 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1758_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_191_",
    x: 84.8,
    y: 64.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -20.2458 53.5592)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g282 || (_g282 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1757_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_190_",
    x: 85.1,
    y: 64.8,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -20.3136 53.7872)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g283 || (_g283 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1756_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_188_",
    x: 77.3,
    y: 60.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.114 49.2577)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g284 || (_g284 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1755_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_187_",
    x: 77.7,
    y: 60.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.1684 49.492)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g285 || (_g285 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1754_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_185_",
    x: 78.1,
    y: 60.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.2351 49.7091)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g286 || (_g286 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1753_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_184_",
    x: 78.5,
    y: 60.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -19.2862 49.9469)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g287 || (_g287 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1752_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_182_",
    x: 78.9,
    y: 61.2,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -19.354 50.1741)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), _g288 || (_g288 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_896_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_898_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_900_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_909_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_175_",
    className: "st3",
    d: "M85.1,61l-4.2,0c0,0-0.1,0-0.1,0.1v1.1l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L85.1,61C85.2,61.1,85.2,61,85.1,61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_176_",
    className: "st2",
    d: "M83,63.8c-0.3,0-0.5-0.1-0.7-0.2L81,62.9c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2v-1.1 c0-0.1,0.1-0.2,0.2-0.2l4.2,0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2v1.4h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8 C83.5,63.8,83.2,63.8,83,63.8z M80.9,61.2l0,1.3c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8 c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0v-1.1L80.9,61.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_908_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2805_",
    className: "st2",
    d: "M85.1,61l-1.9,0v2.7c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L85.1,61 C85.2,61.1,85.2,61,85.1,61z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_902_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_141_",
    className: "st4",
    d: "M85,61.4l-1.4,0.8c-0.3,0.2-0.8,0.2-1.2,0l-1.3-0.7c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C85.3,60.9,85.3,61.2,85,61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_162_",
    className: "st2",
    d: "M83,62.4c-0.3,0-0.5-0.1-0.7-0.2L81,61.5c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4l-1.4,0.8 C83.5,62.4,83.2,62.4,83,62.4z M83,59.9c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3L83.6,60C83.4,59.9,83.2,59.9,83,59.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_901_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_148_",
    x: 84.4,
    y: 62,
    className: "st3",
    width: 0.3,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_899_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_147_",
    x: 82.4,
    y: 62.9,
    className: "st2",
    width: 0.3,
    height: 0.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_897_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_144_",
    x: 82.9,
    y: 59.6,
    transform: "matrix(0.5035 -0.864 0.864 0.5035 -11.5287 102.0108)",
    className: "st2",
    width: 0.3,
    height: 2.9
  })))), _g289 || (_g289 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1028_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1032_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1036_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_134_",
    className: "st3",
    d: "M89.2,60.6l-4.2,0c0,0-0.1,0-0.1,0.1l0,2.1l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L89.2,60.6C89.3,60.7,89.2,60.6,89.2,60.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_137_",
    className: "st2",
    d: "M87.1,64.4c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2v-2.1 c0-0.1,0.1-0.2,0.2-0.2l4.2,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2v2.4h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8 C87.5,64.4,87.3,64.4,87.1,64.4z M85,60.8l0,2.3c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8 c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0v-2.1L85,60.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1035_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2804_",
    className: "st2",
    d: "M89.2,60.6l-1.9,0v3.7c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0 L89.2,60.6C89.3,60.7,89.2,60.6,89.2,60.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1034_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_123_",
    className: "st4",
    d: "M89,61l-1.4,0.8c-0.3,0.2-0.8,0.2-1.2,0L85.1,61c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C89.3,60.5,89.4,60.8,89,61z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_129_",
    className: "st2",
    d: "M87.1,62c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4l-1.4,0.8 C87.5,62,87.3,62,87.1,62z M87,59.5c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7 c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3l-1.3-0.7C87.5,59.6,87.2,59.5,87,59.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1033_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_124_",
    x: 88.6,
    y: 61.5,
    className: "st3",
    width: 0.3,
    height: 1.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1031_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_43_",
    className: "st4",
    points: "87.3,60.5 86.7,60.1 86.5,60.3 86.2,60.4 86.8,60.8 86.5,60.9 87.7,61 87.6,60.3  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_117_",
    className: "st2",
    d: "M87.8,61.1L86.2,61l0.4-0.2L86,60.4l0.7-0.4l0.6,0.3l0.4-0.2L87.8,61.1z M86.8,60.8 l0.7,0.1l-0.1-0.4l-0.2,0.1l-0.6-0.3l-0.3,0.2l0.6,0.3L86.8,60.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1030_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_115_",
    x: 86.5,
    y: 62.5,
    className: "st2",
    width: 0.3,
    height: 1.8
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5100_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4938_"
  }, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2802_",
    d: "M59.5,69.6l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6l-1.9-1.2 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C59.3,69.1,59.3,69.4,59.5,69.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000137110867081508089750000004357209009519199416_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2802_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4940_",
    style: {
      clipPath: "url(#XMLID_00000137110867081508089750000004357209009519199416_)"
    }
  }, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2803_",
    d: "M63.1,71.9l-5.8-3.4c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9l-6.6,3.8C63.9,72.2,63.3,72.1,63.1,71.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000096027636650109694370000003960131659263678870_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2803_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4942_",
    style: {
      clipPath: "url(#XMLID_00000096027636650109694370000003960131659263678870_)"
    }
  }, _g290 || (_g290 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4964_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_114_",
    x: 57.4,
    y: 66.8,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.0512 40.2211)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g291 || (_g291 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4963_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_113_",
    x: 57.9,
    y: 67.1,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.1082 40.4639)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g292 || (_g292 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4962_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_112_",
    x: 58.2,
    y: 67.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.1723 40.6725)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g293 || (_g293 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4961_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_111_",
    x: 58.6,
    y: 67.5,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.226 40.9189)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g294 || (_g294 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4960_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_110_",
    x: 59,
    y: 67.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.2973 41.1147)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g295 || (_g295 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4959_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_109_",
    x: 59.4,
    y: 68,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.3517 41.3489)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g296 || (_g296 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4958_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_108_",
    x: 59.8,
    y: 68.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.4184 41.5662)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g297 || (_g297 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4957_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_107_",
    x: 60.2,
    y: 68.4,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.4721 41.8127)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g298 || (_g298 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4956_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_104_",
    x: 60.6,
    y: 68.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.5362 42.021)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g299 || (_g299 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4955_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_102_",
    x: 61,
    y: 68.9,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.592 42.2675)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g300 || (_g300 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4954_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_101_",
    x: 61.4,
    y: 69.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.6561 42.4757)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g301 || (_g301 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4953_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_100_",
    x: 61.8,
    y: 69.3,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.7098 42.7224)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g302 || (_g302 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4952_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_99_",
    x: 62.1,
    y: 69.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.7811 42.9179)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g303 || (_g303 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4951_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_98_",
    x: 62.5,
    y: 69.8,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.838 43.1613)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g304 || (_g304 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4950_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_97_",
    x: 62.9,
    y: 70,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.9021 43.3694)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g305 || (_g305 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4949_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_96_",
    x: 63.3,
    y: 70.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.9533 43.607)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g306 || (_g306 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4948_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_95_",
    x: 63.7,
    y: 70.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -26.02 43.8242)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g307 || (_g307 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4947_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_94_",
    x: 55.8,
    y: 66,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.8215 39.3056)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g308 || (_g308 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4946_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_93_",
    x: 56.3,
    y: 66.2,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -24.8785 39.5483)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g309 || (_g309 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4945_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_92_",
    x: 56.6,
    y: 66.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.9426 39.757)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g310 || (_g310 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4944_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_91_",
    x: 57,
    y: 66.6,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -24.9962 40.0033)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g311 || (_g311 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4943_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_90_",
    x: 57.4,
    y: 66.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.0603 40.2119)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4965_"
  }, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2800_",
    d: "M55.6,68.2l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6l-1.9-1.2 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C55.4,67.8,55.4,68.1,55.6,68.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000008146092979573528050000008356093648838882711_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2800_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4967_",
    style: {
      clipPath: "url(#XMLID_00000008146092979573528050000008356093648838882711_)"
    }
  }, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2801_",
    d: "M59.2,70.6l-5.8-3.4c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9l-6.6,3.8C60,70.9,59.5,70.7,59.2,70.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000170273824931472548330000011985153329747054753_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2801_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4969_",
    style: {
      clipPath: "url(#XMLID_00000170273824931472548330000011985153329747054753_)"
    }
  }, _g312 || (_g312 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4991_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_89_",
    x: 53.6,
    y: 65.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.885 38.111)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g313 || (_g313 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4990_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_88_",
    x: 54,
    y: 65.7,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -24.942 38.3535)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g314 || (_g314 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4989_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_87_",
    x: 54.4,
    y: 65.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.0061 38.5625)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g315 || (_g315 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4988_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_86_",
    x: 54.8,
    y: 66.1,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.0599 38.8084)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g316 || (_g316 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4987_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_85_",
    x: 55.1,
    y: 66.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.1311 39.0047)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g317 || (_g317 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4986_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_84_",
    x: 55.5,
    y: 66.6,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.1881 39.2474)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g318 || (_g318 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4985_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_83_",
    x: 55.9,
    y: 66.8,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.2522 39.4561)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g319 || (_g319 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4984_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_82_",
    x: 56.3,
    y: 67,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.306 39.7022)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g320 || (_g320 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4983_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_81_",
    x: 56.7,
    y: 67.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.37 39.911)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g321 || (_g321 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4982_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_80_",
    x: 57.1,
    y: 67.5,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.4258 40.1571)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g322 || (_g322 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4981_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_79_",
    x: 57.5,
    y: 67.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.4899 40.3657)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g323 || (_g323 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4980_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_78_",
    x: 57.9,
    y: 67.9,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.5436 40.612)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g324 || (_g324 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4979_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_77_",
    x: 58.3,
    y: 68.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.6149 40.8079)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g325 || (_g325 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4978_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_76_",
    x: 58.7,
    y: 68.4,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.6719 41.0509)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g326 || (_g326 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4977_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_75_",
    x: 59,
    y: 68.6,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.736 41.2593)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g327 || (_g327 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4976_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_74_",
    x: 59.5,
    y: 68.9,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -25.7897 41.5058)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g328 || (_g328 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4975_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_71_",
    x: 59.8,
    y: 69.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -25.8537 41.7142)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g329 || (_g329 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4974_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_70_",
    x: 52,
    y: 64.6,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -24.6579 37.2036)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g330 || (_g330 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4973_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_69_",
    x: 52.4,
    y: 64.8,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.7096 37.4298)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g331 || (_g331 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4972_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_68_",
    x: 52.8,
    y: 65,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -24.779 37.6551)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g332 || (_g332 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4971_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_67_",
    x: 53.2,
    y: 65.3,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -24.8301 37.8928)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g333 || (_g333 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4970_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_66_",
    x: 53.6,
    y: 65.5,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.8942 38.1018)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4992_"
  }, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2798_",
    d: "M60.3,66.2l2.1,1.2c0.4,0.2,0.9,0.2,1.2,0l1.8-1.2c0.2-0.1,0.2-0.4,0-0.6l-1.9-1.2 c-0.4-0.2-0.8-0.2-1.2,0l-2,1.1C60.1,65.7,60.1,66.1,60.3,66.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000098923255287738116550000012033698106819913371_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2798_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4994_",
    style: {
      clipPath: "url(#XMLID_00000098923255287738116550000012033698106819913371_)"
    }
  }, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2799_",
    d: "M63.9,68.5l-5.8-3.4c-0.2-0.1-0.2-0.4,0-0.6l7.3-4.2c0.3-0.1,0.6-0.1,0.8,0l5.8,3.4 c0.2,0.1,0.4,0.6,0,0.9l-6.6,3.8C64.7,68.8,64.1,68.7,63.9,68.5z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "XMLID_00000043419661216815526910000003293054518048016530_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#XMLID_2799_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4996_",
    style: {
      clipPath: "url(#XMLID_00000043419661216815526910000003293054518048016530_)"
    }
  }, _g334 || (_g334 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5018_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_65_",
    x: 58.2,
    y: 63.5,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -23.2595 40.1629)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g335 || (_g335 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5017_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_64_",
    x: 58.6,
    y: 63.7,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -23.3139 40.3972)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g336 || (_g336 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5016_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_63_",
    x: 59,
    y: 63.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.3783 40.6059)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g337 || (_g337 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5015_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_62_",
    x: 59.4,
    y: 64.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.4294 40.8435)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g338 || (_g338 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5014_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_61_",
    x: 59.8,
    y: 64.4,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.5033 41.0481)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g339 || (_g339 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5013_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_60_",
    x: 60.2,
    y: 64.6,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -23.56 41.291)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g340 || (_g340 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5012_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_59_",
    x: 60.5,
    y: 64.8,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.6244 41.4995)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g341 || (_g341 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5011_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_58_",
    x: 61,
    y: 65,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -23.6778 41.746)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g342 || (_g342 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5010_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_57_",
    x: 61.3,
    y: 65.3,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.7422 41.9544)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g343 || (_g343 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5009_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_56_",
    x: 61.8,
    y: 65.5,
    transform: "matrix(0.8664 -0.4994 0.4994 0.8664 -23.7937 42.1854)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g344 || (_g344 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5008_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_55_",
    x: 62.1,
    y: 65.7,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.8621 42.4091)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g345 || (_g345 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5007_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_54_",
    x: 62.5,
    y: 65.9,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.9132 42.6467)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g346 || (_g346 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5006_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_53_",
    x: 62.9,
    y: 66.2,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -23.9894 42.8603)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g347 || (_g347 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5005_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_52_",
    x: 63.3,
    y: 66.4,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -24.0437 43.0947)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g348 || (_g348 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5004_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_51_",
    x: 63.7,
    y: 66.6,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -24.1105 43.3118)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g349 || (_g349 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5003_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_50_",
    x: 64.1,
    y: 66.8,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -24.1616 43.5495)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g350 || (_g350 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5002_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_49_",
    x: 64.5,
    y: 67.1,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -24.226 43.7576)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g351 || (_g351 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5001_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_48_",
    x: 56.6,
    y: 62.6,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -23.0298 39.2473)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g352 || (_g352 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5000_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_47_",
    x: 57,
    y: 62.8,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -23.0842 39.4816)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g353 || (_g353 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4999_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_46_",
    x: 57.4,
    y: 63,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.1486 39.6904)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g354 || (_g354 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4998_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_45_",
    x: 57.8,
    y: 63.2,
    transform: "matrix(0.8663 -0.4995 0.4995 0.8663 -23.1996 39.9281)",
    className: "st2",
    width: 10.4,
    height: 0.2
  }))), _g355 || (_g355 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4997_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_44_",
    x: 58.2,
    y: 63.5,
    transform: "matrix(0.8663 -0.4996 0.4996 0.8663 -23.2687 40.1537)",
    className: "st2",
    width: 10.4,
    height: 0.2
  })))))), _g356 || (_g356 = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_493_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4807_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4810_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4814_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_39_",
    className: "st3",
    d: "M63.6,58.7l-4.1,0c-0.1,0-0.1,0.1-0.1,0.1V65l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0v-6.4C63.8,58.8,63.7,58.7,63.6,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_40_",
    className: "st2",
    d: "M61.6,66.7c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2v-6.2 c0-0.1,0.1-0.3,0.3-0.3l4.1,0c0.2,0,0.3,0.1,0.3,0.3v6.5h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8C62,66.6,61.8,66.7,61.6,66.7z  M63.6,58.7l0,0.1l-4.1,0l0,6.2l0,0.2c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2 l0-0.1h0v-6.3L63.6,58.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4813_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_297_",
    className: "st2",
    d: "M63.8,58.7l-2,0v7.8c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0V58.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4812_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_34_",
    className: "st4",
    d: "M63.6,59.1l-1.4,0.8c-0.3,0.2-0.8,0.2-1.2,0l-1.3-0.7c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C63.8,58.6,63.9,58.9,63.6,59.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st2",
    d: "M61.6,60.1c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4L62.2,60 C62,60.1,61.8,60.1,61.6,60.1z M61.5,57.6c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3l-1.3-0.7C62,57.6,61.7,57.6,61.5,57.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4811_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_35_",
    x: 63.1,
    y: 61,
    className: "st3",
    width: 0.3,
    height: 4.4
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4809_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_29_",
    className: "st4",
    points: "61.8,58.6 61.2,58.2 61,58.4 60.7,58.5 61.3,58.8 61,59 62.2,59.1 62.1,58.4  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    className: "st2",
    d: "M62.3,59.2l-1.7-0.1l0.4-0.2l-0.6-0.3l0.7-0.4l0.6,0.3l0.4-0.2L62.3,59.2z M61.4,58.9 l0.7,0.1L62,58.6l-0.2,0.1l-0.6-0.3l-0.3,0.2l0.6,0.3L61.4,58.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4808_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_30_",
    x: 61,
    y: 62,
    className: "st2",
    width: 0.3,
    height: 4.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4159_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4161_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4162_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4165_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    className: "st3",
    d: "M60.3,64.5l-4.2,0c0,0-0.1,0-0.1,0.1l0,2.1l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L60.3,64.5C60.4,64.6,60.3,64.5,60.3,64.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_26_",
    className: "st2",
    d: "M58.2,68.3c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2v-2.1 c0-0.1,0.1-0.2,0.2-0.2l4.2,0c0.1,0,0.2,0.1,0.2,0.2v2.4h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8C58.6,68.3,58.4,68.3,58.2,68.3z  M56.1,64.7l0,2.3c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0v-2.1 L56.1,64.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4164_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_264_",
    className: "st2",
    d: "M60.3,64.5l-1.9,0v3.7c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0 L60.3,64.5C60.4,64.6,60.3,64.5,60.3,64.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4163_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    className: "st4",
    d: "M60.2,64.9l-1.4,0.8c-0.3,0.2-0.8,0.2-1.2,0l-1.3-0.7c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C60.4,64.4,60.5,64.7,60.2,64.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    className: "st2",
    d: "M58.2,65.9c-0.3,0-0.5-0.1-0.7-0.2L56.2,65c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4l-1.4,0.8 C58.6,65.9,58.4,65.9,58.2,65.9z M58.1,63.4c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3l-1.3-0.7 C58.6,63.4,58.3,63.4,58.1,63.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4172_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_21_",
    x: 59.7,
    y: 65.4,
    className: "st3",
    width: 0.3,
    height: 1.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4174_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_20_",
    x: 57.6,
    y: 66.4,
    className: "st2",
    width: 0.3,
    height: 1.8
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4790_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_19_",
    x: 58.1,
    y: 63,
    transform: "matrix(0.5035 -0.864 0.864 0.5035 -26.8541 82.3056)",
    className: "st2",
    width: 0.3,
    height: 2.9
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4791_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4793_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4797_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    className: "st3",
    d: "M63.7,66.8l-4.2,0c0,0-0.1,0-0.1,0.1V68l0,0.2c0,0.1,0.1,0.3,0.3,0.4l1.3,0.7 c0.4,0.2,0.9,0.2,1.2,0l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L63.7,66.8C63.8,66.9,63.8,66.8,63.7,66.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    className: "st2",
    d: "M61.7,69.6c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.3-0.3-0.4-0.5l0-0.2v-1.1 c0-0.1,0.1-0.2,0.2-0.2l4.2,0c0,0,0,0,0,0c0.1,0,0.1,0,0.2,0.1c0,0,0.1,0.1,0.1,0.2v1.4h0c0,0.1-0.1,0.2-0.3,0.3l-1.4,0.8 C62.1,69.6,61.9,69.6,61.7,69.6z M59.6,67l0,1.3c0,0.1,0.1,0.2,0.2,0.3l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8 c0.1,0,0.1-0.1,0.1-0.2l0-0.1h0V67L59.6,67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4796_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_246_",
    className: "st2",
    d: "M63.7,66.8l-1.9,0v2.7c0.1,0,0.3,0,0.4-0.1l1.4-0.8c0.1-0.1,0.2-0.2,0.2-0.3h0L63.7,66.8 C63.8,66.9,63.8,66.8,63.7,66.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4795_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    className: "st4",
    d: "M63.6,67.2L62.2,68c-0.3,0.2-0.8,0.2-1.2,0l-1.3-0.7c-0.4-0.2-0.4-0.5-0.1-0.7l1.4-0.8 c0.3-0.2,0.8-0.2,1.2,0l1.3,0.7C63.9,66.7,63.9,67,63.6,67.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    className: "st2",
    d: "M61.7,68.2c-0.3,0-0.5-0.1-0.7-0.2l-1.3-0.7c-0.2-0.1-0.4-0.3-0.4-0.5 c0-0.2,0.1-0.3,0.3-0.4l1.4-0.8c0.3-0.2,0.9-0.2,1.3,0l1.3,0.7c0.2,0.1,0.4,0.3,0.4,0.5c0,0.2-0.1,0.3-0.3,0.4l-1.4,0.8 C62.1,68.2,61.9,68.2,61.7,68.2z M61.6,65.7c-0.2,0-0.3,0-0.5,0.1l-1.4,0.8c-0.1,0-0.1,0.1-0.1,0.2c0,0.1,0.1,0.2,0.2,0.3 l1.3,0.7c0.3,0.2,0.8,0.2,1.1,0l1.4-0.8c0.1,0,0.1-0.1,0.1-0.2c0-0.1-0.1-0.2-0.2-0.3l-1.3-0.7C62,65.8,61.8,65.7,61.6,65.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4794_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_10_",
    x: 63.2,
    y: 67.7,
    className: "st3",
    width: 0.3,
    height: 0.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4792_"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_3_",
    className: "st4",
    points: "61.9,66.7 61.3,66.3 61.1,66.5 60.8,66.6 61.4,66.9 61.1,67.1 62.3,67.2 62.2,66.5  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st2",
    d: "M62.4,67.3l-1.7-0.1l0.4-0.2l-0.6-0.3l0.7-0.4l0.6,0.3l0.4-0.2L62.4,67.3z M61.4,67l0.7,0.1 l-0.1-0.4l-0.2,0.1l-0.6-0.3L61,66.6l0.6,0.3L61.4,67z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4827_"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_4_",
    x: 61.1,
    y: 68.7,
    className: "st2",
    width: 0.3,
    height: 0.8
  }))))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M70.2,44l0-0.1c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1-0.1,0.1-0.1c0-0.1-0.1,0-0.2,0c-0.1,0-0.2,0.1-0.3,0 c0-0.1,0-0.2,0.1-0.3c0.1,0,0.2-0.1,0.2-0.1l0,0.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0-0.1,0.1-0.1,0.1c0,0,0.1,0,0.2,0 c0.1,0,0.3-0.1,0.3,0c0,0.1,0.1,0.2-0.2,0.3C70.3,44,70.2,44,70.2,44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M63.6,42.9l-0.7-0.2c-0.1,0-0.3,0.1-0.2,0.2l1,1.8c0.1,0.1,0,0.3-0.1,0.4l-2.7,1.6c-0.3,0.1-0.6,0.1-0.6,0.1 L59,46.5c-0.1,0-0.2,0-0.2,0.1l-0.2,0.5c0,0.1,0,0.1,0.1,0.2l1.3,0.3c0.5,0.1,0.8,0.1,1.1-0.1l3.1-1.8c0.4-0.2,0.6-0.7,0.4-1.1 L63.6,42.9C63.7,43,63.7,42.9,63.6,42.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M58.4,50.4c-0.1-0.2,0-0.4,0.2-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0.1c-0.1,0-0.1,0-0.2,0.1 c-0.1,0.1-0.1,0.2-0.1,0.3c0.1,0.1,0.2,0.2,0.3,0.1c0.1,0,0.1-0.1,0.1-0.1l0.1,0.1c0,0-0.1,0.1-0.2,0.1 C58.7,50.6,58.5,50.5,58.4,50.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M59.2,49.5C59,49.6,58.9,49.8,59,50c0.1,0.2,0.3,0.2,0.5,0.1c0.2-0.1,0.2-0.3,0.1-0.5 C59.6,49.5,59.4,49.4,59.2,49.5z M59.5,50c-0.1,0.1-0.2,0-0.3-0.1c-0.1-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2,0,0.3,0.1 C59.6,49.8,59.6,49.9,59.5,50z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "60.4,49.6 59.9,49.4 60.1,49.7 60,49.8 59.7,49.3 59.8,49.2 60.3,49.4 60.1,49 60.2,49 60.5,49.5 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "60.7,49.4 60.4,48.8 60.8,48.6 60.9,48.7 60.6,48.9 60.7,49 60.9,48.9 60.9,49 60.7,49.1 60.8,49.2  61.1,49.1 61.1,49.2 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M61.1,48.8c-0.1-0.2,0-0.4,0.2-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0.1c-0.1,0-0.1,0-0.2,0.1 c-0.1,0.1-0.1,0.2-0.1,0.3c0.1,0.1,0.2,0.2,0.3,0.1c0.1,0,0.1-0.1,0.1-0.1l0.1,0.1c0,0-0.1,0.1-0.2,0.1C61.4,49,61.2,49,61.1,48.8z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "61.9,48.1 62.2,48.6 62.1,48.6 61.8,48.2 61.7,48.3 61.6,48.2 62.1,47.9 62.1,48 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M62.5,47.7l-0.1,0.1l0.1,0.7l0.1-0.1l0-0.2l0.2-0.1l0.1,0.1l0.1-0.1L62.5,47.7z M62.5,48.1l0-0.2l0.2,0.1 L62.5,48.1z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "63.7,47.7 63.4,47.4 63.4,47.7 63.1,47.6 63.2,48 63.1,48 62.9,47.4 63,47.4 63.3,47.6 63.3,47.2  63.4,47.2 63.8,47.7 "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M63.9,46.8c-0.2,0.1-0.2,0.3-0.1,0.5c0.1,0.2,0.3,0.2,0.5,0.1c0.2-0.1,0.2-0.3,0.1-0.5 C64.3,46.8,64.1,46.7,63.9,46.8z M64.2,47.3c-0.1,0.1-0.2,0-0.3-0.1c-0.1-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2,0,0.3,0.1 C64.4,47.1,64.4,47.2,64.2,47.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M64.7,47.1l0-0.1c0.1,0,0.1,0,0.2-0.1c0.1,0,0.1-0.1,0.1-0.1c0-0.1-0.1,0-0.2,0c-0.1,0-0.2,0.1-0.3,0 c0-0.1,0-0.2,0.1-0.3c0.1,0,0.2-0.1,0.2-0.1l0,0.1c-0.1,0-0.2,0-0.2,0.1c-0.1,0-0.1,0.1-0.1,0.1c0,0,0.1,0,0.2,0 c0.1,0,0.3-0.1,0.3,0c0,0.1,0.1,0.2-0.2,0.3C64.9,47.1,64.8,47.1,64.7,47.1z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "66.1,46.3 65.6,46.1 65.8,46.5 65.7,46.6 65.4,46 65.5,46 66,46.2 65.8,45.8 65.9,45.8 66.2,46.3 "
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "66.4,46.2 66.1,45.6 66.5,45.4 66.5,45.5 66.2,45.6 66.3,45.8 66.5,45.6 66.6,45.7 66.4,45.9 66.5,46  66.8,45.8 66.8,45.9 "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M66.8,45.6c-0.1-0.2,0-0.4,0.2-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0.1c-0.1,0-0.1,0-0.2,0.1 c-0.1,0.1-0.2,0.2-0.1,0.3c0.1,0.1,0.2,0.2,0.3,0.1c0,0,0.1,0,0.1-0.1l-0.1-0.1l-0.1,0l0-0.1l0.2-0.1l0.1,0.2c0,0-0.1,0.1-0.2,0.2 C67.1,45.8,66.9,45.8,66.8,45.6z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M67.6,44.7c-0.2,0.1-0.2,0.3-0.1,0.5c0.1,0.2,0.3,0.2,0.5,0.1c0.2-0.1,0.2-0.3,0.1-0.5 C68,44.7,67.8,44.6,67.6,44.7z M67.9,45.2c-0.1,0.1-0.2,0-0.3-0.1c-0.1-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2,0,0.3,0.1 C68.1,45,68,45.1,67.9,45.2z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "67.5,44.8 67.4,44.7 67.6,44.5 67.6,44.6 "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M68.3,44.7c-0.1-0.2,0-0.4,0.2-0.5c0.1,0,0.1-0.1,0.2-0.1l0,0.1c-0.1,0-0.1,0-0.2,0.1 c-0.1,0.1-0.1,0.2-0.1,0.3c0.1,0.1,0.2,0.2,0.3,0.1c0.1,0,0.1-0.1,0.1-0.1l0.1,0.1c0,0-0.1,0.1-0.2,0.1C68.6,45,68.4,44.9,68.3,44.7 z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68.9,
    y: 44,
    transform: "matrix(0.8688 -0.4952 0.4952 0.8688 -12.8953 39.9804)",
    className: "st35",
    width: 0.1,
    height: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M69.4,43.7c-0.2,0.1-0.2,0.3-0.1,0.5c0.1,0.2,0.3,0.2,0.5,0.1c0.2-0.1,0.2-0.3,0.1-0.5 C69.8,43.7,69.6,43.6,69.4,43.7z M69.7,44.2c-0.1,0.1-0.2,0-0.3-0.1c-0.1-0.1,0-0.2,0.1-0.3c0.1-0.1,0.2,0,0.3,0.1 C69.8,44,69.8,44.1,69.7,44.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M66.9,39.1c0-0.1-0.1-0.1-0.2,0l-0.5,0.3c-0.1,0.1-0.1,0.1-0.1,0.2l1.7,3c0,0.1,0,0.3-0.2,0.2L63,41.6 c-0.3-0.1-0.6-0.1-1,0.1c0,0-3.2,1.8-3.2,1.8c-0.3,0.2-0.5,0.4-0.7,0.9l-1.4,4.5c-0.1,0.2-0.2,0.3-0.4,0.2L51.8,48 c-0.3-0.1-0.6,0-1,0.2c-0.3,0.2-0.5,0.4-0.6,0.7l-1.5,5.4c0,0.1,0.1,0.2,0.2,0.1l0.5-0.3c0.1-0.1,0.2-0.1,0.2-0.3 c0,0,0.1-0.5,0.3-1.2c0,0,0-0.1,0.2-0.2l4.1-2.3c0.1-0.1,0.1-0.2,0-0.3l-0.7-0.2c0,0-0.1,0-0.1,0l-3,1.7c-0.1,0-0.1,0-0.1-0.1 c0.2-0.9,0.6-2.3,0.6-2.3c0.1-0.2,0.2-0.3,0.4-0.2l4.7,1.2c0.5,0.1,1.2,0,1.6-0.9l1.4-4.4c0-0.1,0.1-0.3,0.2-0.4l3.1-1.8 c0.1,0,0.2-0.1,0.3,0l4.4,1.1c0.5,0.1,0.8,0.1,1.1-0.1c0.2-0.1,0.4-0.3,0.4-0.5c0.1-0.2,0.1-0.4-0.1-0.7L66.9,39.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M54.6,46.2c-0.1,0-0.2-0.2,0-0.3l0.6-0.4c0,0,0.1,0,0.1,0l1.9,0.5c0.1,0,0.1,0.1,0.1,0.2l-0.2,0.5 c0,0.1-0.1,0.1-0.2,0.1L54.6,46.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69,42.5c0-0.1,0-0.2,0-0.3c0,0,0-0.1,0.1-0.1c0,0,0-0.1,0.1-0.1c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0 c0.1,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0.1c0,0,0,0,0,0.1c0,0.1,0,0.1,0,0.2c0,0,0,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1 c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0C69.2,42.6,69.1,42.6,69,42.5C69.1,42.5,69.1,42.5,69,42.5z M69.5,42.5 c0.2-0.1,0.2-0.3,0.1-0.4c-0.1-0.1-0.2-0.2-0.4-0.1c-0.2,0.1-0.2,0.3-0.1,0.4C69.2,42.6,69.4,42.6,69.5,42.5z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M69.6,42.4C69.6,42.4,69.6,42.4,69.6,42.4C69.6,42.4,69.6,42.4,69.6,42.4C69.5,42.4,69.5,42.4,69.6,42.4 C69.5,42.4,69.5,42.4,69.6,42.4c-0.1,0-0.1,0-0.1,0c0,0,0,0,0,0c0,0,0,0-0.1,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0 c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0c0,0,0,0,0,0c-0.1-0.1-0.1-0.2-0.2-0.3c0,0,0,0,0,0c0,0,0,0,0.1,0c0,0,0,0,0,0c0,0,0,0,0.1,0 c0,0,0.1,0,0.1,0c0,0,0,0.1,0,0.1c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0C69.5,42.3,69.5,42.3,69.6,42.4 C69.5,42.3,69.5,42.3,69.6,42.4C69.5,42.3,69.6,42.4,69.6,42.4C69.6,42.4,69.6,42.4,69.6,42.4z M69.3,42.3 C69.3,42.3,69.3,42.3,69.3,42.3C69.3,42.3,69.3,42.3,69.3,42.3C69.4,42.3,69.4,42.3,69.3,42.3c0.1-0.1,0.1-0.1,0.1-0.1c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0c0,0,0,0,0,0C69.3,42.3,69.3,42.3,69.3,42.3C69.3,42.3,69.3,42.3,69.3,42.3z"
  })), _g357 || (_g357 = /*#__PURE__*/React.createElement("g", null)), _g358 || (_g358 = /*#__PURE__*/React.createElement("g", null)), _g359 || (_g359 = /*#__PURE__*/React.createElement("g", null)), _g360 || (_g360 = /*#__PURE__*/React.createElement("g", null)), _g361 || (_g361 = /*#__PURE__*/React.createElement("g", null)), _g362 || (_g362 = /*#__PURE__*/React.createElement("g", null)), _g363 || (_g363 = /*#__PURE__*/React.createElement("g", null)), _g364 || (_g364 = /*#__PURE__*/React.createElement("g", null)), _g365 || (_g365 = /*#__PURE__*/React.createElement("g", null)), _g366 || (_g366 = /*#__PURE__*/React.createElement("g", null)), _g367 || (_g367 = /*#__PURE__*/React.createElement("g", null)), _g368 || (_g368 = /*#__PURE__*/React.createElement("g", null)), _g369 || (_g369 = /*#__PURE__*/React.createElement("g", null)), _g370 || (_g370 = /*#__PURE__*/React.createElement("g", null)), _g371 || (_g371 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataTruckSvg);
export default __webpack_public_path__ + "static/media/dataTruckSvg.9a708ee0485d9ada0aec3d63beb133b5.svg";
export { ForwardRef as ReactComponent };